//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  citext: any;
  date: any;
  float8: any;
  numeric: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
}


export interface BbbJoinLink {
  id: EntireFieldWrapper<Scalars['String']>;
  url: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface BooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface IntComparisonExp {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
}

export interface MessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface Session {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface StringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface UserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** columns and relationships of "assignment_attendee_type" */
export interface AssignmentAttendeeType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  value: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface AssignmentAttendeeTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface AssignmentAttendeeTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_attendee_type". All fields are combined with a logical 'AND'. */
export interface AssignmentAttendeeTypeBoolExp {
  _and?: Maybe<Array<AssignmentAttendeeTypeBoolExp>>;
  _not?: Maybe<AssignmentAttendeeTypeBoolExp>;
  _or?: Maybe<Array<AssignmentAttendeeTypeBoolExp>>;
  assignments?: Maybe<AssignmentsBoolExp>;
  comment?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
}

export const enum AssignmentAttendeeTypeEnum {
  CLASS = 'CLASS',
  USER = 'USER'
};

/** Boolean expression to compare columns of type "assignment_attendee_type_enum". All fields are combined with logical 'AND'. */
export interface AssignmentAttendeeTypeEnumComparisonExp {
  _eq?: Maybe<AssignmentAttendeeTypeEnum>;
  _in?: Maybe<Array<AssignmentAttendeeTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<AssignmentAttendeeTypeEnum>;
  _nin?: Maybe<Array<AssignmentAttendeeTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_attendee_type". */
export interface AssignmentAttendeeTypeOrderBy {
  assignments_aggregate?: Maybe<AssignmentsAggregateOrderBy>;
  comment?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
}

/** select columns of table "assignment_attendee_type" */
export const enum AssignmentAttendeeTypeSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_book_chapter" */
export interface AssignmentBookChapter {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<BookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_book_chapter" */
export interface AssignmentBookChapterAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentBookChapterMaxOrderBy>;
  min?: Maybe<AssignmentBookChapterMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_book_chapter". All fields are combined with a logical 'AND'. */
export interface AssignmentBookChapterBoolExp {
  _and?: Maybe<Array<AssignmentBookChapterBoolExp>>;
  _not?: Maybe<AssignmentBookChapterBoolExp>;
  _or?: Maybe<Array<AssignmentBookChapterBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  book_chapter?: Maybe<BookChaptersBoolExp>;
  book_chapter_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_book_chapter" */
export interface AssignmentBookChapterMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_book_chapter" */
export interface AssignmentBookChapterMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignment_book_chapter". */
export interface AssignmentBookChapterOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  book_chapter?: Maybe<BookChaptersOrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "assignment_book_chapter" */
export const enum AssignmentBookChapterSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_discussion" */
export interface AssignmentDiscussion {
  /** An array relationship */
  assignment_discussion_contents: EntireFieldWrapper<Array<AssignmentDiscussionContent>>;
  /** An array relationship */
  assignment_discussion_subscriptions: EntireFieldWrapper<Array<AssignmentDiscussionSubscription>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion" */
export interface AssignmentDiscussionAssignmentDiscussionContentsArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionContentOrderBy>>;
  where?: Maybe<AssignmentDiscussionContentBoolExp>;
}


/** columns and relationships of "assignment_discussion" */
export interface AssignmentDiscussionAssignmentDiscussionSubscriptionsArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion" */
export interface AssignmentDiscussionAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentDiscussionMaxOrderBy>;
  min?: Maybe<AssignmentDiscussionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion" */
export interface AssignmentDiscussionArrRelInsertInput {
  data: Array<AssignmentDiscussionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AssignmentDiscussionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion". All fields are combined with a logical 'AND'. */
export interface AssignmentDiscussionBoolExp {
  _and?: Maybe<Array<AssignmentDiscussionBoolExp>>;
  _not?: Maybe<AssignmentDiscussionBoolExp>;
  _or?: Maybe<Array<AssignmentDiscussionBoolExp>>;
  assignment_discussion_contents?: Maybe<AssignmentDiscussionContentBoolExp>;
  assignment_discussion_subscriptions?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion" */
export const enum AssignmentDiscussionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_PKEY = 'assignment_discussion_pkey'
};

/** columns and relationships of "assignment_discussion_content" */
export interface AssignmentDiscussionContent {
  /** An object relationship */
  assignment_discussion: EntireFieldWrapper<AssignmentDiscussion>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  replay_to?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<Students>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<Teachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_discussion_content" */
export interface AssignmentDiscussionContentAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentDiscussionContentMaxOrderBy>;
  min?: Maybe<AssignmentDiscussionContentMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_content" */
export interface AssignmentDiscussionContentArrRelInsertInput {
  data: Array<AssignmentDiscussionContentInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AssignmentDiscussionContentOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_content". All fields are combined with a logical 'AND'. */
export interface AssignmentDiscussionContentBoolExp {
  _and?: Maybe<Array<AssignmentDiscussionContentBoolExp>>;
  _not?: Maybe<AssignmentDiscussionContentBoolExp>;
  _or?: Maybe<Array<AssignmentDiscussionContentBoolExp>>;
  assignment_discussion?: Maybe<AssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<UuidComparisonExp>;
  content?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  parent_id?: Maybe<UuidComparisonExp>;
  replay_to?: Maybe<AssignmentDiscussionContentBoolExp>;
  student?: Maybe<StudentsBoolExp>;
  teacher?: Maybe<TeachersBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_content" */
export const enum AssignmentDiscussionContentConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_CONTENT_PKEY = 'assignment_discussion_content_pkey'
};

/** input type for inserting data into table "assignment_discussion_content" */
export interface AssignmentDiscussionContentInsertInput {
  assignment_discussion?: Maybe<AssignmentDiscussionObjRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  replay_to?: Maybe<AssignmentDiscussionContentObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_content" */
export interface AssignmentDiscussionContentMaxOrderBy {
  assignment_discussion_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  parent_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_discussion_content" */
export interface AssignmentDiscussionContentMinOrderBy {
  assignment_discussion_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  parent_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_discussion_content" */
export interface AssignmentDiscussionContentMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentDiscussionContent>>;
}

/** input type for inserting object relation for remote table "assignment_discussion_content" */
export interface AssignmentDiscussionContentObjRelInsertInput {
  data: AssignmentDiscussionContentInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AssignmentDiscussionContentOnConflict>;
}

/** on conflict condition type for table "assignment_discussion_content" */
export interface AssignmentDiscussionContentOnConflict {
  constraint: AssignmentDiscussionContentConstraint;
  update_columns?: Array<AssignmentDiscussionContentUpdateColumn>;
  where?: Maybe<AssignmentDiscussionContentBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_content". */
export interface AssignmentDiscussionContentOrderBy {
  assignment_discussion?: Maybe<AssignmentDiscussionOrderBy>;
  assignment_discussion_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  parent_id?: Maybe<OrderBy>;
  replay_to?: Maybe<AssignmentDiscussionContentOrderBy>;
  student?: Maybe<StudentsOrderBy>;
  teacher?: Maybe<TeachersOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_discussion_content */
export interface AssignmentDiscussionContentPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_content" */
export const enum AssignmentDiscussionContentSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_content" */
export interface AssignmentDiscussionContentSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  parent_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_content" */
export const enum AssignmentDiscussionContentUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for inserting data into table "assignment_discussion" */
export interface AssignmentDiscussionInsertInput {
  assignment_discussion_contents?: Maybe<AssignmentDiscussionContentArrRelInsertInput>;
  assignment_discussion_subscriptions?: Maybe<AssignmentDiscussionSubscriptionArrRelInsertInput>;
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion" */
export interface AssignmentDiscussionMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_discussion" */
export interface AssignmentDiscussionMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_discussion" */
export interface AssignmentDiscussionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentDiscussion>>;
}

/** input type for inserting object relation for remote table "assignment_discussion" */
export interface AssignmentDiscussionObjRelInsertInput {
  data: AssignmentDiscussionInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AssignmentDiscussionOnConflict>;
}

/** on conflict condition type for table "assignment_discussion" */
export interface AssignmentDiscussionOnConflict {
  constraint: AssignmentDiscussionConstraint;
  update_columns?: Array<AssignmentDiscussionUpdateColumn>;
  where?: Maybe<AssignmentDiscussionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion". */
export interface AssignmentDiscussionOrderBy {
  assignment_discussion_contents_aggregate?: Maybe<AssignmentDiscussionContentAggregateOrderBy>;
  assignment_discussion_subscriptions_aggregate?: Maybe<AssignmentDiscussionSubscriptionAggregateOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_discussion */
export interface AssignmentDiscussionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion" */
export const enum AssignmentDiscussionSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion" */
export interface AssignmentDiscussionSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscription {
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<AssignmentDiscussion>>;
  assignment_discussion_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_notification_enabled: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionOrderBy>>;
  where?: Maybe<AssignmentDiscussionBoolExp>;
}

/** order by aggregate values of table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentDiscussionSubscriptionMaxOrderBy>;
  min?: Maybe<AssignmentDiscussionSubscriptionMinOrderBy>;
}

/** input type for inserting array relation for remote table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionArrRelInsertInput {
  data: Array<AssignmentDiscussionSubscriptionInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AssignmentDiscussionSubscriptionOnConflict>;
}

/** Boolean expression to filter rows from the table "assignment_discussion_subscription". All fields are combined with a logical 'AND'. */
export interface AssignmentDiscussionSubscriptionBoolExp {
  _and?: Maybe<Array<AssignmentDiscussionSubscriptionBoolExp>>;
  _not?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
  _or?: Maybe<Array<AssignmentDiscussionSubscriptionBoolExp>>;
  assignment_discussion?: Maybe<AssignmentDiscussionBoolExp>;
  assignment_discussion_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_notification_enabled?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_discussion_subscription" */
export const enum AssignmentDiscussionSubscriptionConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_DISCUSSION_SUBSCRIPTION_PKEY = 'assignment_discussion_subscription_pkey'
};

/** input type for inserting data into table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionInsertInput {
  assignment_discussion?: Maybe<AssignmentDiscussionArrRelInsertInput>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionMaxOrderBy {
  assignment_discussion_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionMinOrderBy {
  assignment_discussion_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentDiscussionSubscription>>;
}

/** on conflict condition type for table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionOnConflict {
  constraint: AssignmentDiscussionSubscriptionConstraint;
  update_columns?: Array<AssignmentDiscussionSubscriptionUpdateColumn>;
  where?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
}

/** Ordering options when selecting data from "assignment_discussion_subscription". */
export interface AssignmentDiscussionSubscriptionOrderBy {
  assignment_discussion_aggregate?: Maybe<AssignmentDiscussionAggregateOrderBy>;
  assignment_discussion_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_notification_enabled?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_discussion_subscription */
export interface AssignmentDiscussionSubscriptionPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_discussion_subscription" */
export const enum AssignmentDiscussionSubscriptionSelectColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_discussion_subscription" */
export interface AssignmentDiscussionSubscriptionSetInput {
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_discussion_subscription" */
export const enum AssignmentDiscussionSubscriptionUpdateColumn {
  /** column name */
  ASSIGNMENT_DISCUSSION_ID = 'assignment_discussion_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_NOTIFICATION_ENABLED = 'is_notification_enabled',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** update columns of table "assignment_discussion" */
export const enum AssignmentDiscussionUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_files" */
export interface AssignmentFiles {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_files" */
export interface AssignmentFilesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentFilesMaxOrderBy>;
  min?: Maybe<AssignmentFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_files". All fields are combined with a logical 'AND'. */
export interface AssignmentFilesBoolExp {
  _and?: Maybe<Array<AssignmentFilesBoolExp>>;
  _not?: Maybe<AssignmentFilesBoolExp>;
  _or?: Maybe<Array<AssignmentFilesBoolExp>>;
  assignment_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  hash?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** input type for inserting data into table "assignment_files" */
export interface AssignmentFilesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_files" */
export interface AssignmentFilesMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_files" */
export interface AssignmentFilesMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_files" */
export interface AssignmentFilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentFiles>>;
}

/** Ordering options when selecting data from "assignment_files". */
export interface AssignmentFilesOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "assignment_files" */
export const enum AssignmentFilesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Possible values for assisgment grade weights.
 *
 *
 * columns and relationships of "assignment_grade_weights"
 */
export interface AssignmentGradeWeights {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  value: EntireFieldWrapper<Scalars['numeric']>;
}

/** aggregated selection of "assignment_grade_weights" */
export interface AssignmentGradeWeightsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AssignmentGradeWeights>>;
}

/** aggregate fields of "assignment_grade_weights" */
export interface AssignmentGradeWeightsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<AssignmentGradeWeightsVarianceFields>>;
}


/** aggregate fields of "assignment_grade_weights" */
export interface AssignmentGradeWeightsAggregateFieldsCountArgs {
  columns?: Maybe<Array<AssignmentGradeWeightsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface AssignmentGradeWeightsAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "assignment_grade_weights". All fields are combined with a logical 'AND'. */
export interface AssignmentGradeWeightsBoolExp {
  _and?: Maybe<Array<AssignmentGradeWeightsBoolExp>>;
  _not?: Maybe<AssignmentGradeWeightsBoolExp>;
  _or?: Maybe<Array<AssignmentGradeWeightsBoolExp>>;
  comment?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  value?: Maybe<NumericComparisonExp>;
}

/** aggregate max on columns */
export interface AssignmentGradeWeightsMaxFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate min on columns */
export interface AssignmentGradeWeightsMinFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** Ordering options when selecting data from "assignment_grade_weights". */
export interface AssignmentGradeWeightsOrderBy {
  comment?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
}

/** select columns of table "assignment_grade_weights" */
export const enum AssignmentGradeWeightsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  VALUE = 'value'
};

/** aggregate stddev on columns */
export interface AssignmentGradeWeightsStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface AssignmentGradeWeightsStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface AssignmentGradeWeightsStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface AssignmentGradeWeightsSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate var_pop on columns */
export interface AssignmentGradeWeightsVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface AssignmentGradeWeightsVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface AssignmentGradeWeightsVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** columns and relationships of "assignment_notes" */
export interface AssignmentNotes {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<Assignments>>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  content: EntireFieldWrapper<Scalars['String']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<Students>>;
  /** An object relationship */
  teacher?: EntireFieldWrapper<Maybe<Teachers>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "assignment_notes". All fields are combined with a logical 'AND'. */
export interface AssignmentNotesBoolExp {
  _and?: Maybe<Array<AssignmentNotesBoolExp>>;
  _not?: Maybe<AssignmentNotesBoolExp>;
  _or?: Maybe<Array<AssignmentNotesBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  content?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  teacher?: Maybe<TeachersBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_notes" */
export const enum AssignmentNotesConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_NOTES_PKEY = 'assignment_notes_pkey'
};

/** input type for inserting data into table "assignment_notes" */
export interface AssignmentNotesInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** response of any mutation on the table "assignment_notes" */
export interface AssignmentNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentNotes>>;
}

/** on conflict condition type for table "assignment_notes" */
export interface AssignmentNotesOnConflict {
  constraint: AssignmentNotesConstraint;
  update_columns?: Array<AssignmentNotesUpdateColumn>;
  where?: Maybe<AssignmentNotesBoolExp>;
}

/** Ordering options when selecting data from "assignment_notes". */
export interface AssignmentNotesOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  teacher?: Maybe<TeachersOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_notes */
export interface AssignmentNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_notes" */
export const enum AssignmentNotesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_notes" */
export interface AssignmentNotesSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_notes" */
export const enum AssignmentNotesUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_question_answers" */
export interface AssignmentQuestionAnswers {
  assignment_question_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersAggregateOrderBy {
  avg?: Maybe<AssignmentQuestionAnswersAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentQuestionAnswersMaxOrderBy>;
  min?: Maybe<AssignmentQuestionAnswersMinOrderBy>;
  stddev?: Maybe<AssignmentQuestionAnswersStddevOrderBy>;
  stddev_pop?: Maybe<AssignmentQuestionAnswersStddevPopOrderBy>;
  stddev_samp?: Maybe<AssignmentQuestionAnswersStddevSampOrderBy>;
  sum?: Maybe<AssignmentQuestionAnswersSumOrderBy>;
  var_pop?: Maybe<AssignmentQuestionAnswersVarPopOrderBy>;
  var_samp?: Maybe<AssignmentQuestionAnswersVarSampOrderBy>;
  variance?: Maybe<AssignmentQuestionAnswersVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersAvgOrderBy {
  order?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_answers". All fields are combined with a logical 'AND'. */
export interface AssignmentQuestionAnswersBoolExp {
  _and?: Maybe<Array<AssignmentQuestionAnswersBoolExp>>;
  _not?: Maybe<AssignmentQuestionAnswersBoolExp>;
  _or?: Maybe<Array<AssignmentQuestionAnswersBoolExp>>;
  assignment_question_id?: Maybe<UuidComparisonExp>;
  assignment_question_option_id?: Maybe<UuidComparisonExp>;
  content?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_correct?: Maybe<BooleanComparisonExp>;
  order?: Maybe<IntComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** input type for inserting data into table "assignment_question_answers" */
export interface AssignmentQuestionAnswersInsertInput {
  assignment_question_id?: Maybe<Scalars['uuid']>;
  assignment_question_option_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_correct?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersMaxOrderBy {
  assignment_question_id?: Maybe<OrderBy>;
  assignment_question_option_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersMinOrderBy {
  assignment_question_id?: Maybe<OrderBy>;
  assignment_question_option_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_question_answers" */
export interface AssignmentQuestionAnswersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentQuestionAnswers>>;
}

/** Ordering options when selecting data from "assignment_question_answers". */
export interface AssignmentQuestionAnswersOrderBy {
  assignment_question_id?: Maybe<OrderBy>;
  assignment_question_option_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_correct?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "assignment_question_answers" */
export const enum AssignmentQuestionAnswersSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_ID = 'assignment_question_option_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  USER_ID = 'user_id'
};

/** order by stddev() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersStddevOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersStddevPopOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersStddevSampOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersSumOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersVarPopOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersVarSampOrderBy {
  order?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "assignment_question_answers" */
export interface AssignmentQuestionAnswersVarianceOrderBy {
  order?: Maybe<OrderBy>;
}

/** columns and relationships of "assignment_question_option_relations" */
export interface AssignmentQuestionOptionRelations {
  /** An object relationship */
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: EntireFieldWrapper<Maybe<AssignmentQuestionOptions>>;
  /** An object relationship */
  assignment_question_option?: EntireFieldWrapper<Maybe<AssignmentQuestionOptions>>;
  assignment_question_option_matched_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  assignment_question_option_matching_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_question_option_relations" */
export interface AssignmentQuestionOptionRelationsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentQuestionOptionRelationsMaxOrderBy>;
  min?: Maybe<AssignmentQuestionOptionRelationsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_option_relations". All fields are combined with a logical 'AND'. */
export interface AssignmentQuestionOptionRelationsBoolExp {
  _and?: Maybe<Array<AssignmentQuestionOptionRelationsBoolExp>>;
  _not?: Maybe<AssignmentQuestionOptionRelationsBoolExp>;
  _or?: Maybe<Array<AssignmentQuestionOptionRelationsBoolExp>>;
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<AssignmentQuestionOptionsBoolExp>;
  assignment_question_option?: Maybe<AssignmentQuestionOptionsBoolExp>;
  assignment_question_option_matched_id?: Maybe<UuidComparisonExp>;
  assignment_question_option_matching_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "assignment_question_option_relations" */
export interface AssignmentQuestionOptionRelationsMaxOrderBy {
  assignment_question_option_matched_id?: Maybe<OrderBy>;
  assignment_question_option_matching_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_question_option_relations" */
export interface AssignmentQuestionOptionRelationsMinOrderBy {
  assignment_question_option_matched_id?: Maybe<OrderBy>;
  assignment_question_option_matching_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignment_question_option_relations". */
export interface AssignmentQuestionOptionRelationsOrderBy {
  assignmentQuestionOptionByAssignmentQuestionOptionMatchedId?: Maybe<AssignmentQuestionOptionsOrderBy>;
  assignment_question_option?: Maybe<AssignmentQuestionOptionsOrderBy>;
  assignment_question_option_matched_id?: Maybe<OrderBy>;
  assignment_question_option_matching_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** select columns of table "assignment_question_option_relations" */
export const enum AssignmentQuestionOptionRelationsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHED_ID = 'assignment_question_option_matched_id',
  /** column name */
  ASSIGNMENT_QUESTION_OPTION_MATCHING_ID = 'assignment_question_option_matching_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "assignment_question_options" */
export interface AssignmentQuestionOptions {
  /** An object relationship */
  assignment_question: EntireFieldWrapper<AssignmentQuestions>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<AssignmentQuestionAnswers>>;
  assignment_question_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<AssignmentQuestionOptionRelations>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  group?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_correct?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  order?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  score?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}


/** columns and relationships of "assignment_question_options" */
export interface AssignmentQuestionOptionsAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<AssignmentQuestionAnswersBoolExp>;
}


/** columns and relationships of "assignment_question_options" */
export interface AssignmentQuestionOptionsAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionRelationsBoolExp>;
}

/** order by aggregate values of table "assignment_question_options" */
export interface AssignmentQuestionOptionsAggregateOrderBy {
  avg?: Maybe<AssignmentQuestionOptionsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentQuestionOptionsMaxOrderBy>;
  min?: Maybe<AssignmentQuestionOptionsMinOrderBy>;
  stddev?: Maybe<AssignmentQuestionOptionsStddevOrderBy>;
  stddev_pop?: Maybe<AssignmentQuestionOptionsStddevPopOrderBy>;
  stddev_samp?: Maybe<AssignmentQuestionOptionsStddevSampOrderBy>;
  sum?: Maybe<AssignmentQuestionOptionsSumOrderBy>;
  var_pop?: Maybe<AssignmentQuestionOptionsVarPopOrderBy>;
  var_samp?: Maybe<AssignmentQuestionOptionsVarSampOrderBy>;
  variance?: Maybe<AssignmentQuestionOptionsVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsAvgOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_question_options". All fields are combined with a logical 'AND'. */
export interface AssignmentQuestionOptionsBoolExp {
  _and?: Maybe<Array<AssignmentQuestionOptionsBoolExp>>;
  _not?: Maybe<AssignmentQuestionOptionsBoolExp>;
  _or?: Maybe<Array<AssignmentQuestionOptionsBoolExp>>;
  assignment_question?: Maybe<AssignmentQuestionsBoolExp>;
  assignment_question_answers?: Maybe<AssignmentQuestionAnswersBoolExp>;
  assignment_question_id?: Maybe<UuidComparisonExp>;
  assignment_question_option_relations?: Maybe<AssignmentQuestionOptionRelationsBoolExp>;
  comment?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  group?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_correct?: Maybe<BooleanComparisonExp>;
  order?: Maybe<IntComparisonExp>;
  score?: Maybe<IntComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsMaxOrderBy {
  assignment_question_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  group?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsMinOrderBy {
  assignment_question_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  group?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignment_question_options". */
export interface AssignmentQuestionOptionsOrderBy {
  assignment_question?: Maybe<AssignmentQuestionsOrderBy>;
  assignment_question_answers_aggregate?: Maybe<AssignmentQuestionAnswersAggregateOrderBy>;
  assignment_question_id?: Maybe<OrderBy>;
  assignment_question_option_relations_aggregate?: Maybe<AssignmentQuestionOptionRelationsAggregateOrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  group?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_correct?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "assignment_question_options" */
export const enum AssignmentQuestionOptionsSelectColumn {
  /** column name */
  ASSIGNMENT_QUESTION_ID = 'assignment_question_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GROUP = 'group',
  /** column name */
  ID = 'id',
  /** column name */
  IS_CORRECT = 'is_correct',
  /** column name */
  ORDER = 'order',
  /** column name */
  SCORE = 'score',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsStddevOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsStddevPopOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsStddevSampOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsSumOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsVarPopOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsVarSampOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "assignment_question_options" */
export interface AssignmentQuestionOptionsVarianceOrderBy {
  group?: Maybe<OrderBy>;
  order?: Maybe<OrderBy>;
  score?: Maybe<OrderBy>;
}

export const enum AssignmentQuestionTypesEnum {
  /** quiz.fill_in_black */
  FILL_IN_BLANK = 'FILL_IN_BLANK',
  /** quiz.matching */
  MATCHING = 'MATCHING',
  /** quiz.open_question */
  OPEN_QUESTION = 'OPEN_QUESTION',
  /** quiz.pick_options */
  PICK_OPTIONS = 'PICK_OPTIONS'
};

/** Boolean expression to compare columns of type "assignment_question_types_enum". All fields are combined with logical 'AND'. */
export interface AssignmentQuestionTypesEnumComparisonExp {
  _eq?: Maybe<AssignmentQuestionTypesEnum>;
  _in?: Maybe<Array<AssignmentQuestionTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<AssignmentQuestionTypesEnum>;
  _nin?: Maybe<Array<AssignmentQuestionTypesEnum>>;
}

/** columns and relationships of "assignment_questions" */
export interface AssignmentQuestions {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<AssignmentQuestionOptions>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<AssignmentQuestionTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "assignment_questions" */
export interface AssignmentQuestionsAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionsBoolExp>;
}

/** order by aggregate values of table "assignment_questions" */
export interface AssignmentQuestionsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentQuestionsMaxOrderBy>;
  min?: Maybe<AssignmentQuestionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_questions". All fields are combined with a logical 'AND'. */
export interface AssignmentQuestionsBoolExp {
  _and?: Maybe<Array<AssignmentQuestionsBoolExp>>;
  _not?: Maybe<AssignmentQuestionsBoolExp>;
  _or?: Maybe<Array<AssignmentQuestionsBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  assignment_question_options?: Maybe<AssignmentQuestionOptionsBoolExp>;
  content?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  type?: Maybe<AssignmentQuestionTypesEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_questions" */
export interface AssignmentQuestionsMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_questions" */
export interface AssignmentQuestionsMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignment_questions". */
export interface AssignmentQuestionsOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  assignment_question_options_aggregate?: Maybe<AssignmentQuestionOptionsAggregateOrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "assignment_questions" */
export const enum AssignmentQuestionsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "assignment_quiz" */
export interface AssignmentQuiz {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  attempts?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  pass_percentage: EntireFieldWrapper<Scalars['Int']>;
  time_control: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_quiz" */
export interface AssignmentQuizAggregateOrderBy {
  avg?: Maybe<AssignmentQuizAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentQuizMaxOrderBy>;
  min?: Maybe<AssignmentQuizMinOrderBy>;
  stddev?: Maybe<AssignmentQuizStddevOrderBy>;
  stddev_pop?: Maybe<AssignmentQuizStddevPopOrderBy>;
  stddev_samp?: Maybe<AssignmentQuizStddevSampOrderBy>;
  sum?: Maybe<AssignmentQuizSumOrderBy>;
  var_pop?: Maybe<AssignmentQuizVarPopOrderBy>;
  var_samp?: Maybe<AssignmentQuizVarSampOrderBy>;
  variance?: Maybe<AssignmentQuizVarianceOrderBy>;
}

/** order by avg() on columns of table "assignment_quiz" */
export interface AssignmentQuizAvgOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_quiz". All fields are combined with a logical 'AND'. */
export interface AssignmentQuizBoolExp {
  _and?: Maybe<Array<AssignmentQuizBoolExp>>;
  _not?: Maybe<AssignmentQuizBoolExp>;
  _or?: Maybe<Array<AssignmentQuizBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  attempts?: Maybe<IntComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  pass_percentage?: Maybe<IntComparisonExp>;
  time_control?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_quiz" */
export interface AssignmentQuizMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  attempts?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_quiz" */
export interface AssignmentQuizMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  attempts?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignment_quiz". */
export interface AssignmentQuizOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  attempts?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
  time_control?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "assignment_quiz" */
export const enum AssignmentQuizSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  ATTEMPTS = 'attempts',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  PASS_PERCENTAGE = 'pass_percentage',
  /** column name */
  TIME_CONTROL = 'time_control',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "assignment_quiz" */
export interface AssignmentQuizStddevOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "assignment_quiz" */
export interface AssignmentQuizStddevPopOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "assignment_quiz" */
export interface AssignmentQuizStddevSampOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "assignment_quiz" */
export interface AssignmentQuizSumOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "assignment_quiz" */
export interface AssignmentQuizVarPopOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "assignment_quiz" */
export interface AssignmentQuizVarSampOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "assignment_quiz" */
export interface AssignmentQuizVarianceOrderBy {
  attempts?: Maybe<OrderBy>;
  pass_percentage?: Maybe<OrderBy>;
}

/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface AssignmentSubmits {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  completed_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamp']>;
  file?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<Files>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_submited: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface AssignmentSubmitsFilesArgs {
  distinct_on?: Maybe<Array<FilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FilesOrderBy>>;
  where?: Maybe<FilesBoolExp>;
}

/** order by aggregate values of table "assignment_submits" */
export interface AssignmentSubmitsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentSubmitsMaxOrderBy>;
  min?: Maybe<AssignmentSubmitsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_submits". All fields are combined with a logical 'AND'. */
export interface AssignmentSubmitsBoolExp {
  _and?: Maybe<Array<AssignmentSubmitsBoolExp>>;
  _not?: Maybe<AssignmentSubmitsBoolExp>;
  _or?: Maybe<Array<AssignmentSubmitsBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  completed_at?: Maybe<TimestamptzComparisonExp>;
  content?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestampComparisonExp>;
  file?: Maybe<StringComparisonExp>;
  files?: Maybe<FilesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  is_submited?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "assignment_submits" */
export const enum AssignmentSubmitsConstraint {
  /** unique or primary key constraint */
  ASSIGNMENT_SUBMITS_ASSIGNMENT_ID_USER_ID_KEY = 'assignment_submits_assignment_id_user_id_key',
  /** unique or primary key constraint */
  ASSIGNMENT_USER_PKEY = 'assignment_user_pkey'
};

/** input type for inserting data into table "assignment_submits" */
export interface AssignmentSubmitsInsertInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "assignment_submits" */
export interface AssignmentSubmitsMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  completed_at?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  file?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_submits" */
export interface AssignmentSubmitsMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  completed_at?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  file?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_submits" */
export interface AssignmentSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentSubmits>>;
}

/** on conflict condition type for table "assignment_submits" */
export interface AssignmentSubmitsOnConflict {
  constraint: AssignmentSubmitsConstraint;
  update_columns?: Array<AssignmentSubmitsUpdateColumn>;
  where?: Maybe<AssignmentSubmitsBoolExp>;
}

/** Ordering options when selecting data from "assignment_submits". */
export interface AssignmentSubmitsOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  completed_at?: Maybe<OrderBy>;
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  file?: Maybe<OrderBy>;
  files_aggregate?: Maybe<FilesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_submited?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_submits */
export interface AssignmentSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_submits" */
export const enum AssignmentSubmitsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_submits" */
export interface AssignmentSubmitsSetInput {
  assignment_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  is_submited?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "assignment_submits" */
export const enum AssignmentSubmitsUpdateColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_type" */
export interface AssignmentType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_type" */
export interface AssignmentTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/** columns and relationships of "assignment_type" */
export interface AssignmentTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export interface AssignmentTypeBoolExp {
  _and?: Maybe<Array<AssignmentTypeBoolExp>>;
  _not?: Maybe<AssignmentTypeBoolExp>;
  _or?: Maybe<Array<AssignmentTypeBoolExp>>;
  assignments?: Maybe<AssignmentsBoolExp>;
  icon?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
}

export const enum AssignmentTypeEnum {
  HAUSAUFGABE = 'HAUSAUFGABE',
  KLASSENARBEIT = 'KLASSENARBEIT',
  MATERIAL = 'MATERIAL',
  ONLINE = 'ONLINE',
  PRUFUNG = 'PRUFUNG',
  QUIZ = 'QUIZ',
  STUDY = 'STUDY',
  TASK = 'TASK'
};

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export interface AssignmentTypeEnumComparisonExp {
  _eq?: Maybe<AssignmentTypeEnum>;
  _in?: Maybe<Array<AssignmentTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<AssignmentTypeEnum>;
  _nin?: Maybe<Array<AssignmentTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_type". */
export interface AssignmentTypeOrderBy {
  assignments_aggregate?: Maybe<AssignmentsAggregateOrderBy>;
  icon?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
}

/** select columns of table "assignment_type" */
export const enum AssignmentTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/**
 * All users that assignment is assigned to and the table that teachers insert grades for each of them
 *
 *
 * columns and relationships of "assignment_user"
 */
export interface AssignmentUser {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<Marks>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_user" */
export interface AssignmentUserAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentUserMaxOrderBy>;
  min?: Maybe<AssignmentUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_user". All fields are combined with a logical 'AND'. */
export interface AssignmentUserBoolExp {
  _and?: Maybe<Array<AssignmentUserBoolExp>>;
  _not?: Maybe<AssignmentUserBoolExp>;
  _or?: Maybe<Array<AssignmentUserBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_completed?: Maybe<BooleanComparisonExp>;
  mark?: Maybe<MarksBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "assignment_user" */
export interface AssignmentUserMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "assignment_user" */
export interface AssignmentUserMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "assignment_user" */
export interface AssignmentUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AssignmentUser>>;
}

/** Ordering options when selecting data from "assignment_user". */
export interface AssignmentUserOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_completed?: Maybe<OrderBy>;
  mark?: Maybe<MarksOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: assignment_user */
export interface AssignmentUserPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "assignment_user" */
export const enum AssignmentUserSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "assignment_user" */
export interface AssignmentUserSetInput {
  is_completed?: Maybe<Scalars['Boolean']>;
}

/** columns and relationships of "assignments" */
export interface Assignments {
  /** An object relationship */
  assignmentAttendeeType?: EntireFieldWrapper<Maybe<AssignmentAttendeeType>>;
  assignment_attendee_type?: EntireFieldWrapper<Maybe<AssignmentAttendeeTypeEnum>>;
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<AssignmentBookChapter>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<AssignmentFiles>>;
  /** An object relationship */
  assignment_grade_weight?: EntireFieldWrapper<Maybe<AssignmentGradeWeights>>;
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<AssignmentQuestions>>;
  /** An object relationship */
  assignment_quiz?: EntireFieldWrapper<Maybe<AssignmentQuiz>>;
  /** An array relationship */
  assignment_quizzes: EntireFieldWrapper<Array<AssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<AssignmentSubmits>>;
  /** An object relationship */
  assignment_type: EntireFieldWrapper<AssignmentType>;
  /** An array relationship */
  assignment_users: EntireFieldWrapper<Array<AssignmentUser>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<Chats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<ViewAssignmentClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** A computed field, executes function "assignment_due_at_filter" */
  due_at_filter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<Files>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "assignment_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_gradeable: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  lesson?: EntireFieldWrapper<Maybe<Lessons>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<TeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<AssignmentTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<AssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentBookChapterOrderBy>>;
  where?: Maybe<AssignmentBookChapterBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentFilesArgs {
  distinct_on?: Maybe<Array<AssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentFilesOrderBy>>;
  where?: Maybe<AssignmentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionsOrderBy>>;
  where?: Maybe<AssignmentQuestionsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentQuizzesArgs {
  distinct_on?: Maybe<Array<AssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuizOrderBy>>;
  where?: Maybe<AssignmentQuizBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<AssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentSubmitsOrderBy>>;
  where?: Maybe<AssignmentSubmitsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsAssignmentUsersArgs {
  distinct_on?: Maybe<Array<AssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentUserOrderBy>>;
  where?: Maybe<AssignmentUserBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsClassesArgs {
  distinct_on?: Maybe<Array<ViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewAssignmentClassOrderBy>>;
  where?: Maybe<ViewAssignmentClassBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsFilesArgs {
  distinct_on?: Maybe<Array<FilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FilesOrderBy>>;
  where?: Maybe<FilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface AssignmentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}

/** aggregated selection of "assignments" */
export interface AssignmentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AssignmentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Assignments>>;
}

/** aggregate fields of "assignments" */
export interface AssignmentsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<AssignmentsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AssignmentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AssignmentsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<AssignmentsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<AssignmentsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<AssignmentsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<AssignmentsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<AssignmentsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<AssignmentsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<AssignmentsVarianceFields>>;
}


/** aggregate fields of "assignments" */
export interface AssignmentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<AssignmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "assignments" */
export interface AssignmentsAggregateOrderBy {
  avg?: Maybe<AssignmentsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<AssignmentsMaxOrderBy>;
  min?: Maybe<AssignmentsMinOrderBy>;
  stddev?: Maybe<AssignmentsStddevOrderBy>;
  stddev_pop?: Maybe<AssignmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<AssignmentsStddevSampOrderBy>;
  sum?: Maybe<AssignmentsSumOrderBy>;
  var_pop?: Maybe<AssignmentsVarPopOrderBy>;
  var_samp?: Maybe<AssignmentsVarSampOrderBy>;
  variance?: Maybe<AssignmentsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface AssignmentsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "assignments" */
export interface AssignmentsAvgOrderBy {
  duration?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export interface AssignmentsBoolExp {
  _and?: Maybe<Array<AssignmentsBoolExp>>;
  _not?: Maybe<AssignmentsBoolExp>;
  _or?: Maybe<Array<AssignmentsBoolExp>>;
  assignmentAttendeeType?: Maybe<AssignmentAttendeeTypeBoolExp>;
  assignment_attendee_type?: Maybe<AssignmentAttendeeTypeEnumComparisonExp>;
  assignment_book_chapters?: Maybe<AssignmentBookChapterBoolExp>;
  assignment_files?: Maybe<AssignmentFilesBoolExp>;
  assignment_grade_weight?: Maybe<AssignmentGradeWeightsBoolExp>;
  assignment_grade_weight_id?: Maybe<UuidComparisonExp>;
  assignment_questions?: Maybe<AssignmentQuestionsBoolExp>;
  assignment_quiz?: Maybe<AssignmentQuizBoolExp>;
  assignment_quizzes?: Maybe<AssignmentQuizBoolExp>;
  assignment_submits?: Maybe<AssignmentSubmitsBoolExp>;
  assignment_type?: Maybe<AssignmentTypeBoolExp>;
  assignment_users?: Maybe<AssignmentUserBoolExp>;
  chat?: Maybe<ChatsBoolExp>;
  chat_id?: Maybe<UuidComparisonExp>;
  classes?: Maybe<ViewAssignmentClassBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  due_at?: Maybe<TimestamptzComparisonExp>;
  due_at_filter?: Maybe<StringComparisonExp>;
  duration?: Maybe<IntComparisonExp>;
  files?: Maybe<FilesBoolExp>;
  grades?: Maybe<GradesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  is_completed?: Maybe<BooleanComparisonExp>;
  is_everybody?: Maybe<BooleanComparisonExp>;
  is_gradeable?: Maybe<BooleanComparisonExp>;
  lesson?: Maybe<LessonsBoolExp>;
  lesson_id?: Maybe<UuidComparisonExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  teaching_structure?: Maybe<TeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<UuidComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  type?: Maybe<AssignmentTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** aggregate max on columns */
export interface AssignmentsMaxFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "assignments" */
export interface AssignmentsMaxOrderBy {
  assignment_grade_weight_id?: Maybe<OrderBy>;
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AssignmentsMinFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "assignments" */
export interface AssignmentsMinOrderBy {
  assignment_grade_weight_id?: Maybe<OrderBy>;
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "assignments". */
export interface AssignmentsOrderBy {
  assignmentAttendeeType?: Maybe<AssignmentAttendeeTypeOrderBy>;
  assignment_attendee_type?: Maybe<OrderBy>;
  assignment_book_chapters_aggregate?: Maybe<AssignmentBookChapterAggregateOrderBy>;
  assignment_files_aggregate?: Maybe<AssignmentFilesAggregateOrderBy>;
  assignment_grade_weight?: Maybe<AssignmentGradeWeightsOrderBy>;
  assignment_grade_weight_id?: Maybe<OrderBy>;
  assignment_questions_aggregate?: Maybe<AssignmentQuestionsAggregateOrderBy>;
  assignment_quiz?: Maybe<AssignmentQuizOrderBy>;
  assignment_quizzes_aggregate?: Maybe<AssignmentQuizAggregateOrderBy>;
  assignment_submits_aggregate?: Maybe<AssignmentSubmitsAggregateOrderBy>;
  assignment_type?: Maybe<AssignmentTypeOrderBy>;
  assignment_users_aggregate?: Maybe<AssignmentUserAggregateOrderBy>;
  chat?: Maybe<ChatsOrderBy>;
  chat_id?: Maybe<OrderBy>;
  classes_aggregate?: Maybe<ViewAssignmentClassAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  due_at_filter?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  files_aggregate?: Maybe<FilesAggregateOrderBy>;
  grades_aggregate?: Maybe<GradesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_completed?: Maybe<OrderBy>;
  is_everybody?: Maybe<OrderBy>;
  is_gradeable?: Maybe<OrderBy>;
  lesson?: Maybe<LessonsOrderBy>;
  lesson_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure?: Maybe<TeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "assignments" */
export const enum AssignmentsSelectColumn {
  /** column name */
  ASSIGNMENT_ATTENDEE_TYPE = 'assignment_attendee_type',
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate stddev on columns */
export interface AssignmentsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "assignments" */
export interface AssignmentsStddevOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate stddev_pop on columns */
export interface AssignmentsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "assignments" */
export interface AssignmentsStddevPopOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate stddev_samp on columns */
export interface AssignmentsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "assignments" */
export interface AssignmentsStddevSampOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate sum on columns */
export interface AssignmentsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "assignments" */
export interface AssignmentsSumOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate var_pop on columns */
export interface AssignmentsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "assignments" */
export interface AssignmentsVarPopOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate var_samp on columns */
export interface AssignmentsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "assignments" */
export interface AssignmentsVarSampOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate variance on columns */
export interface AssignmentsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "assignments" */
export interface AssignmentsVarianceOrderBy {
  duration?: Maybe<OrderBy>;
}

/** columns and relationships of "attendance_types" */
export interface AttendanceTypes {
  icon: EntireFieldWrapper<Scalars['String']>;
  text: EntireFieldWrapper<Scalars['String']>;
  value: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "attendance_types". All fields are combined with a logical 'AND'. */
export interface AttendanceTypesBoolExp {
  _and?: Maybe<Array<AttendanceTypesBoolExp>>;
  _not?: Maybe<AttendanceTypesBoolExp>;
  _or?: Maybe<Array<AttendanceTypesBoolExp>>;
  icon?: Maybe<StringComparisonExp>;
  text?: Maybe<StringComparisonExp>;
  value?: Maybe<StringComparisonExp>;
}

/** Ordering options when selecting data from "attendance_types". */
export interface AttendanceTypesOrderBy {
  icon?: Maybe<OrderBy>;
  text?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
}

/** select columns of table "attendance_types" */
export const enum AttendanceTypesSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  TEXT = 'text',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "attendances" */
export interface Attendances {
  attendance_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  class: EntireFieldWrapper<TeachingStructures>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  semester: EntireFieldWrapper<TeachingStructures>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<Users>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<TeachingStructures>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  teacher?: EntireFieldWrapper<Maybe<Users>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  type?: EntireFieldWrapper<Maybe<AttendanceTypes>>;
}

/** Boolean expression to filter rows from the table "attendances". All fields are combined with a logical 'AND'. */
export interface AttendancesBoolExp {
  _and?: Maybe<Array<AttendancesBoolExp>>;
  _not?: Maybe<AttendancesBoolExp>;
  _or?: Maybe<Array<AttendancesBoolExp>>;
  attendance_type?: Maybe<StringComparisonExp>;
  class?: Maybe<TeachingStructuresBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
  comment?: Maybe<StringComparisonExp>;
  date?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  semester?: Maybe<TeachingStructuresBoolExp>;
  semester_id?: Maybe<UuidComparisonExp>;
  student_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<TeachingStructuresBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
  type?: Maybe<AttendanceTypesBoolExp>;
}

/** Ordering options when selecting data from "attendances". */
export interface AttendancesOrderBy {
  attendance_type?: Maybe<OrderBy>;
  class?: Maybe<TeachingStructuresOrderBy>;
  class_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  semester?: Maybe<TeachingStructuresOrderBy>;
  semester_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject?: Maybe<TeachingStructuresOrderBy>;
  subject_id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
  type?: Maybe<AttendanceTypesOrderBy>;
}

/** select columns of table "attendances" */
export const enum AttendancesSelectColumn {
  /** column name */
  ATTENDANCE_TYPE = 'attendance_type',
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "auth.account_providers" */
export interface AuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<AuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface AuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface AuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface AuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface AuthAccountProvidersAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountProvidersMaxOrderBy>;
  min?: Maybe<AuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface AuthAccountProvidersArrRelInsertInput {
  data: Array<AuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface AuthAccountProvidersBoolExp {
  _and?: Maybe<Array<AuthAccountProvidersBoolExp>>;
  _not?: Maybe<AuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<AuthAccountProvidersBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  auth_provider?: Maybe<StringComparisonExp>;
  auth_provider_unique_id?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  provider?: Maybe<AuthProvidersBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum AuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface AuthAccountProvidersInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<AuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface AuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface AuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface AuthAccountProvidersMinOrderBy {
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface AuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface AuthAccountProvidersOnConflict {
  constraint: AuthAccountProvidersConstraint;
  update_columns?: Array<AuthAccountProvidersUpdateColumn>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface AuthAccountProvidersOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  auth_provider?: Maybe<OrderBy>;
  auth_provider_unique_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  provider?: Maybe<AuthProvidersOrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface AuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum AuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface AuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum AuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface AuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<AuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface AuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface AuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface AuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface AuthAccountRolesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountRolesMaxOrderBy>;
  min?: Maybe<AuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface AuthAccountRolesArrRelInsertInput {
  data: Array<AuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface AuthAccountRolesBoolExp {
  _and?: Maybe<Array<AuthAccountRolesBoolExp>>;
  _not?: Maybe<AuthAccountRolesBoolExp>;
  _or?: Maybe<Array<AuthAccountRolesBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  roleByRole?: Maybe<AuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum AuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface AuthAccountRolesInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<AuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface AuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface AuthAccountRolesMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface AuthAccountRolesMinOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface AuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface AuthAccountRolesOnConflict {
  constraint: AuthAccountRolesConstraint;
  update_columns?: Array<AuthAccountRolesUpdateColumn>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface AuthAccountRolesOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  roleByRole?: Maybe<AuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface AuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum AuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface AuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum AuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface AuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<AuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<AuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<AuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface AuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface AuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface AuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface AuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface AuthAccountsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthAccountsMaxOrderBy>;
  min?: Maybe<AuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface AuthAccountsArrRelInsertInput {
  data: Array<AuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface AuthAccountsBoolExp {
  _and?: Maybe<Array<AuthAccountsBoolExp>>;
  _not?: Maybe<AuthAccountsBoolExp>;
  _or?: Maybe<Array<AuthAccountsBoolExp>>;
  account_providers?: Maybe<AuthAccountProvidersBoolExp>;
  account_roles?: Maybe<AuthAccountRolesBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  default_role?: Maybe<StringComparisonExp>;
  email?: Maybe<CitextComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  insurance_number?: Maybe<PrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<BooleanComparisonExp>;
  new_email?: Maybe<CitextComparisonExp>;
  password_hash?: Maybe<StringComparisonExp>;
  refresh_tokens?: Maybe<AuthRefreshTokensBoolExp>;
  role?: Maybe<AuthRolesBoolExp>;
  ticket?: Maybe<UuidComparisonExp>;
  ticket_expires_at?: Maybe<TimestamptzComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum AuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface AuthAccountsInsertInput {
  account_providers?: Maybe<AuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<AuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<PrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<AuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<AuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface AuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface AuthAccountsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface AuthAccountsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface AuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface AuthAccountsObjRelInsertInput {
  data: AuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface AuthAccountsOnConflict {
  constraint: AuthAccountsConstraint;
  update_columns?: Array<AuthAccountsUpdateColumn>;
  where?: Maybe<AuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface AuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<AuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<AuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  default_role?: Maybe<OrderBy>;
  email?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  insurance_number?: Maybe<PrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<OrderBy>;
  new_email?: Maybe<OrderBy>;
  password_hash?: Maybe<OrderBy>;
  refresh_tokens_aggregate?: Maybe<AuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<AuthRolesOrderBy>;
  ticket?: Maybe<OrderBy>;
  ticket_expires_at?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface AuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum AuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface AuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum AuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface AuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface AuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface AuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface AuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface AuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface AuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface AuthProvidersBoolExp {
  _and?: Maybe<Array<AuthProvidersBoolExp>>;
  _not?: Maybe<AuthProvidersBoolExp>;
  _or?: Maybe<Array<AuthProvidersBoolExp>>;
  account_providers?: Maybe<AuthAccountProvidersBoolExp>;
  provider?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum AuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface AuthProvidersInsertInput {
  account_providers?: Maybe<AuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface AuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface AuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface AuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface AuthProvidersObjRelInsertInput {
  data: AuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface AuthProvidersOnConflict {
  constraint: AuthProvidersConstraint;
  update_columns?: Array<AuthProvidersUpdateColumn>;
  where?: Maybe<AuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface AuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<AuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface AuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum AuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface AuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum AuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface AuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<AuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface AuthRefreshTokensAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<AuthRefreshTokensMaxOrderBy>;
  min?: Maybe<AuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface AuthRefreshTokensArrRelInsertInput {
  data: Array<AuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface AuthRefreshTokensBoolExp {
  _and?: Maybe<Array<AuthRefreshTokensBoolExp>>;
  _not?: Maybe<AuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<AuthRefreshTokensBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  account_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  expires_at?: Maybe<TimestamptzComparisonExp>;
  refresh_token?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum AuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface AuthRefreshTokensInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface AuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface AuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface AuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface AuthRefreshTokensMinOrderBy {
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface AuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface AuthRefreshTokensOnConflict {
  constraint: AuthRefreshTokensConstraint;
  update_columns?: Array<AuthRefreshTokensUpdateColumn>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface AuthRefreshTokensOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  account_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  expires_at?: Maybe<OrderBy>;
  refresh_token?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface AuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum AuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface AuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum AuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface AuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<AuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<AuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface AuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface AuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<AuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<AuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface AuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<AuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<AuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface AuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<AuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface AuthRolesBoolExp {
  _and?: Maybe<Array<AuthRolesBoolExp>>;
  _not?: Maybe<AuthRolesBoolExp>;
  _or?: Maybe<Array<AuthRolesBoolExp>>;
  account_roles?: Maybe<AuthAccountRolesBoolExp>;
  accounts?: Maybe<AuthAccountsBoolExp>;
  role?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum AuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface AuthRolesInsertInput {
  account_roles?: Maybe<AuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<AuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface AuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface AuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface AuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<AuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface AuthRolesObjRelInsertInput {
  data: AuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<AuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface AuthRolesOnConflict {
  constraint: AuthRolesConstraint;
  update_columns?: Array<AuthRolesUpdateColumn>;
  where?: Maybe<AuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface AuthRolesOrderBy {
  account_roles_aggregate?: Maybe<AuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<AuthAccountsAggregateOrderBy>;
  role?: Maybe<OrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface AuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum AuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface AuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum AuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export interface BigintComparisonExp {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
}

/** columns and relationships of "book_chapter_type" */
export interface BookChapterType {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<BookChapters>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "book_chapter_type" */
export interface BookChapterTypeBookChaptersArgs {
  distinct_on?: Maybe<Array<BookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChaptersOrderBy>>;
  where?: Maybe<BookChaptersBoolExp>;
}

/** Boolean expression to filter rows from the table "book_chapter_type". All fields are combined with a logical 'AND'. */
export interface BookChapterTypeBoolExp {
  _and?: Maybe<Array<BookChapterTypeBoolExp>>;
  _not?: Maybe<BookChapterTypeBoolExp>;
  _or?: Maybe<Array<BookChapterTypeBoolExp>>;
  book_chapters?: Maybe<BookChaptersBoolExp>;
  description?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
}

export const enum BookChapterTypeEnum {
  HTML = 'HTML',
  QUIZZ = 'QUIZZ'
};

/** Boolean expression to compare columns of type "book_chapter_type_enum". All fields are combined with logical 'AND'. */
export interface BookChapterTypeEnumComparisonExp {
  _eq?: Maybe<BookChapterTypeEnum>;
  _in?: Maybe<Array<BookChapterTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<BookChapterTypeEnum>;
  _nin?: Maybe<Array<BookChapterTypeEnum>>;
}

/** Ordering options when selecting data from "book_chapter_type". */
export interface BookChapterTypeOrderBy {
  book_chapters_aggregate?: Maybe<BookChaptersAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
}

/** select columns of table "book_chapter_type" */
export const enum BookChapterTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "book_chapters" */
export interface BookChapters {
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<AssignmentBookChapter>>;
  /** An object relationship */
  book: EntireFieldWrapper<Books>;
  /** An object relationship */
  book_chapter_type: EntireFieldWrapper<BookChapterType>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<ChapterSections>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  due_at: EntireFieldWrapper<Scalars['date']>;
  /** A computed field, executes function "book_chapter_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<BookChapterTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "book_chapters" */
export interface BookChaptersAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<AssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentBookChapterOrderBy>>;
  where?: Maybe<AssignmentBookChapterBoolExp>;
}


/** columns and relationships of "book_chapters" */
export interface BookChaptersChapterSectionsArgs {
  distinct_on?: Maybe<Array<ChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionsOrderBy>>;
  where?: Maybe<ChapterSectionsBoolExp>;
}

/** order by aggregate values of table "book_chapters" */
export interface BookChaptersAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<BookChaptersMaxOrderBy>;
  min?: Maybe<BookChaptersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_chapters". All fields are combined with a logical 'AND'. */
export interface BookChaptersBoolExp {
  _and?: Maybe<Array<BookChaptersBoolExp>>;
  _not?: Maybe<BookChaptersBoolExp>;
  _or?: Maybe<Array<BookChaptersBoolExp>>;
  assignment_book_chapters?: Maybe<AssignmentBookChapterBoolExp>;
  book?: Maybe<BooksBoolExp>;
  book_chapter_type?: Maybe<BookChapterTypeBoolExp>;
  book_id?: Maybe<UuidComparisonExp>;
  chapter_sections?: Maybe<ChapterSectionsBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  due_at?: Maybe<DateComparisonExp>;
  duration_left?: Maybe<BigintComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  type?: Maybe<BookChapterTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "book_chapters" */
export interface BookChaptersMaxOrderBy {
  book_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "book_chapters" */
export interface BookChaptersMinOrderBy {
  book_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "book_chapters". */
export interface BookChaptersOrderBy {
  assignment_book_chapters_aggregate?: Maybe<AssignmentBookChapterAggregateOrderBy>;
  book?: Maybe<BooksOrderBy>;
  book_chapter_type?: Maybe<BookChapterTypeOrderBy>;
  book_id?: Maybe<OrderBy>;
  chapter_sections_aggregate?: Maybe<ChapterSectionsAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  due_at?: Maybe<OrderBy>;
  duration_left?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "book_chapters" */
export const enum BookChaptersSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "book_course" */
export interface BookCourse {
  /** An object relationship */
  book: EntireFieldWrapper<Books>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_course" */
export interface BookCourseAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<BookCourseMaxOrderBy>;
  min?: Maybe<BookCourseMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_course". All fields are combined with a logical 'AND'. */
export interface BookCourseBoolExp {
  _and?: Maybe<Array<BookCourseBoolExp>>;
  _not?: Maybe<BookCourseBoolExp>;
  _or?: Maybe<Array<BookCourseBoolExp>>;
  book?: Maybe<BooksBoolExp>;
  book_id?: Maybe<UuidComparisonExp>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "book_course" */
export interface BookCourseMaxOrderBy {
  book_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "book_course" */
export interface BookCourseMinOrderBy {
  book_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "book_course". */
export interface BookCourseOrderBy {
  book?: Maybe<BooksOrderBy>;
  book_id?: Maybe<OrderBy>;
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** select columns of table "book_course" */
export const enum BookCourseSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "book_user" */
export interface BookUser {
  /** An object relationship */
  book: EntireFieldWrapper<Books>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_user" */
export interface BookUserAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<BookUserMaxOrderBy>;
  min?: Maybe<BookUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_user". All fields are combined with a logical 'AND'. */
export interface BookUserBoolExp {
  _and?: Maybe<Array<BookUserBoolExp>>;
  _not?: Maybe<BookUserBoolExp>;
  _or?: Maybe<Array<BookUserBoolExp>>;
  book?: Maybe<BooksBoolExp>;
  book_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "book_user" */
export interface BookUserMaxOrderBy {
  book_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "book_user" */
export interface BookUserMinOrderBy {
  book_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "book_user". */
export interface BookUserOrderBy {
  book?: Maybe<BooksOrderBy>;
  book_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "book_user" */
export const enum BookUserSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "books" */
export interface Books {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<BookChapters>>;
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<BookCourse>>;
  /** An array relationship */
  book_users: EntireFieldWrapper<Array<BookUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  subject: EntireFieldWrapper<Subjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "books" */
export interface BooksBookChaptersArgs {
  distinct_on?: Maybe<Array<BookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChaptersOrderBy>>;
  where?: Maybe<BookChaptersBoolExp>;
}


/** columns and relationships of "books" */
export interface BooksBookCoursesArgs {
  distinct_on?: Maybe<Array<BookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookCourseOrderBy>>;
  where?: Maybe<BookCourseBoolExp>;
}


/** columns and relationships of "books" */
export interface BooksBookUsersArgs {
  distinct_on?: Maybe<Array<BookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookUserOrderBy>>;
  where?: Maybe<BookUserBoolExp>;
}

/** order by aggregate values of table "books" */
export interface BooksAggregateOrderBy {
  avg?: Maybe<BooksAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<BooksMaxOrderBy>;
  min?: Maybe<BooksMinOrderBy>;
  stddev?: Maybe<BooksStddevOrderBy>;
  stddev_pop?: Maybe<BooksStddevPopOrderBy>;
  stddev_samp?: Maybe<BooksStddevSampOrderBy>;
  sum?: Maybe<BooksSumOrderBy>;
  var_pop?: Maybe<BooksVarPopOrderBy>;
  var_samp?: Maybe<BooksVarSampOrderBy>;
  variance?: Maybe<BooksVarianceOrderBy>;
}

/** order by avg() on columns of table "books" */
export interface BooksAvgOrderBy {
  sort?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export interface BooksBoolExp {
  _and?: Maybe<Array<BooksBoolExp>>;
  _not?: Maybe<BooksBoolExp>;
  _or?: Maybe<Array<BooksBoolExp>>;
  book_chapters?: Maybe<BookChaptersBoolExp>;
  book_courses?: Maybe<BookCourseBoolExp>;
  book_users?: Maybe<BookUserBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  sort?: Maybe<IntComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "books" */
export interface BooksMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "books" */
export interface BooksMinOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "books". */
export interface BooksOrderBy {
  book_chapters_aggregate?: Maybe<BookChaptersAggregateOrderBy>;
  book_courses_aggregate?: Maybe<BookCourseAggregateOrderBy>;
  book_users_aggregate?: Maybe<BookUserAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "books" */
export const enum BooksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "books" */
export interface BooksStddevOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "books" */
export interface BooksStddevPopOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "books" */
export interface BooksStddevSampOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "books" */
export interface BooksSumOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "books" */
export interface BooksVarPopOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "books" */
export interface BooksVarSampOrderBy {
  sort?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "books" */
export interface BooksVarianceOrderBy {
  sort?: Maybe<OrderBy>;
}

/**
 * DEPRECATED - change to assignments_notes
 *
 *
 * columns and relationships of "chapter_section_notes"
 */
export interface ChapterSectionNotes {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chapter_section: EntireFieldWrapper<ChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<Students>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
}

/** order by aggregate values of table "chapter_section_notes" */
export interface ChapterSectionNotesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChapterSectionNotesMaxOrderBy>;
  min?: Maybe<ChapterSectionNotesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_notes". All fields are combined with a logical 'AND'. */
export interface ChapterSectionNotesBoolExp {
  _and?: Maybe<Array<ChapterSectionNotesBoolExp>>;
  _not?: Maybe<ChapterSectionNotesBoolExp>;
  _or?: Maybe<Array<ChapterSectionNotesBoolExp>>;
  body?: Maybe<StringComparisonExp>;
  chapter_section?: Maybe<ChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_notes" */
export const enum ChapterSectionNotesConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_NOTES_PKEY = 'chapter_section_notes_pkey'
};

/** input type for inserting data into table "chapter_section_notes" */
export interface ChapterSectionNotesInsertInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_notes" */
export interface ChapterSectionNotesMaxOrderBy {
  body?: Maybe<OrderBy>;
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chapter_section_notes" */
export interface ChapterSectionNotesMinOrderBy {
  body?: Maybe<OrderBy>;
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chapter_section_notes" */
export interface ChapterSectionNotesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChapterSectionNotes>>;
}

/** on conflict condition type for table "chapter_section_notes" */
export interface ChapterSectionNotesOnConflict {
  constraint: ChapterSectionNotesConstraint;
  update_columns?: Array<ChapterSectionNotesUpdateColumn>;
  where?: Maybe<ChapterSectionNotesBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_notes". */
export interface ChapterSectionNotesOrderBy {
  body?: Maybe<OrderBy>;
  chapter_section?: Maybe<ChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: chapter_section_notes */
export interface ChapterSectionNotesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_notes" */
export const enum ChapterSectionNotesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_notes" */
export interface ChapterSectionNotesSetInput {
  body?: Maybe<Scalars['String']>;
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "chapter_section_notes" */
export const enum ChapterSectionNotesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "chapter_section_submits" */
export interface ChapterSectionSubmits {
  /** An object relationship */
  chapter_section: EntireFieldWrapper<ChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration_spent: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  student: EntireFieldWrapper<Students>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "chapter_section_submits" */
export interface ChapterSectionSubmitsAggregateOrderBy {
  avg?: Maybe<ChapterSectionSubmitsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ChapterSectionSubmitsMaxOrderBy>;
  min?: Maybe<ChapterSectionSubmitsMinOrderBy>;
  stddev?: Maybe<ChapterSectionSubmitsStddevOrderBy>;
  stddev_pop?: Maybe<ChapterSectionSubmitsStddevPopOrderBy>;
  stddev_samp?: Maybe<ChapterSectionSubmitsStddevSampOrderBy>;
  sum?: Maybe<ChapterSectionSubmitsSumOrderBy>;
  var_pop?: Maybe<ChapterSectionSubmitsVarPopOrderBy>;
  var_samp?: Maybe<ChapterSectionSubmitsVarSampOrderBy>;
  variance?: Maybe<ChapterSectionSubmitsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsAvgOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_submits". All fields are combined with a logical 'AND'. */
export interface ChapterSectionSubmitsBoolExp {
  _and?: Maybe<Array<ChapterSectionSubmitsBoolExp>>;
  _not?: Maybe<ChapterSectionSubmitsBoolExp>;
  _or?: Maybe<Array<ChapterSectionSubmitsBoolExp>>;
  chapter_section?: Maybe<ChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  duration_spent?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_completed?: Maybe<BooleanComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "chapter_section_submits" */
export const enum ChapterSectionSubmitsConstraint {
  /** unique or primary key constraint */
  CHAPTER_SECTION_STUDENT_PKEY = 'chapter_section_student_pkey',
  /** unique or primary key constraint */
  CHAPTER_SECTION_SUBMITS_CHAPTER_SECTION_ID_STUDENT_ID_KEY = 'chapter_section_submits_chapter_section_id_student_id_key'
};

/** input type for incrementing numeric columns in table "chapter_section_submits" */
export interface ChapterSectionSubmitsIncInput {
  duration_spent?: Maybe<Scalars['Int']>;
}

/** input type for inserting data into table "chapter_section_submits" */
export interface ChapterSectionSubmitsInsertInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsMaxOrderBy {
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  duration_spent?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsMinOrderBy {
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  duration_spent?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chapter_section_submits" */
export interface ChapterSectionSubmitsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChapterSectionSubmits>>;
}

/** on conflict condition type for table "chapter_section_submits" */
export interface ChapterSectionSubmitsOnConflict {
  constraint: ChapterSectionSubmitsConstraint;
  update_columns?: Array<ChapterSectionSubmitsUpdateColumn>;
  where?: Maybe<ChapterSectionSubmitsBoolExp>;
}

/** Ordering options when selecting data from "chapter_section_submits". */
export interface ChapterSectionSubmitsOrderBy {
  chapter_section?: Maybe<ChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  duration_spent?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_completed?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: chapter_section_submits */
export interface ChapterSectionSubmitsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chapter_section_submits" */
export const enum ChapterSectionSubmitsSelectColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "chapter_section_submits" */
export interface ChapterSectionSubmitsSetInput {
  chapter_section_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  duration_spent?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by stddev() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsStddevOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsStddevPopOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsStddevSampOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsSumOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** update columns of table "chapter_section_submits" */
export const enum ChapterSectionSubmitsUpdateColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by var_pop() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsVarPopOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsVarSampOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "chapter_section_submits" */
export interface ChapterSectionSubmitsVarianceOrderBy {
  duration_spent?: Maybe<OrderBy>;
}

/** columns and relationships of "chapter_section_type" */
export interface ChapterSectionType {
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<ChapterSections>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chapter_section_type" */
export interface ChapterSectionTypeChapterSectionsArgs {
  distinct_on?: Maybe<Array<ChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionsOrderBy>>;
  where?: Maybe<ChapterSectionsBoolExp>;
}

/** Boolean expression to filter rows from the table "chapter_section_type". All fields are combined with a logical 'AND'. */
export interface ChapterSectionTypeBoolExp {
  _and?: Maybe<Array<ChapterSectionTypeBoolExp>>;
  _not?: Maybe<ChapterSectionTypeBoolExp>;
  _or?: Maybe<Array<ChapterSectionTypeBoolExp>>;
  chapter_sections?: Maybe<ChapterSectionsBoolExp>;
  icon?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
}

export const enum ChapterSectionTypeEnum {
  HTML = 'HTML',
  INFORMATION = 'Information',
  QUIZZ = 'Quizz'
};

/** Boolean expression to compare columns of type "chapter_section_type_enum". All fields are combined with logical 'AND'. */
export interface ChapterSectionTypeEnumComparisonExp {
  _eq?: Maybe<ChapterSectionTypeEnum>;
  _in?: Maybe<Array<ChapterSectionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ChapterSectionTypeEnum>;
  _nin?: Maybe<Array<ChapterSectionTypeEnum>>;
}

/** Ordering options when selecting data from "chapter_section_type". */
export interface ChapterSectionTypeOrderBy {
  chapter_sections_aggregate?: Maybe<ChapterSectionsAggregateOrderBy>;
  icon?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
}

/** select columns of table "chapter_section_type" */
export const enum ChapterSectionTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chapter_sections" */
export interface ChapterSections {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<BookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<ChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<ChapterSectionSubmits>>;
  /** An object relationship */
  chapter_section_type: EntireFieldWrapper<ChapterSectionType>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** A computed field, executes function "section_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "section_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<ChapterSectionTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "chapter_sections" */
export interface ChapterSectionsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<ChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionNotesOrderBy>>;
  where?: Maybe<ChapterSectionNotesBoolExp>;
}


/** columns and relationships of "chapter_sections" */
export interface ChapterSectionsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<ChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionSubmitsOrderBy>>;
  where?: Maybe<ChapterSectionSubmitsBoolExp>;
}

/** order by aggregate values of table "chapter_sections" */
export interface ChapterSectionsAggregateOrderBy {
  avg?: Maybe<ChapterSectionsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ChapterSectionsMaxOrderBy>;
  min?: Maybe<ChapterSectionsMinOrderBy>;
  stddev?: Maybe<ChapterSectionsStddevOrderBy>;
  stddev_pop?: Maybe<ChapterSectionsStddevPopOrderBy>;
  stddev_samp?: Maybe<ChapterSectionsStddevSampOrderBy>;
  sum?: Maybe<ChapterSectionsSumOrderBy>;
  var_pop?: Maybe<ChapterSectionsVarPopOrderBy>;
  var_samp?: Maybe<ChapterSectionsVarSampOrderBy>;
  variance?: Maybe<ChapterSectionsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_sections" */
export interface ChapterSectionsAvgOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_sections". All fields are combined with a logical 'AND'. */
export interface ChapterSectionsBoolExp {
  _and?: Maybe<Array<ChapterSectionsBoolExp>>;
  _not?: Maybe<ChapterSectionsBoolExp>;
  _or?: Maybe<Array<ChapterSectionsBoolExp>>;
  body?: Maybe<StringComparisonExp>;
  book_chapter?: Maybe<BookChaptersBoolExp>;
  book_chapter_id?: Maybe<UuidComparisonExp>;
  chapter_section_notes?: Maybe<ChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<ChapterSectionSubmitsBoolExp>;
  chapter_section_type?: Maybe<ChapterSectionTypeBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  duration?: Maybe<IntComparisonExp>;
  duration_left?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_completed?: Maybe<BooleanComparisonExp>;
  sort?: Maybe<IntComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  type?: Maybe<ChapterSectionTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_sections" */
export interface ChapterSectionsMaxOrderBy {
  body?: Maybe<OrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chapter_sections" */
export interface ChapterSectionsMinOrderBy {
  body?: Maybe<OrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "chapter_sections". */
export interface ChapterSectionsOrderBy {
  body?: Maybe<OrderBy>;
  book_chapter?: Maybe<BookChaptersOrderBy>;
  book_chapter_id?: Maybe<OrderBy>;
  chapter_section_notes_aggregate?: Maybe<ChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<ChapterSectionSubmitsAggregateOrderBy>;
  chapter_section_type?: Maybe<ChapterSectionTypeOrderBy>;
  created_at?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  duration_left?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_completed?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "chapter_sections" */
export const enum ChapterSectionsSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_sections" */
export interface ChapterSectionsStddevOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_sections" */
export interface ChapterSectionsStddevPopOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_sections" */
export interface ChapterSectionsStddevSampOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "chapter_sections" */
export interface ChapterSectionsSumOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "chapter_sections" */
export interface ChapterSectionsVarPopOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "chapter_sections" */
export interface ChapterSectionsVarSampOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "chapter_sections" */
export interface ChapterSectionsVarianceOrderBy {
  duration?: Maybe<OrderBy>;
  sort?: Maybe<OrderBy>;
}

/** columns and relationships of "chat_message_likes" */
export interface ChatMessageLikes {
  chat_like_user?: EntireFieldWrapper<Maybe<Users>>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<ChatMessages>>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "chat_message_likes" */
export interface ChatMessageLikesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<ChatMessageLikesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<ChatMessageLikes>>;
}

/** aggregate fields of "chat_message_likes" */
export interface ChatMessageLikesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<ChatMessageLikesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<ChatMessageLikesMinFields>>;
}


/** aggregate fields of "chat_message_likes" */
export interface ChatMessageLikesAggregateFieldsCountArgs {
  columns?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_message_likes" */
export interface ChatMessageLikesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChatMessageLikesMaxOrderBy>;
  min?: Maybe<ChatMessageLikesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_likes" */
export interface ChatMessageLikesArrRelInsertInput {
  data: Array<ChatMessageLikesInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_message_likes". All fields are combined with a logical 'AND'. */
export interface ChatMessageLikesBoolExp {
  _and?: Maybe<Array<ChatMessageLikesBoolExp>>;
  _not?: Maybe<ChatMessageLikesBoolExp>;
  _or?: Maybe<Array<ChatMessageLikesBoolExp>>;
  chat_message?: Maybe<ChatMessagesBoolExp>;
  chat_message_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** input type for inserting data into table "chat_message_likes" */
export interface ChatMessageLikesInsertInput {
  chat_message?: Maybe<ChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface ChatMessageLikesMaxFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_message_likes" */
export interface ChatMessageLikesMaxOrderBy {
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface ChatMessageLikesMinFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_message_likes" */
export interface ChatMessageLikesMinOrderBy {
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chat_message_likes" */
export interface ChatMessageLikesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChatMessageLikes>>;
}

/** Ordering options when selecting data from "chat_message_likes". */
export interface ChatMessageLikesOrderBy {
  chat_message?: Maybe<ChatMessagesOrderBy>;
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "chat_message_likes" */
export const enum ChatMessageLikesSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chat_message_reads" */
export interface ChatMessageReads {
  /** An object relationship */
  chat_message: EntireFieldWrapper<ChatMessages>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_message_reads" */
export interface ChatMessageReadsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChatMessageReadsMaxOrderBy>;
  min?: Maybe<ChatMessageReadsMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_reads" */
export interface ChatMessageReadsArrRelInsertInput {
  data: Array<ChatMessageReadsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<ChatMessageReadsOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_message_reads". All fields are combined with a logical 'AND'. */
export interface ChatMessageReadsBoolExp {
  _and?: Maybe<Array<ChatMessageReadsBoolExp>>;
  _not?: Maybe<ChatMessageReadsBoolExp>;
  _or?: Maybe<Array<ChatMessageReadsBoolExp>>;
  chat_message?: Maybe<ChatMessagesBoolExp>;
  chat_message_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_read?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_message_reads" */
export const enum ChatMessageReadsConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGE_USER_PKEY = 'chat_message_user_pkey'
};

/** input type for inserting data into table "chat_message_reads" */
export interface ChatMessageReadsInsertInput {
  chat_message?: Maybe<ChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
}

/** order by max() on columns of table "chat_message_reads" */
export interface ChatMessageReadsMaxOrderBy {
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chat_message_reads" */
export interface ChatMessageReadsMinOrderBy {
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chat_message_reads" */
export interface ChatMessageReadsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChatMessageReads>>;
}

/** on conflict condition type for table "chat_message_reads" */
export interface ChatMessageReadsOnConflict {
  constraint: ChatMessageReadsConstraint;
  update_columns?: Array<ChatMessageReadsUpdateColumn>;
  where?: Maybe<ChatMessageReadsBoolExp>;
}

/** Ordering options when selecting data from "chat_message_reads". */
export interface ChatMessageReadsOrderBy {
  chat_message?: Maybe<ChatMessagesOrderBy>;
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_read?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: chat_message_reads */
export interface ChatMessageReadsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_message_reads" */
export const enum ChatMessageReadsSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_message_reads" */
export interface ChatMessageReadsSetInput {
  is_read?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_message_reads" */
export const enum ChatMessageReadsUpdateColumn {
  /** column name */
  IS_READ = 'is_read'
};

/** columns and relationships of "chat_messages" */
export interface ChatMessages {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chat: EntireFieldWrapper<Chats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<ChatMessages>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<ChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<ChatMessageLikesAggregate>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<ChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<ChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<ChatMessagesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<Files>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_pinned: EntireFieldWrapper<Scalars['Boolean']>;
  /** A computed field, executes function "chat_message_replys" */
  replys?: EntireFieldWrapper<Maybe<Array<ChatMessages>>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesChatMessageLikesArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesChatMessageReadsArgs {
  distinct_on?: Maybe<Array<ChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageReadsOrderBy>>;
  where?: Maybe<ChatMessageReadsBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesChatMessagesArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesFilesArgs {
  distinct_on?: Maybe<Array<FilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FilesOrderBy>>;
  where?: Maybe<FilesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface ChatMessagesReplysArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}

/** aggregated selection of "chat_messages" */
export interface ChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<ChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<ChatMessages>>;
}

/** aggregate fields of "chat_messages" */
export interface ChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<ChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<ChatMessagesMinFields>>;
}


/** aggregate fields of "chat_messages" */
export interface ChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<ChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_messages" */
export interface ChatMessagesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChatMessagesMaxOrderBy>;
  min?: Maybe<ChatMessagesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_messages" */
export interface ChatMessagesArrRelInsertInput {
  data: Array<ChatMessagesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<ChatMessagesOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export interface ChatMessagesBoolExp {
  _and?: Maybe<Array<ChatMessagesBoolExp>>;
  _not?: Maybe<ChatMessagesBoolExp>;
  _or?: Maybe<Array<ChatMessagesBoolExp>>;
  body?: Maybe<StringComparisonExp>;
  chat?: Maybe<ChatsBoolExp>;
  chat_id?: Maybe<UuidComparisonExp>;
  chat_message?: Maybe<ChatMessagesBoolExp>;
  chat_message_id?: Maybe<UuidComparisonExp>;
  chat_message_likes?: Maybe<ChatMessageLikesBoolExp>;
  chat_message_reads?: Maybe<ChatMessageReadsBoolExp>;
  chat_messages?: Maybe<ChatMessagesBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  files?: Maybe<FilesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  is_pinned?: Maybe<BooleanComparisonExp>;
  replys?: Maybe<ChatMessagesBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_messages" */
export const enum ChatMessagesConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
};

/** input type for inserting data into table "chat_messages" */
export interface ChatMessagesInsertInput {
  body?: Maybe<Scalars['String']>;
  chat?: Maybe<ChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message?: Maybe<ChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  chat_message_likes?: Maybe<ChatMessageLikesArrRelInsertInput>;
  chat_message_reads?: Maybe<ChatMessageReadsArrRelInsertInput>;
  chat_messages?: Maybe<ChatMessagesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface ChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_messages" */
export interface ChatMessagesMaxOrderBy {
  body?: Maybe<OrderBy>;
  chat_id?: Maybe<OrderBy>;
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface ChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_messages" */
export interface ChatMessagesMinOrderBy {
  body?: Maybe<OrderBy>;
  chat_id?: Maybe<OrderBy>;
  chat_message_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chat_messages" */
export interface ChatMessagesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChatMessages>>;
}

/** input type for inserting object relation for remote table "chat_messages" */
export interface ChatMessagesObjRelInsertInput {
  data: ChatMessagesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<ChatMessagesOnConflict>;
}

/** on conflict condition type for table "chat_messages" */
export interface ChatMessagesOnConflict {
  constraint: ChatMessagesConstraint;
  update_columns?: Array<ChatMessagesUpdateColumn>;
  where?: Maybe<ChatMessagesBoolExp>;
}

/** Ordering options when selecting data from "chat_messages". */
export interface ChatMessagesOrderBy {
  body?: Maybe<OrderBy>;
  chat?: Maybe<ChatsOrderBy>;
  chat_id?: Maybe<OrderBy>;
  chat_message?: Maybe<ChatMessagesOrderBy>;
  chat_message_id?: Maybe<OrderBy>;
  chat_message_likes_aggregate?: Maybe<ChatMessageLikesAggregateOrderBy>;
  chat_message_reads_aggregate?: Maybe<ChatMessageReadsAggregateOrderBy>;
  chat_messages_aggregate?: Maybe<ChatMessagesAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  files_aggregate?: Maybe<FilesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  is_pinned?: Maybe<OrderBy>;
  replys_aggregate?: Maybe<ChatMessagesAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: chat_messages */
export interface ChatMessagesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_messages" */
export const enum ChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_messages" */
export interface ChatMessagesSetInput {
  body?: Maybe<Scalars['String']>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_messages" */
export const enum ChatMessagesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned'
};

/** columns and relationships of "chat_type" */
export interface ChatType {
  /** An array relationship */
  chats: EntireFieldWrapper<Array<Chats>>;
  description: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chat_type" */
export interface ChatTypeChatsArgs {
  distinct_on?: Maybe<Array<ChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatsOrderBy>>;
  where?: Maybe<ChatsBoolExp>;
}

/** Boolean expression to filter rows from the table "chat_type". All fields are combined with a logical 'AND'. */
export interface ChatTypeBoolExp {
  _and?: Maybe<Array<ChatTypeBoolExp>>;
  _not?: Maybe<ChatTypeBoolExp>;
  _or?: Maybe<Array<ChatTypeBoolExp>>;
  chats?: Maybe<ChatsBoolExp>;
  description?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
}

export const enum ChatTypeEnum {
  /** Group conversation */
  GROUP = 'GROUP',
  /** Private conversation */
  PRIVATE = 'PRIVATE'
};

/** Boolean expression to compare columns of type "chat_type_enum". All fields are combined with logical 'AND'. */
export interface ChatTypeEnumComparisonExp {
  _eq?: Maybe<ChatTypeEnum>;
  _in?: Maybe<Array<ChatTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ChatTypeEnum>;
  _nin?: Maybe<Array<ChatTypeEnum>>;
}

/** Ordering options when selecting data from "chat_type". */
export interface ChatTypeOrderBy {
  chats_aggregate?: Maybe<ChatsAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
}

/** select columns of table "chat_type" */
export const enum ChatTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chat_user" */
export interface ChatUser {
  /** An object relationship */
  chat: EntireFieldWrapper<Chats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_user" */
export interface ChatUserAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChatUserMaxOrderBy>;
  min?: Maybe<ChatUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_user" */
export interface ChatUserArrRelInsertInput {
  data: Array<ChatUserInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_user". All fields are combined with a logical 'AND'. */
export interface ChatUserBoolExp {
  _and?: Maybe<Array<ChatUserBoolExp>>;
  _not?: Maybe<ChatUserBoolExp>;
  _or?: Maybe<Array<ChatUserBoolExp>>;
  chat?: Maybe<ChatsBoolExp>;
  chat_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** input type for inserting data into table "chat_user" */
export interface ChatUserInsertInput {
  chat?: Maybe<ChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "chat_user" */
export interface ChatUserMaxOrderBy {
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chat_user" */
export interface ChatUserMinOrderBy {
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chat_user" */
export interface ChatUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<ChatUser>>;
}

/** Ordering options when selecting data from "chat_user". */
export interface ChatUserOrderBy {
  chat?: Maybe<ChatsOrderBy>;
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "chat_user" */
export const enum ChatUserSelectColumn {
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chats" */
export interface Chats {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<ChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<ChatMessagesAggregate>;
  /** An object relationship */
  chat_type: EntireFieldWrapper<ChatType>;
  /** An array relationship */
  chat_users: EntireFieldWrapper<Array<ChatUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<ChatTypeEnum>;
  /** A computed field, executes function "unread_messages" */
  unread_messages?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chats" */
export interface ChatsChatMessagesArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface ChatsChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface ChatsChatUsersArgs {
  distinct_on?: Maybe<Array<ChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatUserOrderBy>>;
  where?: Maybe<ChatUserBoolExp>;
}

/** order by aggregate values of table "chats" */
export interface ChatsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ChatsMaxOrderBy>;
  min?: Maybe<ChatsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface ChatsBoolExp {
  _and?: Maybe<Array<ChatsBoolExp>>;
  _not?: Maybe<ChatsBoolExp>;
  _or?: Maybe<Array<ChatsBoolExp>>;
  avatar_url?: Maybe<StringComparisonExp>;
  chat_messages?: Maybe<ChatMessagesBoolExp>;
  chat_type?: Maybe<ChatTypeBoolExp>;
  chat_users?: Maybe<ChatUserBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  type?: Maybe<ChatTypeEnumComparisonExp>;
  unread_messages?: Maybe<BigintComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "chats" */
export const enum ChatsConstraint {
  /** unique or primary key constraint */
  CHATS_PKEY = 'chats_pkey'
};

/** input type for inserting data into table "chats" */
export interface ChatsInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  chat_messages?: Maybe<ChatMessagesArrRelInsertInput>;
  chat_users?: Maybe<ChatUserArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ChatTypeEnum>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chats" */
export interface ChatsMaxOrderBy {
  avatar_url?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "chats" */
export interface ChatsMinOrderBy {
  avatar_url?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "chats" */
export interface ChatsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Chats>>;
}

/** input type for inserting object relation for remote table "chats" */
export interface ChatsObjRelInsertInput {
  data: ChatsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<ChatsOnConflict>;
}

/** on conflict condition type for table "chats" */
export interface ChatsOnConflict {
  constraint: ChatsConstraint;
  update_columns?: Array<ChatsUpdateColumn>;
  where?: Maybe<ChatsBoolExp>;
}

/** Ordering options when selecting data from "chats". */
export interface ChatsOrderBy {
  avatar_url?: Maybe<OrderBy>;
  chat_messages_aggregate?: Maybe<ChatMessagesAggregateOrderBy>;
  chat_type?: Maybe<ChatTypeOrderBy>;
  chat_users_aggregate?: Maybe<ChatUserAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  unread_messages?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: chats */
export interface ChatsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chats" */
export const enum ChatsSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chats" */
export interface ChatsSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "chats" */
export const enum ChatsUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  TITLE = 'title'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface CitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}

/** columns and relationships of "class_levels" */
export interface ClassLevels {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<Classes>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  number: EntireFieldWrapper<Scalars['Int']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "class_levels" */
export interface ClassLevelsClassesArgs {
  distinct_on?: Maybe<Array<ClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassesOrderBy>>;
  where?: Maybe<ClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export interface ClassLevelsBoolExp {
  _and?: Maybe<Array<ClassLevelsBoolExp>>;
  _not?: Maybe<ClassLevelsBoolExp>;
  _or?: Maybe<Array<ClassLevelsBoolExp>>;
  classes?: Maybe<ClassesBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  number?: Maybe<IntComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "class_levels". */
export interface ClassLevelsOrderBy {
  classes_aggregate?: Maybe<ClassesAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "class_levels" */
export const enum ClassLevelsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "class_type" */
export interface ClassType {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<Classes>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "class_type" */
export interface ClassTypeClassesArgs {
  distinct_on?: Maybe<Array<ClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassesOrderBy>>;
  where?: Maybe<ClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_type". All fields are combined with a logical 'AND'. */
export interface ClassTypeBoolExp {
  _and?: Maybe<Array<ClassTypeBoolExp>>;
  _not?: Maybe<ClassTypeBoolExp>;
  _or?: Maybe<Array<ClassTypeBoolExp>>;
  classes?: Maybe<ClassesBoolExp>;
  description?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
}

export const enum ClassTypeEnum {
  C = 'C',
  GEISTESWISSENSCHAFTEN = 'Geisteswissenschaften',
  TECHNOLOGIE = 'Technologie'
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export interface ClassTypeEnumComparisonExp {
  _eq?: Maybe<ClassTypeEnum>;
  _in?: Maybe<Array<ClassTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<ClassTypeEnum>;
  _nin?: Maybe<Array<ClassTypeEnum>>;
}

/** Ordering options when selecting data from "class_type". */
export interface ClassTypeOrderBy {
  classes_aggregate?: Maybe<ClassesAggregateOrderBy>;
  description?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
}

/** select columns of table "class_type" */
export const enum ClassTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "classes" */
export interface Classes {
  /** An object relationship */
  class_type: EntireFieldWrapper<ClassType>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<CourseClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  identifier?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  level: EntireFieldWrapper<ClassLevels>;
  level_id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "class_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<Students>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentsAggregate>;
  /** An object relationship */
  teacher: EntireFieldWrapper<Teachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<ClassTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classes" */
export interface ClassesCourseClassesArgs {
  distinct_on?: Maybe<Array<CourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassOrderBy>>;
  where?: Maybe<CourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface ClassesStudentsArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}


/** columns and relationships of "classes" */
export interface ClassesStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}

/** order by aggregate values of table "classes" */
export interface ClassesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ClassesMaxOrderBy>;
  min?: Maybe<ClassesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export interface ClassesBoolExp {
  _and?: Maybe<Array<ClassesBoolExp>>;
  _not?: Maybe<ClassesBoolExp>;
  _or?: Maybe<Array<ClassesBoolExp>>;
  class_type?: Maybe<ClassTypeBoolExp>;
  course_classes?: Maybe<CourseClassBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  identifier?: Maybe<StringComparisonExp>;
  level?: Maybe<ClassLevelsBoolExp>;
  level_id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  students?: Maybe<StudentsBoolExp>;
  teacher?: Maybe<TeachersBoolExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
  type?: Maybe<ClassTypeEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "classes" */
export interface ClassesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  identifier?: Maybe<OrderBy>;
  level_id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "classes" */
export interface ClassesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  identifier?: Maybe<OrderBy>;
  level_id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "classes". */
export interface ClassesOrderBy {
  class_type?: Maybe<ClassTypeOrderBy>;
  course_classes_aggregate?: Maybe<CourseClassAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  identifier?: Maybe<OrderBy>;
  level?: Maybe<ClassLevelsOrderBy>;
  level_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  students_aggregate?: Maybe<StudentsAggregateOrderBy>;
  teacher?: Maybe<TeachersOrderBy>;
  teacher_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "classes" */
export const enum ClassesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IDENTIFIER = 'identifier',
  /** column name */
  LEVEL_ID = 'level_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "classrooms" */
export interface Classrooms {
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<CourseClassroom>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  floor: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<Lessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<LessonsAggregate>;
  name: EntireFieldWrapper<Scalars['String']>;
  room: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<Subjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<Teachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classrooms" */
export interface ClassroomsCourseClassroomsArgs {
  distinct_on?: Maybe<Array<CourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassroomOrderBy>>;
  where?: Maybe<CourseClassroomBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface ClassroomsLessonsArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface ClassroomsLessonsAggregateArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface ClassroomsTeachersArgs {
  distinct_on?: Maybe<Array<TeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachersOrderBy>>;
  where?: Maybe<TeachersBoolExp>;
}

/** order by aggregate values of table "classrooms" */
export interface ClassroomsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ClassroomsMaxOrderBy>;
  min?: Maybe<ClassroomsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export interface ClassroomsBoolExp {
  _and?: Maybe<Array<ClassroomsBoolExp>>;
  _not?: Maybe<ClassroomsBoolExp>;
  _or?: Maybe<Array<ClassroomsBoolExp>>;
  course_classrooms?: Maybe<CourseClassroomBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  floor?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  lessons?: Maybe<LessonsBoolExp>;
  name?: Maybe<StringComparisonExp>;
  room?: Maybe<StringComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  teachers?: Maybe<TeachersBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "classrooms" */
export interface ClassroomsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  floor?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  room?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "classrooms" */
export interface ClassroomsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  floor?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  room?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "classrooms". */
export interface ClassroomsOrderBy {
  course_classrooms_aggregate?: Maybe<CourseClassroomAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  floor?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lessons_aggregate?: Maybe<LessonsAggregateOrderBy>;
  name?: Maybe<OrderBy>;
  room?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  teachers_aggregate?: Maybe<TeachersAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "classrooms" */
export const enum ClassroomsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FLOOR = 'floor',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ROOM = 'room',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_class" */
export interface CourseClass {
  /** An object relationship */
  class: EntireFieldWrapper<Classes>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_class" */
export interface CourseClassAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<CourseClassMaxOrderBy>;
  min?: Maybe<CourseClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_class". All fields are combined with a logical 'AND'. */
export interface CourseClassBoolExp {
  _and?: Maybe<Array<CourseClassBoolExp>>;
  _not?: Maybe<CourseClassBoolExp>;
  _or?: Maybe<Array<CourseClassBoolExp>>;
  class?: Maybe<ClassesBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_class" */
export interface CourseClassMaxOrderBy {
  class_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "course_class" */
export interface CourseClassMinOrderBy {
  class_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "course_class". */
export interface CourseClassOrderBy {
  class?: Maybe<ClassesOrderBy>;
  class_id?: Maybe<OrderBy>;
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "course_class" */
export const enum CourseClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_classroom" */
export interface CourseClassroom {
  /** An object relationship */
  classroom: EntireFieldWrapper<Classrooms>;
  classroom_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_classroom" */
export interface CourseClassroomAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<CourseClassroomMaxOrderBy>;
  min?: Maybe<CourseClassroomMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_classroom". All fields are combined with a logical 'AND'. */
export interface CourseClassroomBoolExp {
  _and?: Maybe<Array<CourseClassroomBoolExp>>;
  _not?: Maybe<CourseClassroomBoolExp>;
  _or?: Maybe<Array<CourseClassroomBoolExp>>;
  classroom?: Maybe<ClassroomsBoolExp>;
  classroom_id?: Maybe<UuidComparisonExp>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_classroom" */
export interface CourseClassroomMaxOrderBy {
  classroom_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "course_classroom" */
export interface CourseClassroomMinOrderBy {
  classroom_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "course_classroom". */
export interface CourseClassroomOrderBy {
  classroom?: Maybe<ClassroomsOrderBy>;
  classroom_id?: Maybe<OrderBy>;
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "course_classroom" */
export const enum CourseClassroomSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_student" */
export interface CourseStudent {
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<Students>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_student" */
export interface CourseStudentAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<CourseStudentMaxOrderBy>;
  min?: Maybe<CourseStudentMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_student". All fields are combined with a logical 'AND'. */
export interface CourseStudentBoolExp {
  _and?: Maybe<Array<CourseStudentBoolExp>>;
  _not?: Maybe<CourseStudentBoolExp>;
  _or?: Maybe<Array<CourseStudentBoolExp>>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_student" */
export interface CourseStudentMaxOrderBy {
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "course_student" */
export interface CourseStudentMinOrderBy {
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "course_student". */
export interface CourseStudentOrderBy {
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "course_student" */
export const enum CourseStudentSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_teacher" */
export interface CourseTeacher {
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_primary: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<Teachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_teacher" */
export interface CourseTeacherAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<CourseTeacherMaxOrderBy>;
  min?: Maybe<CourseTeacherMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_teacher". All fields are combined with a logical 'AND'. */
export interface CourseTeacherBoolExp {
  _and?: Maybe<Array<CourseTeacherBoolExp>>;
  _not?: Maybe<CourseTeacherBoolExp>;
  _or?: Maybe<Array<CourseTeacherBoolExp>>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_primary?: Maybe<BooleanComparisonExp>;
  teacher?: Maybe<TeachersBoolExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_teacher" */
export interface CourseTeacherMaxOrderBy {
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "course_teacher" */
export interface CourseTeacherMinOrderBy {
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "course_teacher". */
export interface CourseTeacherOrderBy {
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_primary?: Maybe<OrderBy>;
  teacher?: Maybe<TeachersOrderBy>;
  teacher_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "course_teacher" */
export const enum CourseTeacherSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRIMARY = 'is_primary',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "courses" */
export interface Courses {
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<BookCourse>>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<CourseClass>>;
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<CourseClassroom>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<CourseTeacher>>;
  /** An array relationship */
  course_users: EntireFieldWrapper<Array<CourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_mandatory: EntireFieldWrapper<Scalars['Boolean']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<Lessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<LessonsAggregate>;
  /** An object relationship */
  semester: EntireFieldWrapper<Semesters>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<Subjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "courses" */
export interface CoursesBookCoursesArgs {
  distinct_on?: Maybe<Array<BookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookCourseOrderBy>>;
  where?: Maybe<BookCourseBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesCourseClassesArgs {
  distinct_on?: Maybe<Array<CourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassOrderBy>>;
  where?: Maybe<CourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesCourseClassroomsArgs {
  distinct_on?: Maybe<Array<CourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassroomOrderBy>>;
  where?: Maybe<CourseClassroomBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesCourseTeachersArgs {
  distinct_on?: Maybe<Array<CourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseTeacherOrderBy>>;
  where?: Maybe<CourseTeacherBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesCourseUsersArgs {
  distinct_on?: Maybe<Array<CourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseStudentOrderBy>>;
  where?: Maybe<CourseStudentBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesLessonsArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


/** columns and relationships of "courses" */
export interface CoursesLessonsAggregateArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}

/** order by aggregate values of table "courses" */
export interface CoursesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<CoursesMaxOrderBy>;
  min?: Maybe<CoursesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export interface CoursesBoolExp {
  _and?: Maybe<Array<CoursesBoolExp>>;
  _not?: Maybe<CoursesBoolExp>;
  _or?: Maybe<Array<CoursesBoolExp>>;
  book_courses?: Maybe<BookCourseBoolExp>;
  course_classes?: Maybe<CourseClassBoolExp>;
  course_classrooms?: Maybe<CourseClassroomBoolExp>;
  course_teachers?: Maybe<CourseTeacherBoolExp>;
  course_users?: Maybe<CourseStudentBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_everybody?: Maybe<BooleanComparisonExp>;
  is_mandatory?: Maybe<BooleanComparisonExp>;
  lessons?: Maybe<LessonsBoolExp>;
  semester?: Maybe<SemestersBoolExp>;
  semester_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "courses" */
export interface CoursesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "courses" */
export interface CoursesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "courses". */
export interface CoursesOrderBy {
  book_courses_aggregate?: Maybe<BookCourseAggregateOrderBy>;
  course_classes_aggregate?: Maybe<CourseClassAggregateOrderBy>;
  course_classrooms_aggregate?: Maybe<CourseClassroomAggregateOrderBy>;
  course_teachers_aggregate?: Maybe<CourseTeacherAggregateOrderBy>;
  course_users_aggregate?: Maybe<CourseStudentAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_everybody?: Maybe<OrderBy>;
  is_mandatory?: Maybe<OrderBy>;
  lessons_aggregate?: Maybe<LessonsAggregateOrderBy>;
  semester?: Maybe<SemestersOrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "courses" */
export const enum CoursesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_MANDATORY = 'is_mandatory',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface DateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** columns and relationships of "event_users" */
export interface EventUsers {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  event: EntireFieldWrapper<Events>;
  event_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  paid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export interface EventUsersBoolExp {
  _and?: Maybe<Array<EventUsersBoolExp>>;
  _not?: Maybe<EventUsersBoolExp>;
  _or?: Maybe<Array<EventUsersBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  event?: Maybe<EventsBoolExp>;
  event_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  paid?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "event_users". */
export interface EventUsersOrderBy {
  created_at?: Maybe<OrderBy>;
  event?: Maybe<EventsOrderBy>;
  event_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  paid?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "event_users" */
export const enum EventUsersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "events" */
export interface Events {
  cost: EntireFieldWrapper<Scalars['float8']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export interface EventsBoolExp {
  _and?: Maybe<Array<EventsBoolExp>>;
  _not?: Maybe<EventsBoolExp>;
  _or?: Maybe<Array<EventsBoolExp>>;
  cost?: Maybe<Float8ComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  date?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  time?: Maybe<IntComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "events". */
export interface EventsOrderBy {
  cost?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  date?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  time?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "events" */
export const enum EventsSelectColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

export const enum FileTableTypesEnum {
  ASSIGNMENT_SUBMITS = 'assignment_submits',
  ASSIGNMENTS = 'assignments',
  CHATS = 'chats',
  PROFILE_PICTURES = 'profile_pictures'
};

/** Boolean expression to compare columns of type "file_table_types_enum". All fields are combined with logical 'AND'. */
export interface FileTableTypesEnumComparisonExp {
  _eq?: Maybe<FileTableTypesEnum>;
  _in?: Maybe<Array<FileTableTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<FileTableTypesEnum>;
  _nin?: Maybe<Array<FileTableTypesEnum>>;
}

/** columns and relationships of "files" */
export interface Files {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  file_name: EntireFieldWrapper<Scalars['String']>;
  foreign_id: EntireFieldWrapper<Scalars['uuid']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  table: EntireFieldWrapper<FileTableTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "files" */
export interface FilesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<FilesMaxOrderBy>;
  min?: Maybe<FilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface FilesBoolExp {
  _and?: Maybe<Array<FilesBoolExp>>;
  _not?: Maybe<FilesBoolExp>;
  _or?: Maybe<Array<FilesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  file_name?: Maybe<StringComparisonExp>;
  foreign_id?: Maybe<UuidComparisonExp>;
  hash?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  table?: Maybe<FileTableTypesEnumComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "files" */
export interface FilesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  file_name?: Maybe<OrderBy>;
  foreign_id?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "files" */
export interface FilesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  file_name?: Maybe<OrderBy>;
  foreign_id?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** response of any mutation on the table "files" */
export interface FilesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Files>>;
}

/** Ordering options when selecting data from "files". */
export interface FilesOrderBy {
  created_at?: Maybe<OrderBy>;
  file_name?: Maybe<OrderBy>;
  foreign_id?: Maybe<OrderBy>;
  hash?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  table?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "files" */
export const enum FilesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE_NAME = 'file_name',
  /** column name */
  FOREIGN_ID = 'foreign_id',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TABLE = 'table',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface Float8ComparisonExp {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
}

/** columns and relationships of "grade_types" */
export interface GradeTypes {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<GradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<GradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<ViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<ViewGradesAggregate>;
}


/** columns and relationships of "grade_types" */
export interface GradeTypesGradeTypesArgs {
  distinct_on?: Maybe<Array<GradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradeTypesOrderBy>>;
  where?: Maybe<GradeTypesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface GradeTypesGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface GradeTypesGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface GradeTypesViewGradesArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface GradeTypesViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}

/** order by aggregate values of table "grade_types" */
export interface GradeTypesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<GradeTypesMaxOrderBy>;
  min?: Maybe<GradeTypesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "grade_types". All fields are combined with a logical 'AND'. */
export interface GradeTypesBoolExp {
  _and?: Maybe<Array<GradeTypesBoolExp>>;
  _not?: Maybe<GradeTypesBoolExp>;
  _or?: Maybe<Array<GradeTypesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grade_type?: Maybe<GradeTypesBoolExp>;
  grade_type_id?: Maybe<UuidComparisonExp>;
  grade_types?: Maybe<GradeTypesBoolExp>;
  grades?: Maybe<GradesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  view_grades?: Maybe<ViewGradesBoolExp>;
}

/** order by max() on columns of table "grade_types" */
export interface GradeTypesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "grade_types" */
export interface GradeTypesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "grade_types". */
export interface GradeTypesOrderBy {
  created_at?: Maybe<OrderBy>;
  grade_type?: Maybe<GradeTypesOrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  grade_types_aggregate?: Maybe<GradeTypesAggregateOrderBy>;
  grades_aggregate?: Maybe<GradesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  view_grades_aggregate?: Maybe<ViewGradesAggregateOrderBy>;
}

/** select columns of table "grade_types" */
export const enum GradeTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "grades" */
export interface Grades {
  /** An object relationship */
  assignment: EntireFieldWrapper<Assignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<GradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<Marks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student: EntireFieldWrapper<Students>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  weight: EntireFieldWrapper<Scalars['Int']>;
}

/** aggregated selection of "grades" */
export interface GradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<GradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Grades>>;
}

/** aggregate fields of "grades" */
export interface GradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<GradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<GradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<GradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<GradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<GradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<GradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<GradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<GradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<GradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<GradesVarianceFields>>;
}


/** aggregate fields of "grades" */
export interface GradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<GradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "grades" */
export interface GradesAggregateOrderBy {
  avg?: Maybe<GradesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<GradesMaxOrderBy>;
  min?: Maybe<GradesMinOrderBy>;
  stddev?: Maybe<GradesStddevOrderBy>;
  stddev_pop?: Maybe<GradesStddevPopOrderBy>;
  stddev_samp?: Maybe<GradesStddevSampOrderBy>;
  sum?: Maybe<GradesSumOrderBy>;
  var_pop?: Maybe<GradesVarPopOrderBy>;
  var_samp?: Maybe<GradesVarSampOrderBy>;
  variance?: Maybe<GradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface GradesAvgFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "grades" */
export interface GradesAvgOrderBy {
  weight?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "grades". All fields are combined with a logical 'AND'. */
export interface GradesBoolExp {
  _and?: Maybe<Array<GradesBoolExp>>;
  _not?: Maybe<GradesBoolExp>;
  _or?: Maybe<Array<GradesBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  comment?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grade_type?: Maybe<GradeTypesBoolExp>;
  grade_type_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  mark?: Maybe<MarksBoolExp>;
  mark_id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  weight?: Maybe<IntComparisonExp>;
}

/** aggregate max on columns */
export interface GradesMaxFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "grades" */
export interface GradesMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  mark_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface GradesMinFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "grades" */
export interface GradesMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  mark_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "grades". */
export interface GradesOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  grade_type?: Maybe<GradeTypesOrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  mark?: Maybe<MarksOrderBy>;
  mark_id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** select columns of table "grades" */
export const enum GradesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface GradesStddevFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "grades" */
export interface GradesStddevOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate stddev_pop on columns */
export interface GradesStddevPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "grades" */
export interface GradesStddevPopOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate stddev_samp on columns */
export interface GradesStddevSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "grades" */
export interface GradesStddevSampOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate sum on columns */
export interface GradesSumFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "grades" */
export interface GradesSumOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate var_pop on columns */
export interface GradesVarPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "grades" */
export interface GradesVarPopOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate var_samp on columns */
export interface GradesVarSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "grades" */
export interface GradesVarSampOrderBy {
  weight?: Maybe<OrderBy>;
}

/** aggregate variance on columns */
export interface GradesVarianceFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "grades" */
export interface GradesVarianceOrderBy {
  weight?: Maybe<OrderBy>;
}

/** columns and relationships of "latest_activities" */
export interface LatestActivities {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  message: EntireFieldWrapper<Scalars['String']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "latest_activities". All fields are combined with a logical 'AND'. */
export interface LatestActivitiesBoolExp {
  _and?: Maybe<Array<LatestActivitiesBoolExp>>;
  _not?: Maybe<LatestActivitiesBoolExp>;
  _or?: Maybe<Array<LatestActivitiesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  message?: Maybe<StringComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "latest_activities". */
export interface LatestActivitiesOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  message?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "latest_activities" */
export const enum LatestActivitiesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MESSAGE = 'message',
  /** column name */
  PATH = 'path',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lesson_attendace_type" */
export interface LessonAttendaceType {
  name: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "lesson_attendace_type". All fields are combined with a logical 'AND'. */
export interface LessonAttendaceTypeBoolExp {
  _and?: Maybe<Array<LessonAttendaceTypeBoolExp>>;
  _not?: Maybe<LessonAttendaceTypeBoolExp>;
  _or?: Maybe<Array<LessonAttendaceTypeBoolExp>>;
  name?: Maybe<StringComparisonExp>;
}

/** Ordering options when selecting data from "lesson_attendace_type". */
export interface LessonAttendaceTypeOrderBy {
  name?: Maybe<OrderBy>;
}

/** select columns of table "lesson_attendace_type" */
export const enum LessonAttendaceTypeSelectColumn {
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "lesson_attendances" */
export interface LessonAttendances {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  lesson: EntireFieldWrapper<Lessons>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "lesson_attendances" */
export interface LessonAttendancesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<LessonAttendancesMaxOrderBy>;
  min?: Maybe<LessonAttendancesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "lesson_attendances". All fields are combined with a logical 'AND'. */
export interface LessonAttendancesBoolExp {
  _and?: Maybe<Array<LessonAttendancesBoolExp>>;
  _not?: Maybe<LessonAttendancesBoolExp>;
  _or?: Maybe<Array<LessonAttendancesBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  lesson?: Maybe<LessonsBoolExp>;
  lesson_id?: Maybe<UuidComparisonExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "lesson_attendances" */
export interface LessonAttendancesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "lesson_attendances" */
export interface LessonAttendancesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "lesson_attendances". */
export interface LessonAttendancesOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson?: Maybe<LessonsOrderBy>;
  lesson_id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "lesson_attendances" */
export const enum LessonAttendancesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lessons" */
export interface Lessons {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  /** An array relationship */
  attendaces: EntireFieldWrapper<Array<LessonAttendances>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<Classrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  course: EntireFieldWrapper<Courses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_online: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_classes?: EntireFieldWrapper<Maybe<LiveClasses>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "lessons" */
export interface LessonsAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface LessonsAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface LessonsAttendacesArgs {
  distinct_on?: Maybe<Array<LessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonAttendancesOrderBy>>;
  where?: Maybe<LessonAttendancesBoolExp>;
}

/** aggregated selection of "lessons" */
export interface LessonsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<LessonsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Lessons>>;
}

/** aggregate fields of "lessons" */
export interface LessonsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<LessonsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<LessonsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<LessonsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<LessonsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<LessonsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<LessonsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<LessonsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<LessonsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<LessonsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<LessonsVarianceFields>>;
}


/** aggregate fields of "lessons" */
export interface LessonsAggregateFieldsCountArgs {
  columns?: Maybe<Array<LessonsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "lessons" */
export interface LessonsAggregateOrderBy {
  avg?: Maybe<LessonsAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<LessonsMaxOrderBy>;
  min?: Maybe<LessonsMinOrderBy>;
  stddev?: Maybe<LessonsStddevOrderBy>;
  stddev_pop?: Maybe<LessonsStddevPopOrderBy>;
  stddev_samp?: Maybe<LessonsStddevSampOrderBy>;
  sum?: Maybe<LessonsSumOrderBy>;
  var_pop?: Maybe<LessonsVarPopOrderBy>;
  var_samp?: Maybe<LessonsVarSampOrderBy>;
  variance?: Maybe<LessonsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface LessonsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "lessons" */
export interface LessonsAvgOrderBy {
  duration?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export interface LessonsBoolExp {
  _and?: Maybe<Array<LessonsBoolExp>>;
  _not?: Maybe<LessonsBoolExp>;
  _or?: Maybe<Array<LessonsBoolExp>>;
  assignments?: Maybe<AssignmentsBoolExp>;
  attendaces?: Maybe<LessonAttendancesBoolExp>;
  classroom?: Maybe<ClassroomsBoolExp>;
  classroom_id?: Maybe<UuidComparisonExp>;
  course?: Maybe<CoursesBoolExp>;
  course_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  duration?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_online?: Maybe<BooleanComparisonExp>;
  live_classes?: Maybe<LiveClassesBoolExp>;
  start_at?: Maybe<TimetzComparisonExp>;
  start_date?: Maybe<DateComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface LessonsMaxFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "lessons" */
export interface LessonsMaxOrderBy {
  classroom_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  start_at?: Maybe<OrderBy>;
  start_date?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface LessonsMinFields {
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  course_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "lessons" */
export interface LessonsMinOrderBy {
  classroom_id?: Maybe<OrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  start_at?: Maybe<OrderBy>;
  start_date?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "lessons". */
export interface LessonsOrderBy {
  assignments_aggregate?: Maybe<AssignmentsAggregateOrderBy>;
  attendaces_aggregate?: Maybe<LessonAttendancesAggregateOrderBy>;
  classroom?: Maybe<ClassroomsOrderBy>;
  classroom_id?: Maybe<OrderBy>;
  course?: Maybe<CoursesOrderBy>;
  course_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_online?: Maybe<OrderBy>;
  live_classes?: Maybe<LiveClassesOrderBy>;
  start_at?: Maybe<OrderBy>;
  start_date?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "lessons" */
export const enum LessonsSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ONLINE = 'is_online',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface LessonsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "lessons" */
export interface LessonsStddevOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate stddev_pop on columns */
export interface LessonsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "lessons" */
export interface LessonsStddevPopOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate stddev_samp on columns */
export interface LessonsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "lessons" */
export interface LessonsStddevSampOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate sum on columns */
export interface LessonsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "lessons" */
export interface LessonsSumOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate var_pop on columns */
export interface LessonsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "lessons" */
export interface LessonsVarPopOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate var_samp on columns */
export interface LessonsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "lessons" */
export interface LessonsVarSampOrderBy {
  duration?: Maybe<OrderBy>;
}

/** aggregate variance on columns */
export interface LessonsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "lessons" */
export interface LessonsVarianceOrderBy {
  duration?: Maybe<OrderBy>;
}

/** columns and relationships of "live_class_attendees" */
export interface LiveClassAttendees {
  group_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_present: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_class: EntireFieldWrapper<LiveClasses>;
  live_class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  students?: EntireFieldWrapper<Maybe<Students>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "live_class_attendees" */
export interface LiveClassAttendeesAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<LiveClassAttendeesMaxOrderBy>;
  min?: Maybe<LiveClassAttendeesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "live_class_attendees". All fields are combined with a logical 'AND'. */
export interface LiveClassAttendeesBoolExp {
  _and?: Maybe<Array<LiveClassAttendeesBoolExp>>;
  _not?: Maybe<LiveClassAttendeesBoolExp>;
  _or?: Maybe<Array<LiveClassAttendeesBoolExp>>;
  group_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_present?: Maybe<BooleanComparisonExp>;
  live_class?: Maybe<LiveClassesBoolExp>;
  live_class_id?: Maybe<UuidComparisonExp>;
  students?: Maybe<StudentsBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "live_class_attendees" */
export interface LiveClassAttendeesMaxOrderBy {
  group_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  live_class_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "live_class_attendees" */
export interface LiveClassAttendeesMinOrderBy {
  group_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  live_class_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "live_class_attendees". */
export interface LiveClassAttendeesOrderBy {
  group_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_present?: Maybe<OrderBy>;
  live_class?: Maybe<LiveClassesOrderBy>;
  live_class_id?: Maybe<OrderBy>;
  students?: Maybe<StudentsOrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "live_class_attendees" */
export const enum LiveClassAttendeesSelectColumn {
  /** column name */
  GROUP_ID = 'group_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRESENT = 'is_present',
  /** column name */
  LIVE_CLASS_ID = 'live_class_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "live_classes" */
export interface LiveClasses {
  attendeePW: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<LiveClassAttendees>>;
  meetingID: EntireFieldWrapper<Scalars['String']>;
  moderatorPW: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}


/** columns and relationships of "live_classes" */
export interface LiveClassesLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<LiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LiveClassAttendeesOrderBy>>;
  where?: Maybe<LiveClassAttendeesBoolExp>;
}

/** Boolean expression to filter rows from the table "live_classes". All fields are combined with a logical 'AND'. */
export interface LiveClassesBoolExp {
  _and?: Maybe<Array<LiveClassesBoolExp>>;
  _not?: Maybe<LiveClassesBoolExp>;
  _or?: Maybe<Array<LiveClassesBoolExp>>;
  attendeePW?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  description?: Maybe<StringComparisonExp>;
  duration?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  lesson_id?: Maybe<UuidComparisonExp>;
  live_class_attendees?: Maybe<LiveClassAttendeesBoolExp>;
  meetingID?: Maybe<StringComparisonExp>;
  moderatorPW?: Maybe<StringComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  recording_private_id?: Maybe<IntComparisonExp>;
  starting_at?: Maybe<TimestamptzComparisonExp>;
  status?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  voice_bridge?: Maybe<StringComparisonExp>;
}

/** Ordering options when selecting data from "live_classes". */
export interface LiveClassesOrderBy {
  attendeePW?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  description?: Maybe<OrderBy>;
  duration?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  live_class_attendees_aggregate?: Maybe<LiveClassAttendeesAggregateOrderBy>;
  meetingID?: Maybe<OrderBy>;
  moderatorPW?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  recording_private_id?: Maybe<OrderBy>;
  starting_at?: Maybe<OrderBy>;
  status?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  voice_bridge?: Maybe<OrderBy>;
}

/** select columns of table "live_classes" */
export const enum LiveClassesSelectColumn {
  /** column name */
  ATTENDEEPW = 'attendeePW',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  MEETINGID = 'meetingID',
  /** column name */
  MODERATORPW = 'moderatorPW',
  /** column name */
  NAME = 'name',
  /** column name */
  RECORDING_PRIVATE_ID = 'recording_private_id',
  /** column name */
  STARTING_AT = 'starting_at',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VOICE_BRIDGE = 'voice_bridge'
};

/** columns and relationships of "marks" */
export interface Marks {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  value: EntireFieldWrapper<Scalars['Int']>;
}


/** columns and relationships of "marks" */
export interface MarksGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


/** columns and relationships of "marks" */
export interface MarksGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}

/** Boolean expression to filter rows from the table "marks". All fields are combined with a logical 'AND'. */
export interface MarksBoolExp {
  _and?: Maybe<Array<MarksBoolExp>>;
  _not?: Maybe<MarksBoolExp>;
  _or?: Maybe<Array<MarksBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grades?: Maybe<GradesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  value?: Maybe<IntComparisonExp>;
}

/** Ordering options when selecting data from "marks". */
export interface MarksOrderBy {
  created_at?: Maybe<OrderBy>;
  grades_aggregate?: Maybe<GradesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
}

/** select columns of table "marks" */
export const enum MarksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "meeting_user" */
export interface MeetingUser {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  meeting_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "meeting_user" */
export interface MeetingUserAggregate {
  aggregate?: EntireFieldWrapper<Maybe<MeetingUserAggregateFields>>;
  nodes: EntireFieldWrapper<Array<MeetingUser>>;
}

/** aggregate fields of "meeting_user" */
export interface MeetingUserAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<MeetingUserMaxFields>>;
  min?: EntireFieldWrapper<Maybe<MeetingUserMinFields>>;
}


/** aggregate fields of "meeting_user" */
export interface MeetingUserAggregateFieldsCountArgs {
  columns?: Maybe<Array<MeetingUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "meeting_user". All fields are combined with a logical 'AND'. */
export interface MeetingUserBoolExp {
  _and?: Maybe<Array<MeetingUserBoolExp>>;
  _not?: Maybe<MeetingUserBoolExp>;
  _or?: Maybe<Array<MeetingUserBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  meeting_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** aggregate max on columns */
export interface MeetingUserMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface MeetingUserMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "meeting_user". */
export interface MeetingUserOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  meeting_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "meeting_user" */
export const enum MeetingUserSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MEETING_ID = 'meeting_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** mutation root */
export interface MutationRoot {
  change_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  /** delete data from the table: "assignment_discussion" */
  delete_assignment_discussion?: EntireFieldWrapper<Maybe<AssignmentDiscussionMutationResponse>>;
  /** delete single row from the table: "assignment_discussion" */
  delete_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussion>>;
  /** delete data from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content?: EntireFieldWrapper<Maybe<AssignmentDiscussionContentMutationResponse>>;
  /** delete single row from the table: "assignment_discussion_content" */
  delete_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** delete data from the table: "assignment_files" */
  delete_assignment_files?: EntireFieldWrapper<Maybe<AssignmentFilesMutationResponse>>;
  /** delete single row from the table: "assignment_files" */
  delete_assignment_files_by_pk?: EntireFieldWrapper<Maybe<AssignmentFiles>>;
  /** delete data from the table: "assignment_notes" */
  delete_assignment_notes?: EntireFieldWrapper<Maybe<AssignmentNotesMutationResponse>>;
  /** delete single row from the table: "assignment_notes" */
  delete_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<AssignmentNotes>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** delete data from the table: "chapter_section_notes" */
  delete_chapter_section_notes?: EntireFieldWrapper<Maybe<ChapterSectionNotesMutationResponse>>;
  /** delete single row from the table: "chapter_section_notes" */
  delete_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionNotes>>;
  /** delete data from the table: "chapter_section_submits" */
  delete_chapter_section_submits?: EntireFieldWrapper<Maybe<ChapterSectionSubmitsMutationResponse>>;
  /** delete single row from the table: "chapter_section_submits" */
  delete_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionSubmits>>;
  /** delete data from the table: "chat_message_likes" */
  delete_chat_message_likes?: EntireFieldWrapper<Maybe<ChatMessageLikesMutationResponse>>;
  /** delete single row from the table: "chat_message_likes" */
  delete_chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<ChatMessageLikes>>;
  /** delete data from the table: "chat_messages" */
  delete_chat_messages?: EntireFieldWrapper<Maybe<ChatMessagesMutationResponse>>;
  /** delete single row from the table: "chat_messages" */
  delete_chat_messages_by_pk?: EntireFieldWrapper<Maybe<ChatMessages>>;
  /** delete data from the table: "chats" */
  delete_chats?: EntireFieldWrapper<Maybe<ChatsMutationResponse>>;
  /** delete single row from the table: "chats" */
  delete_chats_by_pk?: EntireFieldWrapper<Maybe<Chats>>;
  /** delete data from the table: "files" */
  delete_files?: EntireFieldWrapper<Maybe<FilesMutationResponse>>;
  /** delete single row from the table: "files" */
  delete_files_by_pk?: EntireFieldWrapper<Maybe<Files>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** delete data from the table: "tasks" */
  delete_tasks?: EntireFieldWrapper<Maybe<TasksMutationResponse>>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: EntireFieldWrapper<Maybe<Tasks>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
  /** insert data into the table: "assignment_discussion" */
  insert_assignment_discussion?: EntireFieldWrapper<Maybe<AssignmentDiscussionMutationResponse>>;
  /** insert data into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content?: EntireFieldWrapper<Maybe<AssignmentDiscussionContentMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_content" */
  insert_assignment_discussion_content_one?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** insert a single row into the table: "assignment_discussion" */
  insert_assignment_discussion_one?: EntireFieldWrapper<Maybe<AssignmentDiscussion>>;
  /** insert data into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscriptionMutationResponse>>;
  /** insert a single row into the table: "assignment_discussion_subscription" */
  insert_assignment_discussion_subscription_one?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscription>>;
  /** insert data into the table: "assignment_files" */
  insert_assignment_files?: EntireFieldWrapper<Maybe<AssignmentFilesMutationResponse>>;
  /** insert a single row into the table: "assignment_files" */
  insert_assignment_files_one?: EntireFieldWrapper<Maybe<AssignmentFiles>>;
  /** insert data into the table: "assignment_notes" */
  insert_assignment_notes?: EntireFieldWrapper<Maybe<AssignmentNotesMutationResponse>>;
  /** insert a single row into the table: "assignment_notes" */
  insert_assignment_notes_one?: EntireFieldWrapper<Maybe<AssignmentNotes>>;
  /** insert data into the table: "assignment_question_answers" */
  insert_assignment_question_answers?: EntireFieldWrapper<Maybe<AssignmentQuestionAnswersMutationResponse>>;
  /** insert a single row into the table: "assignment_question_answers" */
  insert_assignment_question_answers_one?: EntireFieldWrapper<Maybe<AssignmentQuestionAnswers>>;
  /** insert data into the table: "assignment_submits" */
  insert_assignment_submits?: EntireFieldWrapper<Maybe<AssignmentSubmitsMutationResponse>>;
  /** insert a single row into the table: "assignment_submits" */
  insert_assignment_submits_one?: EntireFieldWrapper<Maybe<AssignmentSubmits>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** insert data into the table: "chapter_section_notes" */
  insert_chapter_section_notes?: EntireFieldWrapper<Maybe<ChapterSectionNotesMutationResponse>>;
  /** insert a single row into the table: "chapter_section_notes" */
  insert_chapter_section_notes_one?: EntireFieldWrapper<Maybe<ChapterSectionNotes>>;
  /** insert data into the table: "chapter_section_submits" */
  insert_chapter_section_submits?: EntireFieldWrapper<Maybe<ChapterSectionSubmitsMutationResponse>>;
  /** insert a single row into the table: "chapter_section_submits" */
  insert_chapter_section_submits_one?: EntireFieldWrapper<Maybe<ChapterSectionSubmits>>;
  /** insert data into the table: "chat_message_likes" */
  insert_chat_message_likes?: EntireFieldWrapper<Maybe<ChatMessageLikesMutationResponse>>;
  /** insert a single row into the table: "chat_message_likes" */
  insert_chat_message_likes_one?: EntireFieldWrapper<Maybe<ChatMessageLikes>>;
  /** insert data into the table: "chat_message_reads" */
  insert_chat_message_reads?: EntireFieldWrapper<Maybe<ChatMessageReadsMutationResponse>>;
  /** insert a single row into the table: "chat_message_reads" */
  insert_chat_message_reads_one?: EntireFieldWrapper<Maybe<ChatMessageReads>>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: EntireFieldWrapper<Maybe<ChatMessagesMutationResponse>>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: EntireFieldWrapper<Maybe<ChatMessages>>;
  /** insert data into the table: "chat_user" */
  insert_chat_user?: EntireFieldWrapper<Maybe<ChatUserMutationResponse>>;
  /** insert a single row into the table: "chat_user" */
  insert_chat_user_one?: EntireFieldWrapper<Maybe<ChatUser>>;
  /** insert data into the table: "chats" */
  insert_chats?: EntireFieldWrapper<Maybe<ChatsMutationResponse>>;
  /** insert a single row into the table: "chats" */
  insert_chats_one?: EntireFieldWrapper<Maybe<Chats>>;
  /** insert data into the table: "notifications" */
  insert_notifications?: EntireFieldWrapper<Maybe<NotificationsMutationResponse>>;
  /** insert a single row into the table: "notifications" */
  insert_notifications_one?: EntireFieldWrapper<Maybe<Notifications>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<Relationships>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<Schools>>;
  /** insert data into the table: "tasks" */
  insert_tasks?: EntireFieldWrapper<Maybe<TasksMutationResponse>>;
  /** insert a single row into the table: "tasks" */
  insert_tasks_one?: EntireFieldWrapper<Maybe<Tasks>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<Users>>;
  lost_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<Session>>;
  reset_password?: EntireFieldWrapper<Maybe<MessageResponse>>;
  revoke_token?: EntireFieldWrapper<Maybe<MessageResponse>>;
  studentJoin?: EntireFieldWrapper<Maybe<BbbJoinLink>>;
  /** update data of the table: "assignment_discussion" */
  update_assignment_discussion?: EntireFieldWrapper<Maybe<AssignmentDiscussionMutationResponse>>;
  /** update single row of the table: "assignment_discussion" */
  update_assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussion>>;
  /** update data of the table: "assignment_discussion_content" */
  update_assignment_discussion_content?: EntireFieldWrapper<Maybe<AssignmentDiscussionContentMutationResponse>>;
  /** update single row of the table: "assignment_discussion_content" */
  update_assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** update data of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscriptionMutationResponse>>;
  /** update single row of the table: "assignment_discussion_subscription" */
  update_assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscription>>;
  /** update data of the table: "assignment_notes" */
  update_assignment_notes?: EntireFieldWrapper<Maybe<AssignmentNotesMutationResponse>>;
  /** update single row of the table: "assignment_notes" */
  update_assignment_notes_by_pk?: EntireFieldWrapper<Maybe<AssignmentNotes>>;
  /** update data of the table: "assignment_submits" */
  update_assignment_submits?: EntireFieldWrapper<Maybe<AssignmentSubmitsMutationResponse>>;
  /** update single row of the table: "assignment_submits" */
  update_assignment_submits_by_pk?: EntireFieldWrapper<Maybe<AssignmentSubmits>>;
  /** update data of the table: "assignment_user" */
  update_assignment_user?: EntireFieldWrapper<Maybe<AssignmentUserMutationResponse>>;
  /** update single row of the table: "assignment_user" */
  update_assignment_user_by_pk?: EntireFieldWrapper<Maybe<AssignmentUser>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<AuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<AuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<AuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<AuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<AuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<AuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** update data of the table: "chapter_section_notes" */
  update_chapter_section_notes?: EntireFieldWrapper<Maybe<ChapterSectionNotesMutationResponse>>;
  /** update single row of the table: "chapter_section_notes" */
  update_chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionNotes>>;
  /** update data of the table: "chapter_section_submits" */
  update_chapter_section_submits?: EntireFieldWrapper<Maybe<ChapterSectionSubmitsMutationResponse>>;
  /** update single row of the table: "chapter_section_submits" */
  update_chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionSubmits>>;
  /** update data of the table: "chat_message_reads" */
  update_chat_message_reads?: EntireFieldWrapper<Maybe<ChatMessageReadsMutationResponse>>;
  /** update single row of the table: "chat_message_reads" */
  update_chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<ChatMessageReads>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: EntireFieldWrapper<Maybe<ChatMessagesMutationResponse>>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: EntireFieldWrapper<Maybe<ChatMessages>>;
  /** update data of the table: "chats" */
  update_chats?: EntireFieldWrapper<Maybe<ChatsMutationResponse>>;
  /** update single row of the table: "chats" */
  update_chats_by_pk?: EntireFieldWrapper<Maybe<Chats>>;
  /** update data of the table: "notifications" */
  update_notifications?: EntireFieldWrapper<Maybe<NotificationsMutationResponse>>;
  /** update single row of the table: "notifications" */
  update_notifications_by_pk?: EntireFieldWrapper<Maybe<Notifications>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<PrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<PrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<RelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<SchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<SchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** update data of the table: "tasks" */
  update_tasks?: EntireFieldWrapper<Maybe<TasksMutationResponse>>;
  /** update single row of the table: "tasks" */
  update_tasks_by_pk?: EntireFieldWrapper<Maybe<Tasks>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<UsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
}


/** mutation root */
export interface MutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeleteAssignmentDiscussionArgs {
  where: AssignmentDiscussionBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAssignmentDiscussionContentArgs {
  where: AssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAssignmentFilesArgs {
  where: AssignmentFilesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAssignmentNotesArgs {
  where: AssignmentNotesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountProvidersArgs {
  where: AuthAccountProvidersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountRolesArgs {
  where: AuthAccountRolesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthAccountsArgs {
  where: AuthAccountsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthProvidersArgs {
  where: AuthProvidersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeleteAuthRefreshTokensArgs {
  where: AuthRefreshTokensBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteAuthRolesArgs {
  where: AuthRolesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface MutationRootDeleteChapterSectionNotesArgs {
  where: ChapterSectionNotesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteChapterSectionSubmitsArgs {
  where: ChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteChatMessageLikesArgs {
  where: ChatMessageLikesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteChatMessagesArgs {
  where: ChatMessagesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteChatsArgs {
  where: ChatsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteChatsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteFilesArgs {
  where: FilesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteFilesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivateAdressesArgs {
  where: PrivateAdressesBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivateBirthdaysArgs {
  where: PrivateBirthdaysBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivateInsuranceNumbersArgs {
  where: PrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeletePrivatePhoneNumbersArgs {
  where: PrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface MutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteRelationshipsArgs {
  where: RelationshipsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsArgs {
  where: SchoolSettingsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsModulesArgs {
  where: SchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteSchoolsArgs {
  where: SchoolsBoolExp;
}


/** mutation root */
export interface MutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteTasksArgs {
  where: TasksBoolExp;
}


/** mutation root */
export interface MutationRootDeleteTasksByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootDeleteUsersArgs {
  where: UsersBoolExp;
}


/** mutation root */
export interface MutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionArgs {
  objects: Array<AssignmentDiscussionInsertInput>;
  on_conflict?: Maybe<AssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionContentArgs {
  objects: Array<AssignmentDiscussionContentInsertInput>;
  on_conflict?: Maybe<AssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionContentOneArgs {
  object: AssignmentDiscussionContentInsertInput;
  on_conflict?: Maybe<AssignmentDiscussionContentOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionOneArgs {
  object: AssignmentDiscussionInsertInput;
  on_conflict?: Maybe<AssignmentDiscussionOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionSubscriptionArgs {
  objects: Array<AssignmentDiscussionSubscriptionInsertInput>;
  on_conflict?: Maybe<AssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentDiscussionSubscriptionOneArgs {
  object: AssignmentDiscussionSubscriptionInsertInput;
  on_conflict?: Maybe<AssignmentDiscussionSubscriptionOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentFilesArgs {
  objects: Array<AssignmentFilesInsertInput>;
}


/** mutation root */
export interface MutationRootInsertAssignmentFilesOneArgs {
  object: AssignmentFilesInsertInput;
}


/** mutation root */
export interface MutationRootInsertAssignmentNotesArgs {
  objects: Array<AssignmentNotesInsertInput>;
  on_conflict?: Maybe<AssignmentNotesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentNotesOneArgs {
  object: AssignmentNotesInsertInput;
  on_conflict?: Maybe<AssignmentNotesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentQuestionAnswersArgs {
  objects: Array<AssignmentQuestionAnswersInsertInput>;
}


/** mutation root */
export interface MutationRootInsertAssignmentQuestionAnswersOneArgs {
  object: AssignmentQuestionAnswersInsertInput;
}


/** mutation root */
export interface MutationRootInsertAssignmentSubmitsArgs {
  objects: Array<AssignmentSubmitsInsertInput>;
  on_conflict?: Maybe<AssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAssignmentSubmitsOneArgs {
  object: AssignmentSubmitsInsertInput;
  on_conflict?: Maybe<AssignmentSubmitsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountProvidersArgs {
  objects: Array<AuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountProvidersOneArgs {
  object: AuthAccountProvidersInsertInput;
  on_conflict?: Maybe<AuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountRolesArgs {
  objects: Array<AuthAccountRolesInsertInput>;
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountRolesOneArgs {
  object: AuthAccountRolesInsertInput;
  on_conflict?: Maybe<AuthAccountRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountsArgs {
  objects: Array<AuthAccountsInsertInput>;
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthAccountsOneArgs {
  object: AuthAccountsInsertInput;
  on_conflict?: Maybe<AuthAccountsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthProvidersArgs {
  objects: Array<AuthProvidersInsertInput>;
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthProvidersOneArgs {
  object: AuthProvidersInsertInput;
  on_conflict?: Maybe<AuthProvidersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRefreshTokensArgs {
  objects: Array<AuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRefreshTokensOneArgs {
  object: AuthRefreshTokensInsertInput;
  on_conflict?: Maybe<AuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRolesArgs {
  objects: Array<AuthRolesInsertInput>;
  on_conflict?: Maybe<AuthRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertAuthRolesOneArgs {
  object: AuthRolesInsertInput;
  on_conflict?: Maybe<AuthRolesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChapterSectionNotesArgs {
  objects: Array<ChapterSectionNotesInsertInput>;
  on_conflict?: Maybe<ChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChapterSectionNotesOneArgs {
  object: ChapterSectionNotesInsertInput;
  on_conflict?: Maybe<ChapterSectionNotesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChapterSectionSubmitsArgs {
  objects: Array<ChapterSectionSubmitsInsertInput>;
  on_conflict?: Maybe<ChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChapterSectionSubmitsOneArgs {
  object: ChapterSectionSubmitsInsertInput;
  on_conflict?: Maybe<ChapterSectionSubmitsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatMessageLikesArgs {
  objects: Array<ChatMessageLikesInsertInput>;
}


/** mutation root */
export interface MutationRootInsertChatMessageLikesOneArgs {
  object: ChatMessageLikesInsertInput;
}


/** mutation root */
export interface MutationRootInsertChatMessageReadsArgs {
  objects: Array<ChatMessageReadsInsertInput>;
  on_conflict?: Maybe<ChatMessageReadsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatMessageReadsOneArgs {
  object: ChatMessageReadsInsertInput;
  on_conflict?: Maybe<ChatMessageReadsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatMessagesArgs {
  objects: Array<ChatMessagesInsertInput>;
  on_conflict?: Maybe<ChatMessagesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatMessagesOneArgs {
  object: ChatMessagesInsertInput;
  on_conflict?: Maybe<ChatMessagesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatUserArgs {
  objects: Array<ChatUserInsertInput>;
}


/** mutation root */
export interface MutationRootInsertChatUserOneArgs {
  object: ChatUserInsertInput;
}


/** mutation root */
export interface MutationRootInsertChatsArgs {
  objects: Array<ChatsInsertInput>;
  on_conflict?: Maybe<ChatsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertChatsOneArgs {
  object: ChatsInsertInput;
  on_conflict?: Maybe<ChatsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertNotificationsArgs {
  objects: Array<NotificationsInsertInput>;
  on_conflict?: Maybe<NotificationsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertNotificationsOneArgs {
  object: NotificationsInsertInput;
  on_conflict?: Maybe<NotificationsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateAdressesArgs {
  objects: Array<PrivateAdressesInsertInput>;
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateAdressesOneArgs {
  object: PrivateAdressesInsertInput;
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateBirthdaysArgs {
  objects: Array<PrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateBirthdaysOneArgs {
  object: PrivateBirthdaysInsertInput;
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<PrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: PrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<PrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertPrivatePhoneNumbersOneArgs {
  object: PrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertRelationshipsArgs {
  objects: Array<RelationshipsInsertInput>;
  on_conflict?: Maybe<RelationshipsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertRelationshipsOneArgs {
  object: RelationshipsInsertInput;
  on_conflict?: Maybe<RelationshipsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsArgs {
  objects: Array<SchoolSettingsInsertInput>;
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<SchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsModulesOneArgs {
  object: SchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolSettingsOneArgs {
  object: SchoolSettingsInsertInput;
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolsArgs {
  objects: Array<SchoolsInsertInput>;
  on_conflict?: Maybe<SchoolsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertSchoolsOneArgs {
  object: SchoolsInsertInput;
  on_conflict?: Maybe<SchoolsOnConflict>;
}


/** mutation root */
export interface MutationRootInsertTasksArgs {
  objects: Array<TasksInsertInput>;
  on_conflict?: Maybe<TasksOnConflict>;
}


/** mutation root */
export interface MutationRootInsertTasksOneArgs {
  object: TasksInsertInput;
  on_conflict?: Maybe<TasksOnConflict>;
}


/** mutation root */
export interface MutationRootInsertUsersArgs {
  objects: Array<UsersInsertInput>;
  on_conflict?: Maybe<UsersOnConflict>;
}


/** mutation root */
export interface MutationRootInsertUsersOneArgs {
  object: UsersInsertInput;
  on_conflict?: Maybe<UsersOnConflict>;
}


/** mutation root */
export interface MutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface MutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface MutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface MutationRootRevokeTokenArgs {
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface MutationRootStudentJoinArgs {
  meeting_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionArgs {
  _set?: Maybe<AssignmentDiscussionSetInput>;
  where: AssignmentDiscussionBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionByPkArgs {
  _set?: Maybe<AssignmentDiscussionSetInput>;
  pk_columns: AssignmentDiscussionPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionContentArgs {
  _set?: Maybe<AssignmentDiscussionContentSetInput>;
  where: AssignmentDiscussionContentBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionContentByPkArgs {
  _set?: Maybe<AssignmentDiscussionContentSetInput>;
  pk_columns: AssignmentDiscussionContentPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionSubscriptionArgs {
  _set?: Maybe<AssignmentDiscussionSubscriptionSetInput>;
  where: AssignmentDiscussionSubscriptionBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentDiscussionSubscriptionByPkArgs {
  _set?: Maybe<AssignmentDiscussionSubscriptionSetInput>;
  pk_columns: AssignmentDiscussionSubscriptionPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAssignmentNotesArgs {
  _set?: Maybe<AssignmentNotesSetInput>;
  where: AssignmentNotesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentNotesByPkArgs {
  _set?: Maybe<AssignmentNotesSetInput>;
  pk_columns: AssignmentNotesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAssignmentSubmitsArgs {
  _set?: Maybe<AssignmentSubmitsSetInput>;
  where: AssignmentSubmitsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentSubmitsByPkArgs {
  _set?: Maybe<AssignmentSubmitsSetInput>;
  pk_columns: AssignmentSubmitsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAssignmentUserArgs {
  _set?: Maybe<AssignmentUserSetInput>;
  where: AssignmentUserBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAssignmentUserByPkArgs {
  _set?: Maybe<AssignmentUserSetInput>;
  pk_columns: AssignmentUserPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<AuthAccountProvidersSetInput>;
  where: AuthAccountProvidersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<AuthAccountProvidersSetInput>;
  pk_columns: AuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<AuthAccountRolesSetInput>;
  where: AuthAccountRolesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<AuthAccountRolesSetInput>;
  pk_columns: AuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<AuthAccountsSetInput>;
  where: AuthAccountsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<AuthAccountsSetInput>;
  pk_columns: AuthAccountsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<AuthProvidersSetInput>;
  where: AuthProvidersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<AuthProvidersSetInput>;
  pk_columns: AuthProvidersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<AuthRefreshTokensSetInput>;
  where: AuthRefreshTokensBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<AuthRefreshTokensSetInput>;
  pk_columns: AuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateAuthRolesArgs {
  _set?: Maybe<AuthRolesSetInput>;
  where: AuthRolesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<AuthRolesSetInput>;
  pk_columns: AuthRolesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateChapterSectionNotesArgs {
  _set?: Maybe<ChapterSectionNotesSetInput>;
  where: ChapterSectionNotesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateChapterSectionNotesByPkArgs {
  _set?: Maybe<ChapterSectionNotesSetInput>;
  pk_columns: ChapterSectionNotesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateChapterSectionSubmitsArgs {
  _inc?: Maybe<ChapterSectionSubmitsIncInput>;
  _set?: Maybe<ChapterSectionSubmitsSetInput>;
  where: ChapterSectionSubmitsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateChapterSectionSubmitsByPkArgs {
  _inc?: Maybe<ChapterSectionSubmitsIncInput>;
  _set?: Maybe<ChapterSectionSubmitsSetInput>;
  pk_columns: ChapterSectionSubmitsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateChatMessageReadsArgs {
  _set?: Maybe<ChatMessageReadsSetInput>;
  where: ChatMessageReadsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateChatMessageReadsByPkArgs {
  _set?: Maybe<ChatMessageReadsSetInput>;
  pk_columns: ChatMessageReadsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateChatMessagesArgs {
  _set?: Maybe<ChatMessagesSetInput>;
  where: ChatMessagesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateChatMessagesByPkArgs {
  _set?: Maybe<ChatMessagesSetInput>;
  pk_columns: ChatMessagesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateChatsArgs {
  _set?: Maybe<ChatsSetInput>;
  where: ChatsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateChatsByPkArgs {
  _set?: Maybe<ChatsSetInput>;
  pk_columns: ChatsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateNotificationsArgs {
  _set?: Maybe<NotificationsSetInput>;
  where: NotificationsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateNotificationsByPkArgs {
  _set?: Maybe<NotificationsSetInput>;
  pk_columns: NotificationsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<PrivateAdressesSetInput>;
  where: PrivateAdressesBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<PrivateAdressesSetInput>;
  pk_columns: PrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<PrivateBirthdaysSetInput>;
  where: PrivateBirthdaysBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<PrivateBirthdaysSetInput>;
  pk_columns: PrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<PrivateInsuranceNumbersSetInput>;
  where: PrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<PrivateInsuranceNumbersSetInput>;
  pk_columns: PrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<PrivatePhoneNumbersSetInput>;
  where: PrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface MutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<PrivatePhoneNumbersSetInput>;
  pk_columns: PrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateRelationshipsArgs {
  _set?: Maybe<RelationshipsSetInput>;
  where: RelationshipsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<RelationshipsSetInput>;
  pk_columns: RelationshipsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<SchoolSettingsSetInput>;
  where: SchoolSettingsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<SchoolSettingsSetInput>;
  pk_columns: SchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<SchoolSettingsModulesSetInput>;
  where: SchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<SchoolSettingsModulesSetInput>;
  pk_columns: SchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateSchoolsArgs {
  _set?: Maybe<SchoolsSetInput>;
  where: SchoolsBoolExp;
}


/** mutation root */
export interface MutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<SchoolsSetInput>;
  pk_columns: SchoolsPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateTasksArgs {
  _set?: Maybe<TasksSetInput>;
  where: TasksBoolExp;
}


/** mutation root */
export interface MutationRootUpdateTasksByPkArgs {
  _set?: Maybe<TasksSetInput>;
  pk_columns: TasksPkColumnsInput;
}


/** mutation root */
export interface MutationRootUpdateUsersArgs {
  _set?: Maybe<UsersSetInput>;
  where: UsersBoolExp;
}


/** mutation root */
export interface MutationRootUpdateUsersByPkArgs {
  _set?: Maybe<UsersSetInput>;
  pk_columns: UsersPkColumnsInput;
}

/** columns and relationships of "notifications" */
export interface Notifications {
  content: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "notifications" */
export interface NotificationsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<NotificationsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Notifications>>;
}

/** aggregate fields of "notifications" */
export interface NotificationsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<NotificationsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<NotificationsMinFields>>;
}


/** aggregate fields of "notifications" */
export interface NotificationsAggregateFieldsCountArgs {
  columns?: Maybe<Array<NotificationsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "notifications". All fields are combined with a logical 'AND'. */
export interface NotificationsBoolExp {
  _and?: Maybe<Array<NotificationsBoolExp>>;
  _not?: Maybe<NotificationsBoolExp>;
  _or?: Maybe<Array<NotificationsBoolExp>>;
  content?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_read?: Maybe<BooleanComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "notifications" */
export const enum NotificationsConstraint {
  /** unique or primary key constraint */
  NOTIFICATIONS_PKEY = 'notifications_pkey'
};

/** input type for inserting data into table "notifications" */
export interface NotificationsInsertInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface NotificationsMaxFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface NotificationsMinFields {
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "notifications" */
export interface NotificationsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Notifications>>;
}

/** on conflict condition type for table "notifications" */
export interface NotificationsOnConflict {
  constraint: NotificationsConstraint;
  update_columns?: Array<NotificationsUpdateColumn>;
  where?: Maybe<NotificationsBoolExp>;
}

/** Ordering options when selecting data from "notifications". */
export interface NotificationsOrderBy {
  content?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_read?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: notifications */
export interface NotificationsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "notifications" */
export const enum NotificationsSelectColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "notifications" */
export interface NotificationsSetInput {
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "notifications" */
export const enum NotificationsUpdateColumn {
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  PATH = 'path',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface NumericComparisonExp {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
}

/** column ordering options */
export const enum OrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "parents" */
export interface Parents {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "parents". All fields are combined with a logical 'AND'. */
export interface ParentsBoolExp {
  _and?: Maybe<Array<ParentsBoolExp>>;
  _not?: Maybe<ParentsBoolExp>;
  _or?: Maybe<Array<ParentsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "parents". */
export interface ParentsOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "parents" */
export const enum ParentsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.adresses" */
export interface PrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.adresses" */
export interface PrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface PrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface PrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface PrivateAdressesBoolExp {
  _and?: Maybe<Array<PrivateAdressesBoolExp>>;
  _not?: Maybe<PrivateAdressesBoolExp>;
  _or?: Maybe<Array<PrivateAdressesBoolExp>>;
  area?: Maybe<StringComparisonExp>;
  city?: Maybe<StringComparisonExp>;
  country?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  postal_code?: Maybe<StringComparisonExp>;
  street?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum PrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface PrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface PrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface PrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface PrivateAdressesObjRelInsertInput {
  data: PrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface PrivateAdressesOnConflict {
  constraint: PrivateAdressesConstraint;
  update_columns?: Array<PrivateAdressesUpdateColumn>;
  where?: Maybe<PrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface PrivateAdressesOrderBy {
  area?: Maybe<OrderBy>;
  city?: Maybe<OrderBy>;
  country?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  postal_code?: Maybe<OrderBy>;
  street?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface PrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum PrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface PrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum PrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface PrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface PrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface PrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface PrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface PrivateBirthdaysBoolExp {
  _and?: Maybe<Array<PrivateBirthdaysBoolExp>>;
  _not?: Maybe<PrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<PrivateBirthdaysBoolExp>>;
  date?: Maybe<DateComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum PrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface PrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface PrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface PrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface PrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface PrivateBirthdaysObjRelInsertInput {
  data: PrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface PrivateBirthdaysOnConflict {
  constraint: PrivateBirthdaysConstraint;
  update_columns?: Array<PrivateBirthdaysUpdateColumn>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface PrivateBirthdaysOrderBy {
  date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface PrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum PrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface PrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum PrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface PrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface PrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface PrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<PrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<PrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<PrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface PrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersObjRelInsertInput {
  data: PrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersOnConflict {
  constraint: PrivateInsuranceNumbersConstraint;
  update_columns?: Array<PrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface PrivateInsuranceNumbersOrderBy {
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface PrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface PrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum PrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface PrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
}

/** aggregated selection of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<PrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface PrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface PrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<PrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<PrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<PrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  number?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum PrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface PrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface PrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface PrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface PrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface PrivatePhoneNumbersObjRelInsertInput {
  data: PrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<PrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface PrivatePhoneNumbersOnConflict {
  constraint: PrivatePhoneNumbersConstraint;
  update_columns?: Array<PrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface PrivatePhoneNumbersOrderBy {
  country_code?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  number?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface PrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum PrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface PrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum PrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "promotions" */
export interface Promotions {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_promoted: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  year: EntireFieldWrapper<Years>;
  year_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "promotions" */
export interface PromotionsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<PromotionsMaxOrderBy>;
  min?: Maybe<PromotionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export interface PromotionsBoolExp {
  _and?: Maybe<Array<PromotionsBoolExp>>;
  _not?: Maybe<PromotionsBoolExp>;
  _or?: Maybe<Array<PromotionsBoolExp>>;
  class_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_promoted?: Maybe<BooleanComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  year?: Maybe<YearsBoolExp>;
  year_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "promotions" */
export interface PromotionsMaxOrderBy {
  class_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  year_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "promotions" */
export interface PromotionsMinOrderBy {
  class_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  year_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "promotions". */
export interface PromotionsOrderBy {
  class_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_promoted?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  year?: Maybe<YearsOrderBy>;
  year_id?: Maybe<OrderBy>;
}

/** select columns of table "promotions" */
export const enum PromotionsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PROMOTED = 'is_promoted',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  YEAR_ID = 'year_id'
};

export interface QueryRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<AssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<AssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<AssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<AssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<AssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<AssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<AssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<AssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<AssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<AssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<AssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<AssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<AssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<AssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<AssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<AssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<AssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<AssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<AssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<AssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<AssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<AssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<AssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<AssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<AssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<Assignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<AttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<AttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<Attendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<Attendances>>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<AuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<AuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<AuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<AuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<AuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<AuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<AuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<AuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<AuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<AuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<AuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<AuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<AuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<AuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<AuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<AuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<AuthRoles>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<BookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<BookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<BookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<BookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<BookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<BookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<BookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<BookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<Books>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<Books>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<ChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<ChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<ChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<ChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<ChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<ChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<ChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<ChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<ChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<ChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<ChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<ChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<ChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<ChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<ChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<ChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<ChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<Chats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<Chats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<ClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<ClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<ClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<ClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<Classes>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<Classes>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<Classrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<Classrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<CourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<CourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<CourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<CourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<CourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<CourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<CourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<CourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<Courses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<Courses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<EventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<EventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<Events>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<Events>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<Files>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<Files>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<GradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<GradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<Grades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<LatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<LatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<LessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<LessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<LessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<LessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<Lessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<LessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<Lessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<LiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<LiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<LiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<LiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<Marks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<Marks>>;
  me?: EntireFieldWrapper<Maybe<UserData>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<MeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<MeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<MeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<Notifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<NotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<Notifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<Parents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<Parents>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<PrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<PrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<PrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<PrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<PrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<PrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<PrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<PrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<Promotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<Promotions>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<Relationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<Relationships>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<SchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<SchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<SchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<SchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<Schools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<SchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<Schools>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<Semesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<Semesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<Students>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<Students>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<Subjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<Subjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<Tasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<TasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<Tasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<TeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<Teachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<Teachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<TeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<TeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<TeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<TeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeachingStructures>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<Users>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<UsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<Users>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<ViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<ViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<ViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<ViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<ViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<ViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<ViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<ViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<ViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<ViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<ViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<ViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<Years>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<YearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<Years>>;
}


export interface QueryRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<AssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<AssignmentAttendeeTypeBoolExp>;
}


export interface QueryRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface QueryRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<AssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentBookChapterOrderBy>>;
  where?: Maybe<AssignmentBookChapterBoolExp>;
}


export interface QueryRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionOrderBy>>;
  where?: Maybe<AssignmentDiscussionBoolExp>;
}


export interface QueryRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionContentOrderBy>>;
  where?: Maybe<AssignmentDiscussionContentBoolExp>;
}


export interface QueryRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
}


export interface QueryRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<AssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentFilesOrderBy>>;
  where?: Maybe<AssignmentFilesBoolExp>;
}


export interface QueryRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<AssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentGradeWeightsOrderBy>>;
  where?: Maybe<AssignmentGradeWeightsBoolExp>;
}


export interface QueryRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentGradeWeightsOrderBy>>;
  where?: Maybe<AssignmentGradeWeightsBoolExp>;
}


export interface QueryRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<AssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentNotesOrderBy>>;
  where?: Maybe<AssignmentNotesBoolExp>;
}


export interface QueryRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<AssignmentQuestionAnswersBoolExp>;
}


export interface QueryRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionRelationsBoolExp>;
}


export interface QueryRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionsBoolExp>;
}


export interface QueryRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionsOrderBy>>;
  where?: Maybe<AssignmentQuestionsBoolExp>;
}


export interface QueryRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<AssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuizOrderBy>>;
  where?: Maybe<AssignmentQuizBoolExp>;
}


export interface QueryRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<AssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentSubmitsOrderBy>>;
  where?: Maybe<AssignmentSubmitsBoolExp>;
}


export interface QueryRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<AssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentTypeOrderBy>>;
  where?: Maybe<AssignmentTypeBoolExp>;
}


export interface QueryRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<AssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentUserOrderBy>>;
  where?: Maybe<AssignmentUserBoolExp>;
}


export interface QueryRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


export interface QueryRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


export interface QueryRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<AttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AttendanceTypesOrderBy>>;
  where?: Maybe<AttendanceTypesBoolExp>;
}


export interface QueryRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface QueryRootAttendancesArgs {
  distinct_on?: Maybe<Array<AttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AttendancesOrderBy>>;
  where?: Maybe<AttendancesBoolExp>;
}


export interface QueryRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


export interface QueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountProvidersOrderBy>>;
  where?: Maybe<AuthAccountProvidersBoolExp>;
}


export interface QueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


export interface QueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountRolesOrderBy>>;
  where?: Maybe<AuthAccountRolesBoolExp>;
}


export interface QueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


export interface QueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<AuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthAccountsOrderBy>>;
  where?: Maybe<AuthAccountsBoolExp>;
}


export interface QueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<AuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProvidersOrderBy>>;
  where?: Maybe<AuthProvidersBoolExp>;
}


export interface QueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<AuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthProvidersOrderBy>>;
  where?: Maybe<AuthProvidersBoolExp>;
}


export interface QueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface QueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


export interface QueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<AuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRefreshTokensOrderBy>>;
  where?: Maybe<AuthRefreshTokensBoolExp>;
}


export interface QueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface QueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<AuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRolesOrderBy>>;
  where?: Maybe<AuthRolesBoolExp>;
}


export interface QueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<AuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AuthRolesOrderBy>>;
  where?: Maybe<AuthRolesBoolExp>;
}


export interface QueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface QueryRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<BookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChapterTypeOrderBy>>;
  where?: Maybe<BookChapterTypeBoolExp>;
}


export interface QueryRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootBookChaptersArgs {
  distinct_on?: Maybe<Array<BookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChaptersOrderBy>>;
  where?: Maybe<BookChaptersBoolExp>;
}


export interface QueryRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootBookCourseArgs {
  distinct_on?: Maybe<Array<BookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookCourseOrderBy>>;
  where?: Maybe<BookCourseBoolExp>;
}


export interface QueryRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootBookUserArgs {
  distinct_on?: Maybe<Array<BookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookUserOrderBy>>;
  where?: Maybe<BookUserBoolExp>;
}


export interface QueryRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootBooksArgs {
  distinct_on?: Maybe<Array<BooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BooksOrderBy>>;
  where?: Maybe<BooksBoolExp>;
}


export interface QueryRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<ChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionNotesOrderBy>>;
  where?: Maybe<ChapterSectionNotesBoolExp>;
}


export interface QueryRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<ChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionSubmitsOrderBy>>;
  where?: Maybe<ChapterSectionSubmitsBoolExp>;
}


export interface QueryRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<ChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionTypeOrderBy>>;
  where?: Maybe<ChapterSectionTypeBoolExp>;
}


export interface QueryRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<ChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionsOrderBy>>;
  where?: Maybe<ChapterSectionsBoolExp>;
}


export interface QueryRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


export interface QueryRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


export interface QueryRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<ChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageReadsOrderBy>>;
  where?: Maybe<ChatMessageReadsBoolExp>;
}


export interface QueryRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChatMessagesArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


export interface QueryRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


export interface QueryRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChatTypeArgs {
  distinct_on?: Maybe<Array<ChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatTypeOrderBy>>;
  where?: Maybe<ChatTypeBoolExp>;
}


export interface QueryRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootChatUserArgs {
  distinct_on?: Maybe<Array<ChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatUserOrderBy>>;
  where?: Maybe<ChatUserBoolExp>;
}


export interface QueryRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootChatsArgs {
  distinct_on?: Maybe<Array<ChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatsOrderBy>>;
  where?: Maybe<ChatsBoolExp>;
}


export interface QueryRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootClassLevelsArgs {
  distinct_on?: Maybe<Array<ClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassLevelsOrderBy>>;
  where?: Maybe<ClassLevelsBoolExp>;
}


export interface QueryRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootClassTypeArgs {
  distinct_on?: Maybe<Array<ClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassTypeOrderBy>>;
  where?: Maybe<ClassTypeBoolExp>;
}


export interface QueryRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootClassesArgs {
  distinct_on?: Maybe<Array<ClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassesOrderBy>>;
  where?: Maybe<ClassesBoolExp>;
}


export interface QueryRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootClassroomsArgs {
  distinct_on?: Maybe<Array<ClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassroomsOrderBy>>;
  where?: Maybe<ClassroomsBoolExp>;
}


export interface QueryRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootCourseClassArgs {
  distinct_on?: Maybe<Array<CourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassOrderBy>>;
  where?: Maybe<CourseClassBoolExp>;
}


export interface QueryRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<CourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassroomOrderBy>>;
  where?: Maybe<CourseClassroomBoolExp>;
}


export interface QueryRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootCourseStudentArgs {
  distinct_on?: Maybe<Array<CourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseStudentOrderBy>>;
  where?: Maybe<CourseStudentBoolExp>;
}


export interface QueryRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<CourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseTeacherOrderBy>>;
  where?: Maybe<CourseTeacherBoolExp>;
}


export interface QueryRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootCoursesArgs {
  distinct_on?: Maybe<Array<CoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CoursesOrderBy>>;
  where?: Maybe<CoursesBoolExp>;
}


export interface QueryRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootEventUsersArgs {
  distinct_on?: Maybe<Array<EventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventUsersOrderBy>>;
  where?: Maybe<EventUsersBoolExp>;
}


export interface QueryRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootEventsArgs {
  distinct_on?: Maybe<Array<EventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventsOrderBy>>;
  where?: Maybe<EventsBoolExp>;
}


export interface QueryRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootFilesArgs {
  distinct_on?: Maybe<Array<FilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FilesOrderBy>>;
  where?: Maybe<FilesBoolExp>;
}


export interface QueryRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootGradeTypesArgs {
  distinct_on?: Maybe<Array<GradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradeTypesOrderBy>>;
  where?: Maybe<GradeTypesBoolExp>;
}


export interface QueryRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


export interface QueryRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


export interface QueryRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<LatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LatestActivitiesOrderBy>>;
  where?: Maybe<LatestActivitiesBoolExp>;
}


export interface QueryRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<LessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonAttendaceTypeOrderBy>>;
  where?: Maybe<LessonAttendaceTypeBoolExp>;
}


export interface QueryRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface QueryRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<LessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonAttendancesOrderBy>>;
  where?: Maybe<LessonAttendancesBoolExp>;
}


export interface QueryRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootLessonsArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


export interface QueryRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


export interface QueryRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<LiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LiveClassAttendeesOrderBy>>;
  where?: Maybe<LiveClassAttendeesBoolExp>;
}


export interface QueryRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootLiveClassesArgs {
  distinct_on?: Maybe<Array<LiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LiveClassesOrderBy>>;
  where?: Maybe<LiveClassesBoolExp>;
}


export interface QueryRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootMarksArgs {
  distinct_on?: Maybe<Array<MarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MarksOrderBy>>;
  where?: Maybe<MarksBoolExp>;
}


export interface QueryRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootMeetingUserArgs {
  distinct_on?: Maybe<Array<MeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MeetingUserOrderBy>>;
  where?: Maybe<MeetingUserBoolExp>;
}


export interface QueryRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<MeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MeetingUserOrderBy>>;
  where?: Maybe<MeetingUserBoolExp>;
}


export interface QueryRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootNotificationsArgs {
  distinct_on?: Maybe<Array<NotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<NotificationsOrderBy>>;
  where?: Maybe<NotificationsBoolExp>;
}


export interface QueryRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<NotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<NotificationsOrderBy>>;
  where?: Maybe<NotificationsBoolExp>;
}


export interface QueryRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootParentsArgs {
  distinct_on?: Maybe<Array<ParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ParentsOrderBy>>;
  where?: Maybe<ParentsBoolExp>;
}


export interface QueryRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<PrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateAdressesOrderBy>>;
  where?: Maybe<PrivateAdressesBoolExp>;
}


export interface QueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<PrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateAdressesOrderBy>>;
  where?: Maybe<PrivateAdressesBoolExp>;
}


export interface QueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateBirthdaysOrderBy>>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}


export interface QueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<PrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateBirthdaysOrderBy>>;
  where?: Maybe<PrivateBirthdaysBoolExp>;
}


export interface QueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}


export interface QueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<PrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<PrivateInsuranceNumbersBoolExp>;
}


export interface QueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivatePhoneNumbersOrderBy>>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}


export interface QueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<PrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PrivatePhoneNumbersOrderBy>>;
  where?: Maybe<PrivatePhoneNumbersBoolExp>;
}


export interface QueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootPromotionsArgs {
  distinct_on?: Maybe<Array<PromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PromotionsOrderBy>>;
  where?: Maybe<PromotionsBoolExp>;
}


export interface QueryRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


export interface QueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


export interface QueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<SchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsOrderBy>>;
  where?: Maybe<SchoolSettingsBoolExp>;
}


export interface QueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<SchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsOrderBy>>;
  where?: Maybe<SchoolSettingsBoolExp>;
}


export interface QueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsModulesOrderBy>>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}


export interface QueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolSettingsModulesOrderBy>>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}


export interface QueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<SchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolsOrderBy>>;
  where?: Maybe<SchoolsBoolExp>;
}


export interface QueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<SchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SchoolsOrderBy>>;
  where?: Maybe<SchoolsBoolExp>;
}


export interface QueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSemestersArgs {
  distinct_on?: Maybe<Array<SemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SemestersOrderBy>>;
  where?: Maybe<SemestersBoolExp>;
}


export interface QueryRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupUsersOrderBy>>;
  where?: Maybe<StudentGroupUsersBoolExp>;
}


export interface QueryRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupsOrderBy>>;
  where?: Maybe<StudentGroupsBoolExp>;
}


export interface QueryRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}


export interface QueryRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}


export interface QueryRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootSubjectsArgs {
  distinct_on?: Maybe<Array<SubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SubjectsOrderBy>>;
  where?: Maybe<SubjectsBoolExp>;
}


export interface QueryRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootTasksArgs {
  distinct_on?: Maybe<Array<TasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TasksOrderBy>>;
  where?: Maybe<TasksBoolExp>;
}


export interface QueryRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<TasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TasksOrderBy>>;
  where?: Maybe<TasksBoolExp>;
}


export interface QueryRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<TeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectOrderBy>>;
  where?: Maybe<TeacherSubjectBoolExp>;
}


export interface QueryRootTeachersArgs {
  distinct_on?: Maybe<Array<TeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachersOrderBy>>;
  where?: Maybe<TeachersBoolExp>;
}


export interface QueryRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootTeachingStructureLeafsArgs {
  args: TeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructureLeafsAggregateArgs {
  args: TeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructureParentsArgs {
  args: TeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructureParentsAggregateArgs {
  args: TeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<TeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructureStudentsOrderBy>>;
  where?: Maybe<TeachingStructureStudentsBoolExp>;
}


export interface QueryRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface QueryRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootUsersArgs {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
}


export interface QueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<UsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<UsersOrderBy>>;
  where?: Maybe<UsersBoolExp>;
}


export interface QueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface QueryRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<ViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewAssignmentClassOrderBy>>;
  where?: Maybe<ViewAssignmentClassBoolExp>;
}


export interface QueryRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<ViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<ViewAssignmentStudentGradeBoolExp>;
}


export interface QueryRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<ViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewClassStudentOrderBy>>;
  where?: Maybe<ViewClassStudentBoolExp>;
}


export interface QueryRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<ViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<ViewGradeTypeSubjectBoolExp>;
}


export interface QueryRootViewGradesArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


export interface QueryRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


export interface QueryRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<ViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesForStudentsOrderBy>>;
  where?: Maybe<ViewGradesForStudentsBoolExp>;
}


export interface QueryRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<ViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewLatestChatMessagesOrderBy>>;
  where?: Maybe<ViewLatestChatMessagesBoolExp>;
}


export interface QueryRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewLatestChatMessagesOrderBy>>;
  where?: Maybe<ViewLatestChatMessagesBoolExp>;
}


export interface QueryRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<ViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<ViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface QueryRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<ViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewSubjectSemesterOrderBy>>;
  where?: Maybe<ViewSubjectSemesterBoolExp>;
}


export interface QueryRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<ViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<ViewTeacherClassSubjectBoolExp>;
}


export interface QueryRootYearsArgs {
  distinct_on?: Maybe<Array<YearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<YearsOrderBy>>;
  where?: Maybe<YearsBoolExp>;
}


export interface QueryRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<YearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<YearsOrderBy>>;
  where?: Maybe<YearsBoolExp>;
}


export interface QueryRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface Relationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<Users>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<AuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<Users>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface RelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<RelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Relationships>>;
}

/** aggregate fields of "relationships" */
export interface RelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<RelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<RelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface RelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<RelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface RelationshipsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<RelationshipsMaxOrderBy>;
  min?: Maybe<RelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface RelationshipsArrRelInsertInput {
  data: Array<RelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<RelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface RelationshipsBoolExp {
  _and?: Maybe<Array<RelationshipsBoolExp>>;
  _not?: Maybe<RelationshipsBoolExp>;
  _or?: Maybe<Array<RelationshipsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  related?: Maybe<UsersBoolExp>;
  related_id?: Maybe<UuidComparisonExp>;
  role?: Maybe<StringComparisonExp>;
  roleByRole?: Maybe<AuthRolesBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user?: Maybe<UsersBoolExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum RelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface RelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<UsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<AuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<UsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface RelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface RelationshipsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface RelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface RelationshipsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface RelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Relationships>>;
}

/** on conflict condition type for table "relationships" */
export interface RelationshipsOnConflict {
  constraint: RelationshipsConstraint;
  update_columns?: Array<RelationshipsUpdateColumn>;
  where?: Maybe<RelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface RelationshipsOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  related?: Maybe<UsersOrderBy>;
  related_id?: Maybe<OrderBy>;
  role?: Maybe<OrderBy>;
  roleByRole?: Maybe<AuthRolesOrderBy>;
  updated_at?: Maybe<OrderBy>;
  user?: Maybe<UsersOrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: relationships */
export interface RelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum RelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface RelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum RelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface SchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<Schools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<SchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface SchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<SchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface SchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface SchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface SchoolSettingsBoolExp {
  _and?: Maybe<Array<SchoolSettingsBoolExp>>;
  _not?: Maybe<SchoolSettingsBoolExp>;
  _or?: Maybe<Array<SchoolSettingsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  school?: Maybe<SchoolsBoolExp>;
  school_id?: Maybe<UuidComparisonExp>;
  school_settings_module?: Maybe<SchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum SchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface SchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<SchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<SchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface SchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface SchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface SchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<SchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface SchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<SchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface SchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface SchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface SchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<SchoolSettingsModulesBoolExp>>;
  _not?: Maybe<SchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<SchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<BooleanComparisonExp>;
  chat?: Maybe<BooleanComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grading?: Maybe<BooleanComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  live_class?: Maybe<BooleanComparisonExp>;
  school_setting?: Maybe<SchoolSettingsBoolExp>;
  school_settings_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum SchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface SchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<SchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface SchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface SchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface SchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<SchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface SchoolSettingsModulesObjRelInsertInput {
  data: SchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface SchoolSettingsModulesOnConflict {
  constraint: SchoolSettingsModulesConstraint;
  update_columns?: Array<SchoolSettingsModulesUpdateColumn>;
  where?: Maybe<SchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface SchoolSettingsModulesOrderBy {
  assignments?: Maybe<OrderBy>;
  chat?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  grading?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  live_class?: Maybe<OrderBy>;
  school_setting?: Maybe<SchoolSettingsOrderBy>;
  school_settings_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface SchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum SchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface SchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum SchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface SchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<SchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface SchoolSettingsObjRelInsertInput {
  data: SchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface SchoolSettingsOnConflict {
  constraint: SchoolSettingsConstraint;
  update_columns?: Array<SchoolSettingsUpdateColumn>;
  where?: Maybe<SchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface SchoolSettingsOrderBy {
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  school?: Maybe<SchoolsOrderBy>;
  school_id?: Maybe<OrderBy>;
  school_settings_module?: Maybe<SchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: school_settings */
export interface SchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum SchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface SchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum SchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface Schools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<SchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface SchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<SchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Schools>>;
}

/** aggregate fields of "schools" */
export interface SchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<SchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<SchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface SchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<SchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface SchoolsBoolExp {
  _and?: Maybe<Array<SchoolsBoolExp>>;
  _not?: Maybe<SchoolsBoolExp>;
  _or?: Maybe<Array<SchoolsBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  path?: Maybe<StringComparisonExp>;
  school_setting?: Maybe<SchoolSettingsBoolExp>;
  serial?: Maybe<StringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum SchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface SchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<SchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface SchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface SchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface SchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Schools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface SchoolsObjRelInsertInput {
  data: SchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<SchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface SchoolsOnConflict {
  constraint: SchoolsConstraint;
  update_columns?: Array<SchoolsUpdateColumn>;
  where?: Maybe<SchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface SchoolsOrderBy {
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  path?: Maybe<OrderBy>;
  school_setting?: Maybe<SchoolSettingsOrderBy>;
  serial?: Maybe<OrderBy>;
}

/** primary key columns input for table: schools */
export interface SchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum SchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface SchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum SchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** columns and relationships of "semesters" */
export interface Semesters {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_at: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  start_at: EntireFieldWrapper<Scalars['date']>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<TeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "semesters". All fields are combined with a logical 'AND'. */
export interface SemestersBoolExp {
  _and?: Maybe<Array<SemestersBoolExp>>;
  _not?: Maybe<SemestersBoolExp>;
  _or?: Maybe<Array<SemestersBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  end_at?: Maybe<DateComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  start_at?: Maybe<DateComparisonExp>;
  teaching_structure?: Maybe<TeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "semesters". */
export interface SemestersOrderBy {
  created_at?: Maybe<OrderBy>;
  end_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  start_at?: Maybe<OrderBy>;
  teaching_structure?: Maybe<TeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "semesters" */
export const enum SemestersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_AT = 'end_at',
  /** column name */
  ID = 'id',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "student_group_users" */
export interface StudentGroupUsers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  live_class_group: EntireFieldWrapper<Array<StudentGroups>>;
  student_group_id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_group_users" */
export interface StudentGroupUsersLiveClassGroupArgs {
  distinct_on?: Maybe<Array<StudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupsOrderBy>>;
  where?: Maybe<StudentGroupsBoolExp>;
}

/** order by aggregate values of table "student_group_users" */
export interface StudentGroupUsersAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<StudentGroupUsersMaxOrderBy>;
  min?: Maybe<StudentGroupUsersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_group_users". All fields are combined with a logical 'AND'. */
export interface StudentGroupUsersBoolExp {
  _and?: Maybe<Array<StudentGroupUsersBoolExp>>;
  _not?: Maybe<StudentGroupUsersBoolExp>;
  _or?: Maybe<Array<StudentGroupUsersBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  live_class_group?: Maybe<StudentGroupsBoolExp>;
  student_group_id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "student_group_users" */
export interface StudentGroupUsersMaxOrderBy {
  id?: Maybe<OrderBy>;
  student_group_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "student_group_users" */
export interface StudentGroupUsersMinOrderBy {
  id?: Maybe<OrderBy>;
  student_group_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "student_group_users". */
export interface StudentGroupUsersOrderBy {
  id?: Maybe<OrderBy>;
  live_class_group_aggregate?: Maybe<StudentGroupsAggregateOrderBy>;
  student_group_id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "student_group_users" */
export const enum StudentGroupUsersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_GROUP_ID = 'student_group_id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "student_groups" */
export interface StudentGroups {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lesson: EntireFieldWrapper<Array<Lessons>>;
  /** An aggregate relationship */
  lesson_aggregate: EntireFieldWrapper<LessonsAggregate>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentGroupUsers>>;
  /** An array relationship */
  teacher: EntireFieldWrapper<Array<Teachers>>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "student_groups" */
export interface StudentGroupsLessonArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentGroupsLessonAggregateArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentGroupsStudentsArgs {
  distinct_on?: Maybe<Array<StudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupUsersOrderBy>>;
  where?: Maybe<StudentGroupUsersBoolExp>;
}


/** columns and relationships of "student_groups" */
export interface StudentGroupsTeacherArgs {
  distinct_on?: Maybe<Array<TeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachersOrderBy>>;
  where?: Maybe<TeachersBoolExp>;
}

/** order by aggregate values of table "student_groups" */
export interface StudentGroupsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<StudentGroupsMaxOrderBy>;
  min?: Maybe<StudentGroupsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "student_groups". All fields are combined with a logical 'AND'. */
export interface StudentGroupsBoolExp {
  _and?: Maybe<Array<StudentGroupsBoolExp>>;
  _not?: Maybe<StudentGroupsBoolExp>;
  _or?: Maybe<Array<StudentGroupsBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  lesson?: Maybe<LessonsBoolExp>;
  lesson_id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  students?: Maybe<StudentGroupUsersBoolExp>;
  teacher?: Maybe<TeachersBoolExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "student_groups" */
export interface StudentGroupsMaxOrderBy {
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "student_groups" */
export interface StudentGroupsMinOrderBy {
  id?: Maybe<OrderBy>;
  lesson_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "student_groups". */
export interface StudentGroupsOrderBy {
  id?: Maybe<OrderBy>;
  lesson_aggregate?: Maybe<LessonsAggregateOrderBy>;
  lesson_id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  students_aggregate?: Maybe<StudentGroupUsersAggregateOrderBy>;
  teacher_aggregate?: Maybe<TeachersAggregateOrderBy>;
  teacher_id?: Maybe<OrderBy>;
}

/** select columns of table "student_groups" */
export const enum StudentGroupsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  NAME = 'name',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "students" */
export interface Students {
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<ChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<ChapterSectionSubmits>>;
  /** An object relationship */
  class: EntireFieldWrapper<Classes>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  course_students: EntireFieldWrapper<Array<CourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
}


/** columns and relationships of "students" */
export interface StudentsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<ChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionNotesOrderBy>>;
  where?: Maybe<ChapterSectionNotesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<ChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionSubmitsOrderBy>>;
  where?: Maybe<ChapterSectionSubmitsBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentsCourseStudentsArgs {
  distinct_on?: Maybe<Array<CourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseStudentOrderBy>>;
  where?: Maybe<CourseStudentBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentsGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}

/** aggregated selection of "students" */
export interface StudentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Students>>;
}

/** aggregate fields of "students" */
export interface StudentsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentsMinFields>>;
}


/** aggregate fields of "students" */
export interface StudentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "students" */
export interface StudentsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<StudentsMaxOrderBy>;
  min?: Maybe<StudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export interface StudentsBoolExp {
  _and?: Maybe<Array<StudentsBoolExp>>;
  _not?: Maybe<StudentsBoolExp>;
  _or?: Maybe<Array<StudentsBoolExp>>;
  chapter_section_notes?: Maybe<ChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<ChapterSectionSubmitsBoolExp>;
  class?: Maybe<ClassesBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
  course_students?: Maybe<CourseStudentBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grades?: Maybe<GradesBoolExp>;
  id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentsMaxFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "students" */
export interface StudentsMaxOrderBy {
  class_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface StudentsMinFields {
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "students" */
export interface StudentsMinOrderBy {
  class_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "students". */
export interface StudentsOrderBy {
  chapter_section_notes_aggregate?: Maybe<ChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<ChapterSectionSubmitsAggregateOrderBy>;
  class?: Maybe<ClassesOrderBy>;
  class_id?: Maybe<OrderBy>;
  course_students_aggregate?: Maybe<CourseStudentAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  grades_aggregate?: Maybe<GradesAggregateOrderBy>;
  id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "students" */
export const enum StudentsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "subjects" */
export interface Subjects {
  /** An array relationship */
  books: EntireFieldWrapper<Array<Books>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<Classrooms>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<Courses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<ViewGradeTypeSubject>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  statistics: EntireFieldWrapper<Array<ViewStatisticsSemesterSubjectMark>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherSubject>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<ViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<ViewGradesAggregate>;
}


/** columns and relationships of "subjects" */
export interface SubjectsBooksArgs {
  distinct_on?: Maybe<Array<BooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BooksOrderBy>>;
  where?: Maybe<BooksBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsClassroomsArgs {
  distinct_on?: Maybe<Array<ClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassroomsOrderBy>>;
  where?: Maybe<ClassroomsBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsCoursesArgs {
  distinct_on?: Maybe<Array<CoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CoursesOrderBy>>;
  where?: Maybe<CoursesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsGradeTypesArgs {
  distinct_on?: Maybe<Array<ViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<ViewGradeTypeSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsStatisticsArgs {
  distinct_on?: Maybe<Array<ViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<ViewStatisticsSemesterSubjectMarkBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectOrderBy>>;
  where?: Maybe<TeacherSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsViewGradesArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface SubjectsViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}

/** order by aggregate values of table "subjects" */
export interface SubjectsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<SubjectsMaxOrderBy>;
  min?: Maybe<SubjectsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export interface SubjectsBoolExp {
  _and?: Maybe<Array<SubjectsBoolExp>>;
  _not?: Maybe<SubjectsBoolExp>;
  _or?: Maybe<Array<SubjectsBoolExp>>;
  books?: Maybe<BooksBoolExp>;
  classrooms?: Maybe<ClassroomsBoolExp>;
  courses?: Maybe<CoursesBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  grade_types?: Maybe<ViewGradeTypeSubjectBoolExp>;
  icon?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  statistics?: Maybe<ViewStatisticsSemesterSubjectMarkBoolExp>;
  teacher_subjects?: Maybe<TeacherSubjectBoolExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  view_grades?: Maybe<ViewGradesBoolExp>;
}

/** order by max() on columns of table "subjects" */
export interface SubjectsMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  icon?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "subjects" */
export interface SubjectsMinOrderBy {
  created_at?: Maybe<OrderBy>;
  icon?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "subjects". */
export interface SubjectsOrderBy {
  books_aggregate?: Maybe<BooksAggregateOrderBy>;
  classrooms_aggregate?: Maybe<ClassroomsAggregateOrderBy>;
  courses_aggregate?: Maybe<CoursesAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  grade_types_aggregate?: Maybe<ViewGradeTypeSubjectAggregateOrderBy>;
  icon?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  statistics_aggregate?: Maybe<ViewStatisticsSemesterSubjectMarkAggregateOrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherSubjectAggregateOrderBy>;
  updated_at?: Maybe<OrderBy>;
  view_grades_aggregate?: Maybe<ViewGradesAggregateOrderBy>;
}

/** select columns of table "subjects" */
export const enum SubjectsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface SubscriptionRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<AssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<AssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<AssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<AssignmentBookChapter>>;
  /** An array relationship */
  assignment_discussion: EntireFieldWrapper<Array<AssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion" using primary key columns */
  assignment_discussion_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussion>>;
  /** fetch data from the table: "assignment_discussion_content" */
  assignment_discussion_content: EntireFieldWrapper<Array<AssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_content" using primary key columns */
  assignment_discussion_content_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionContent>>;
  /** fetch data from the table: "assignment_discussion_subscription" */
  assignment_discussion_subscription: EntireFieldWrapper<Array<AssignmentDiscussionSubscription>>;
  /** fetch data from the table: "assignment_discussion_subscription" using primary key columns */
  assignment_discussion_subscription_by_pk?: EntireFieldWrapper<Maybe<AssignmentDiscussionSubscription>>;
  /** An array relationship */
  assignment_files: EntireFieldWrapper<Array<AssignmentFiles>>;
  /** fetch data from the table: "assignment_files" using primary key columns */
  assignment_files_by_pk?: EntireFieldWrapper<Maybe<AssignmentFiles>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<AssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<AssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<AssignmentGradeWeights>>;
  /** fetch data from the table: "assignment_notes" */
  assignment_notes: EntireFieldWrapper<Array<AssignmentNotes>>;
  /** fetch data from the table: "assignment_notes" using primary key columns */
  assignment_notes_by_pk?: EntireFieldWrapper<Maybe<AssignmentNotes>>;
  /** An array relationship */
  assignment_question_answers: EntireFieldWrapper<Array<AssignmentQuestionAnswers>>;
  /** fetch data from the table: "assignment_question_answers" using primary key columns */
  assignment_question_answers_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionAnswers>>;
  /** An array relationship */
  assignment_question_option_relations: EntireFieldWrapper<Array<AssignmentQuestionOptionRelations>>;
  /** fetch data from the table: "assignment_question_option_relations" using primary key columns */
  assignment_question_option_relations_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionOptionRelations>>;
  /** An array relationship */
  assignment_question_options: EntireFieldWrapper<Array<AssignmentQuestionOptions>>;
  /** fetch data from the table: "assignment_question_options" using primary key columns */
  assignment_question_options_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestionOptions>>;
  /** An array relationship */
  assignment_questions: EntireFieldWrapper<Array<AssignmentQuestions>>;
  /** fetch data from the table: "assignment_questions" using primary key columns */
  assignment_questions_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuestions>>;
  /** fetch data from the table: "assignment_quiz" */
  assignment_quiz: EntireFieldWrapper<Array<AssignmentQuiz>>;
  /** fetch data from the table: "assignment_quiz" using primary key columns */
  assignment_quiz_by_pk?: EntireFieldWrapper<Maybe<AssignmentQuiz>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<AssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<AssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<AssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<AssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<AssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<AssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<Assignments>>;
  /** fetch data from the table: "attendance_types" */
  attendance_types: EntireFieldWrapper<Array<AttendanceTypes>>;
  /** fetch data from the table: "attendance_types" using primary key columns */
  attendance_types_by_pk?: EntireFieldWrapper<Maybe<AttendanceTypes>>;
  /** fetch data from the table: "attendances" */
  attendances: EntireFieldWrapper<Array<Attendances>>;
  /** fetch data from the table: "attendances" using primary key columns */
  attendances_by_pk?: EntireFieldWrapper<Maybe<Attendances>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<BookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<BookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<BookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<BookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<BookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<BookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<BookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<BookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<Books>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<Books>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<ChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<ChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<ChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<ChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<ChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<ChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<ChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<ChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<ChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<ChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<ChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<ChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<ChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<ChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<ChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<ChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<ChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<ChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<Chats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<Chats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<ClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<ClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<ClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<ClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<Classes>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<Classes>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<Classrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<Classrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<CourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<CourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<CourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<CourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<CourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<CourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<CourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<CourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<Courses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<Courses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<EventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<EventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<Events>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<Events>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<Files>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<Files>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<GradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<GradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<Grades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<GradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<Grades>>;
  /** fetch data from the table: "latest_activities" */
  latest_activities: EntireFieldWrapper<Array<LatestActivities>>;
  /** fetch data from the table: "latest_activities" using primary key columns */
  latest_activities_by_pk?: EntireFieldWrapper<Maybe<LatestActivities>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<LessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<LessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<LessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<LessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<Lessons>>;
  /** An aggregate relationship */
  lessons_aggregate: EntireFieldWrapper<LessonsAggregate>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<Lessons>>;
  /** An array relationship */
  live_class_attendees: EntireFieldWrapper<Array<LiveClassAttendees>>;
  /** fetch data from the table: "live_class_attendees" using primary key columns */
  live_class_attendees_by_pk?: EntireFieldWrapper<Maybe<LiveClassAttendees>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<LiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<LiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<Marks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<Marks>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<MeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<MeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<MeetingUser>>;
  /** fetch data from the table: "notifications" */
  notifications: EntireFieldWrapper<Array<Notifications>>;
  /** fetch aggregated fields from the table: "notifications" */
  notifications_aggregate: EntireFieldWrapper<NotificationsAggregate>;
  /** fetch data from the table: "notifications" using primary key columns */
  notifications_by_pk?: EntireFieldWrapper<Maybe<Notifications>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<Parents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<Parents>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<Promotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<Promotions>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<Semesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<Semesters>>;
  /** fetch data from the table: "student_group_users" */
  student_group_users: EntireFieldWrapper<Array<StudentGroupUsers>>;
  /** fetch data from the table: "student_group_users" using primary key columns */
  student_group_users_by_pk?: EntireFieldWrapper<Maybe<StudentGroupUsers>>;
  /** fetch data from the table: "student_groups" */
  student_groups: EntireFieldWrapper<Array<StudentGroups>>;
  /** fetch data from the table: "student_groups" using primary key columns */
  student_groups_by_pk?: EntireFieldWrapper<Maybe<StudentGroups>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<Students>>;
  /** An aggregate relationship */
  students_aggregate: EntireFieldWrapper<StudentsAggregate>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<Students>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<Subjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<Subjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<Tasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<TasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<Tasks>>;
  /** fetch data from the table: "teacher_subject" */
  teacher_subject: EntireFieldWrapper<Array<TeacherSubject>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<Teachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<Teachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<TeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<TeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<TeachingStructureStudents>>;
  /** fetch data from the table: "teaching_structure_students" using primary key columns */
  teaching_structure_students_by_pk?: EntireFieldWrapper<Maybe<TeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<TeachingStructures>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<ViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<ViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<ViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<ViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<ViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<ViewGradesAggregate>;
  /** fetch data from the table: "view.grades_for_students" */
  view_grades_for_students: EntireFieldWrapper<Array<ViewGradesForStudents>>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<ViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<ViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<ViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<ViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<ViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<Years>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<YearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<Years>>;
}


export interface SubscriptionRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<AssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<AssignmentAttendeeTypeBoolExp>;
}


export interface SubscriptionRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface SubscriptionRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<AssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentBookChapterOrderBy>>;
  where?: Maybe<AssignmentBookChapterBoolExp>;
}


export interface SubscriptionRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentDiscussionArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionOrderBy>>;
  where?: Maybe<AssignmentDiscussionBoolExp>;
}


export interface SubscriptionRootAssignmentDiscussionByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentDiscussionContentArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionContentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionContentOrderBy>>;
  where?: Maybe<AssignmentDiscussionContentBoolExp>;
}


export interface SubscriptionRootAssignmentDiscussionContentByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentDiscussionSubscriptionArgs {
  distinct_on?: Maybe<Array<AssignmentDiscussionSubscriptionSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentDiscussionSubscriptionOrderBy>>;
  where?: Maybe<AssignmentDiscussionSubscriptionBoolExp>;
}


export interface SubscriptionRootAssignmentDiscussionSubscriptionByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentFilesArgs {
  distinct_on?: Maybe<Array<AssignmentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentFilesOrderBy>>;
  where?: Maybe<AssignmentFilesBoolExp>;
}


export interface SubscriptionRootAssignmentFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<AssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentGradeWeightsOrderBy>>;
  where?: Maybe<AssignmentGradeWeightsBoolExp>;
}


export interface SubscriptionRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentGradeWeightsOrderBy>>;
  where?: Maybe<AssignmentGradeWeightsBoolExp>;
}


export interface SubscriptionRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentNotesArgs {
  distinct_on?: Maybe<Array<AssignmentNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentNotesOrderBy>>;
  where?: Maybe<AssignmentNotesBoolExp>;
}


export interface SubscriptionRootAssignmentNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentQuestionAnswersArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionAnswersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionAnswersOrderBy>>;
  where?: Maybe<AssignmentQuestionAnswersBoolExp>;
}


export interface SubscriptionRootAssignmentQuestionAnswersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentQuestionOptionRelationsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionRelationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionRelationsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionRelationsBoolExp>;
}


export interface SubscriptionRootAssignmentQuestionOptionRelationsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentQuestionOptionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionOptionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionOptionsOrderBy>>;
  where?: Maybe<AssignmentQuestionOptionsBoolExp>;
}


export interface SubscriptionRootAssignmentQuestionOptionsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentQuestionsArgs {
  distinct_on?: Maybe<Array<AssignmentQuestionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuestionsOrderBy>>;
  where?: Maybe<AssignmentQuestionsBoolExp>;
}


export interface SubscriptionRootAssignmentQuestionsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentQuizArgs {
  distinct_on?: Maybe<Array<AssignmentQuizSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentQuizOrderBy>>;
  where?: Maybe<AssignmentQuizBoolExp>;
}


export interface SubscriptionRootAssignmentQuizByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<AssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentSubmitsOrderBy>>;
  where?: Maybe<AssignmentSubmitsBoolExp>;
}


export interface SubscriptionRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<AssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentTypeOrderBy>>;
  where?: Maybe<AssignmentTypeBoolExp>;
}


export interface SubscriptionRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<AssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentUserOrderBy>>;
  where?: Maybe<AssignmentUserBoolExp>;
}


export interface SubscriptionRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


export interface SubscriptionRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


export interface SubscriptionRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootAttendanceTypesArgs {
  distinct_on?: Maybe<Array<AttendanceTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AttendanceTypesOrderBy>>;
  where?: Maybe<AttendanceTypesBoolExp>;
}


export interface SubscriptionRootAttendanceTypesByPkArgs {
  value: Scalars['String'];
}


export interface SubscriptionRootAttendancesArgs {
  distinct_on?: Maybe<Array<AttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AttendancesOrderBy>>;
  where?: Maybe<AttendancesBoolExp>;
}


export interface SubscriptionRootAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<BookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChapterTypeOrderBy>>;
  where?: Maybe<BookChapterTypeBoolExp>;
}


export interface SubscriptionRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootBookChaptersArgs {
  distinct_on?: Maybe<Array<BookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookChaptersOrderBy>>;
  where?: Maybe<BookChaptersBoolExp>;
}


export interface SubscriptionRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootBookCourseArgs {
  distinct_on?: Maybe<Array<BookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookCourseOrderBy>>;
  where?: Maybe<BookCourseBoolExp>;
}


export interface SubscriptionRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootBookUserArgs {
  distinct_on?: Maybe<Array<BookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BookUserOrderBy>>;
  where?: Maybe<BookUserBoolExp>;
}


export interface SubscriptionRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootBooksArgs {
  distinct_on?: Maybe<Array<BooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<BooksOrderBy>>;
  where?: Maybe<BooksBoolExp>;
}


export interface SubscriptionRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<ChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionNotesOrderBy>>;
  where?: Maybe<ChapterSectionNotesBoolExp>;
}


export interface SubscriptionRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<ChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionSubmitsOrderBy>>;
  where?: Maybe<ChapterSectionSubmitsBoolExp>;
}


export interface SubscriptionRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<ChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionTypeOrderBy>>;
  where?: Maybe<ChapterSectionTypeBoolExp>;
}


export interface SubscriptionRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<ChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChapterSectionsOrderBy>>;
  where?: Maybe<ChapterSectionsBoolExp>;
}


export interface SubscriptionRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


export interface SubscriptionRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageLikesOrderBy>>;
  where?: Maybe<ChatMessageLikesBoolExp>;
}


export interface SubscriptionRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<ChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessageReadsOrderBy>>;
  where?: Maybe<ChatMessageReadsBoolExp>;
}


export interface SubscriptionRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChatMessagesArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


export interface SubscriptionRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatMessagesOrderBy>>;
  where?: Maybe<ChatMessagesBoolExp>;
}


export interface SubscriptionRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChatTypeArgs {
  distinct_on?: Maybe<Array<ChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatTypeOrderBy>>;
  where?: Maybe<ChatTypeBoolExp>;
}


export interface SubscriptionRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootChatUserArgs {
  distinct_on?: Maybe<Array<ChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatUserOrderBy>>;
  where?: Maybe<ChatUserBoolExp>;
}


export interface SubscriptionRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootChatsArgs {
  distinct_on?: Maybe<Array<ChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ChatsOrderBy>>;
  where?: Maybe<ChatsBoolExp>;
}


export interface SubscriptionRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootClassLevelsArgs {
  distinct_on?: Maybe<Array<ClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassLevelsOrderBy>>;
  where?: Maybe<ClassLevelsBoolExp>;
}


export interface SubscriptionRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootClassTypeArgs {
  distinct_on?: Maybe<Array<ClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassTypeOrderBy>>;
  where?: Maybe<ClassTypeBoolExp>;
}


export interface SubscriptionRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootClassesArgs {
  distinct_on?: Maybe<Array<ClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassesOrderBy>>;
  where?: Maybe<ClassesBoolExp>;
}


export interface SubscriptionRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootClassroomsArgs {
  distinct_on?: Maybe<Array<ClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassroomsOrderBy>>;
  where?: Maybe<ClassroomsBoolExp>;
}


export interface SubscriptionRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootCourseClassArgs {
  distinct_on?: Maybe<Array<CourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassOrderBy>>;
  where?: Maybe<CourseClassBoolExp>;
}


export interface SubscriptionRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<CourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseClassroomOrderBy>>;
  where?: Maybe<CourseClassroomBoolExp>;
}


export interface SubscriptionRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootCourseStudentArgs {
  distinct_on?: Maybe<Array<CourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseStudentOrderBy>>;
  where?: Maybe<CourseStudentBoolExp>;
}


export interface SubscriptionRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<CourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseTeacherOrderBy>>;
  where?: Maybe<CourseTeacherBoolExp>;
}


export interface SubscriptionRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootCoursesArgs {
  distinct_on?: Maybe<Array<CoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CoursesOrderBy>>;
  where?: Maybe<CoursesBoolExp>;
}


export interface SubscriptionRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootEventUsersArgs {
  distinct_on?: Maybe<Array<EventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventUsersOrderBy>>;
  where?: Maybe<EventUsersBoolExp>;
}


export interface SubscriptionRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootEventsArgs {
  distinct_on?: Maybe<Array<EventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<EventsOrderBy>>;
  where?: Maybe<EventsBoolExp>;
}


export interface SubscriptionRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootFilesArgs {
  distinct_on?: Maybe<Array<FilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<FilesOrderBy>>;
  where?: Maybe<FilesBoolExp>;
}


export interface SubscriptionRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootGradeTypesArgs {
  distinct_on?: Maybe<Array<GradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradeTypesOrderBy>>;
  where?: Maybe<GradeTypesBoolExp>;
}


export interface SubscriptionRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootGradesArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


export interface SubscriptionRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<GradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradesOrderBy>>;
  where?: Maybe<GradesBoolExp>;
}


export interface SubscriptionRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootLatestActivitiesArgs {
  distinct_on?: Maybe<Array<LatestActivitiesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LatestActivitiesOrderBy>>;
  where?: Maybe<LatestActivitiesBoolExp>;
}


export interface SubscriptionRootLatestActivitiesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<LessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonAttendaceTypeOrderBy>>;
  where?: Maybe<LessonAttendaceTypeBoolExp>;
}


export interface SubscriptionRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface SubscriptionRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<LessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonAttendancesOrderBy>>;
  where?: Maybe<LessonAttendancesBoolExp>;
}


export interface SubscriptionRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootLessonsArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


export interface SubscriptionRootLessonsAggregateArgs {
  distinct_on?: Maybe<Array<LessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LessonsOrderBy>>;
  where?: Maybe<LessonsBoolExp>;
}


export interface SubscriptionRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootLiveClassAttendeesArgs {
  distinct_on?: Maybe<Array<LiveClassAttendeesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LiveClassAttendeesOrderBy>>;
  where?: Maybe<LiveClassAttendeesBoolExp>;
}


export interface SubscriptionRootLiveClassAttendeesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootLiveClassesArgs {
  distinct_on?: Maybe<Array<LiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<LiveClassesOrderBy>>;
  where?: Maybe<LiveClassesBoolExp>;
}


export interface SubscriptionRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootMarksArgs {
  distinct_on?: Maybe<Array<MarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MarksOrderBy>>;
  where?: Maybe<MarksBoolExp>;
}


export interface SubscriptionRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootMeetingUserArgs {
  distinct_on?: Maybe<Array<MeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MeetingUserOrderBy>>;
  where?: Maybe<MeetingUserBoolExp>;
}


export interface SubscriptionRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<MeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<MeetingUserOrderBy>>;
  where?: Maybe<MeetingUserBoolExp>;
}


export interface SubscriptionRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootNotificationsArgs {
  distinct_on?: Maybe<Array<NotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<NotificationsOrderBy>>;
  where?: Maybe<NotificationsBoolExp>;
}


export interface SubscriptionRootNotificationsAggregateArgs {
  distinct_on?: Maybe<Array<NotificationsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<NotificationsOrderBy>>;
  where?: Maybe<NotificationsBoolExp>;
}


export interface SubscriptionRootNotificationsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootParentsArgs {
  distinct_on?: Maybe<Array<ParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ParentsOrderBy>>;
  where?: Maybe<ParentsBoolExp>;
}


export interface SubscriptionRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootPromotionsArgs {
  distinct_on?: Maybe<Array<PromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PromotionsOrderBy>>;
  where?: Maybe<PromotionsBoolExp>;
}


export interface SubscriptionRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootSemestersArgs {
  distinct_on?: Maybe<Array<SemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SemestersOrderBy>>;
  where?: Maybe<SemestersBoolExp>;
}


export interface SubscriptionRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootStudentGroupUsersArgs {
  distinct_on?: Maybe<Array<StudentGroupUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupUsersOrderBy>>;
  where?: Maybe<StudentGroupUsersBoolExp>;
}


export interface SubscriptionRootStudentGroupUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootStudentGroupsArgs {
  distinct_on?: Maybe<Array<StudentGroupsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentGroupsOrderBy>>;
  where?: Maybe<StudentGroupsBoolExp>;
}


export interface SubscriptionRootStudentGroupsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}


export interface SubscriptionRootStudentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentsOrderBy>>;
  where?: Maybe<StudentsBoolExp>;
}


export interface SubscriptionRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootSubjectsArgs {
  distinct_on?: Maybe<Array<SubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SubjectsOrderBy>>;
  where?: Maybe<SubjectsBoolExp>;
}


export interface SubscriptionRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootTasksArgs {
  distinct_on?: Maybe<Array<TasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TasksOrderBy>>;
  where?: Maybe<TasksBoolExp>;
}


export interface SubscriptionRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<TasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TasksOrderBy>>;
  where?: Maybe<TasksBoolExp>;
}


export interface SubscriptionRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootTeacherSubjectArgs {
  distinct_on?: Maybe<Array<TeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectOrderBy>>;
  where?: Maybe<TeacherSubjectBoolExp>;
}


export interface SubscriptionRootTeachersArgs {
  distinct_on?: Maybe<Array<TeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachersOrderBy>>;
  where?: Maybe<TeachersBoolExp>;
}


export interface SubscriptionRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootTeachingStructureLeafsArgs {
  args: TeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructureLeafsAggregateArgs {
  args: TeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructureParentsArgs {
  args: TeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructureParentsAggregateArgs {
  args: TeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<TeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructureStudentsOrderBy>>;
  where?: Maybe<TeachingStructureStudentsBoolExp>;
}


export interface SubscriptionRootTeachingStructureStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


export interface SubscriptionRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface SubscriptionRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<ViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewAssignmentClassOrderBy>>;
  where?: Maybe<ViewAssignmentClassBoolExp>;
}


export interface SubscriptionRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<ViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<ViewAssignmentStudentGradeBoolExp>;
}


export interface SubscriptionRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<ViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewClassStudentOrderBy>>;
  where?: Maybe<ViewClassStudentBoolExp>;
}


export interface SubscriptionRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<ViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<ViewGradeTypeSubjectBoolExp>;
}


export interface SubscriptionRootViewGradesArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


export interface SubscriptionRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<ViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesOrderBy>>;
  where?: Maybe<ViewGradesBoolExp>;
}


export interface SubscriptionRootViewGradesForStudentsArgs {
  distinct_on?: Maybe<Array<ViewGradesForStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewGradesForStudentsOrderBy>>;
  where?: Maybe<ViewGradesForStudentsBoolExp>;
}


export interface SubscriptionRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<ViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewLatestChatMessagesOrderBy>>;
  where?: Maybe<ViewLatestChatMessagesBoolExp>;
}


export interface SubscriptionRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<ViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewLatestChatMessagesOrderBy>>;
  where?: Maybe<ViewLatestChatMessagesBoolExp>;
}


export interface SubscriptionRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<ViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<ViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface SubscriptionRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<ViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewSubjectSemesterOrderBy>>;
  where?: Maybe<ViewSubjectSemesterBoolExp>;
}


export interface SubscriptionRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<ViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<ViewTeacherClassSubjectBoolExp>;
}


export interface SubscriptionRootYearsArgs {
  distinct_on?: Maybe<Array<YearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<YearsOrderBy>>;
  where?: Maybe<YearsBoolExp>;
}


export interface SubscriptionRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<YearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<YearsOrderBy>>;
  where?: Maybe<YearsBoolExp>;
}


export interface SubscriptionRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "tasks" */
export interface Tasks {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** The user this tasks belongs. */
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "tasks" */
export interface TasksAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TasksAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Tasks>>;
}

/** aggregate fields of "tasks" */
export interface TasksAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TasksMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TasksMinFields>>;
}


/** aggregate fields of "tasks" */
export interface TasksAggregateFieldsCountArgs {
  columns?: Maybe<Array<TasksSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export interface TasksBoolExp {
  _and?: Maybe<Array<TasksBoolExp>>;
  _not?: Maybe<TasksBoolExp>;
  _or?: Maybe<Array<TasksBoolExp>>;
  body?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  is_completed?: Maybe<BooleanComparisonExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** unique or primary key constraints on table "tasks" */
export const enum TasksConstraint {
  /** unique or primary key constraint */
  TASKS_PKEY = 'tasks_pkey'
};

/** input type for inserting data into table "tasks" */
export interface TasksInsertInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface TasksMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface TasksMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "tasks" */
export interface TasksMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Tasks>>;
}

/** on conflict condition type for table "tasks" */
export interface TasksOnConflict {
  constraint: TasksConstraint;
  update_columns?: Array<TasksUpdateColumn>;
  where?: Maybe<TasksBoolExp>;
}

/** Ordering options when selecting data from "tasks". */
export interface TasksOrderBy {
  body?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  is_completed?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** primary key columns input for table: tasks */
export interface TasksPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "tasks" */
export const enum TasksSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "tasks" */
export interface TasksSetInput {
  body?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  is_completed?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "tasks" */
export const enum TasksUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Connection between teachers and subjects with relevant teaching structure
 *
 *
 * columns and relationships of "teacher_subject"
 */
export interface TeacherSubject {
  /** An object relationship */
  subject: EntireFieldWrapper<Subjects>;
  /** An object relationship */
  teacher: EntireFieldWrapper<Teachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<TeachingStructures>;
}

/** order by aggregate values of table "teacher_subject" */
export interface TeacherSubjectAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<TeacherSubjectMaxOrderBy>;
  min?: Maybe<TeacherSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teacher_subject". All fields are combined with a logical 'AND'. */
export interface TeacherSubjectBoolExp {
  _and?: Maybe<Array<TeacherSubjectBoolExp>>;
  _not?: Maybe<TeacherSubjectBoolExp>;
  _or?: Maybe<Array<TeacherSubjectBoolExp>>;
  subject?: Maybe<SubjectsBoolExp>;
  teacher?: Maybe<TeachersBoolExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
  teaching_structure?: Maybe<TeachingStructuresBoolExp>;
}

/** order by max() on columns of table "teacher_subject" */
export interface TeacherSubjectMaxOrderBy {
  teacher_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "teacher_subject" */
export interface TeacherSubjectMinOrderBy {
  teacher_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "teacher_subject". */
export interface TeacherSubjectOrderBy {
  subject?: Maybe<SubjectsOrderBy>;
  teacher?: Maybe<TeachersOrderBy>;
  teacher_id?: Maybe<OrderBy>;
  teaching_structure?: Maybe<TeachingStructuresOrderBy>;
}

/** select columns of table "teacher_subject" */
export const enum TeacherSubjectSelectColumn {
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "teachers" */
export interface Teachers {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<Classes>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<Classrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<CourseTeacher>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherSubject>>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<Users>>;
}


/** columns and relationships of "teachers" */
export interface TeachersClassesArgs {
  distinct_on?: Maybe<Array<ClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<ClassesOrderBy>>;
  where?: Maybe<ClassesBoolExp>;
}


/** columns and relationships of "teachers" */
export interface TeachersCourseTeachersArgs {
  distinct_on?: Maybe<Array<CourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<CourseTeacherOrderBy>>;
  where?: Maybe<CourseTeacherBoolExp>;
}


/** columns and relationships of "teachers" */
export interface TeachersTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectOrderBy>>;
  where?: Maybe<TeacherSubjectBoolExp>;
}

/** order by aggregate values of table "teachers" */
export interface TeachersAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<TeachersMaxOrderBy>;
  min?: Maybe<TeachersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export interface TeachersBoolExp {
  _and?: Maybe<Array<TeachersBoolExp>>;
  _not?: Maybe<TeachersBoolExp>;
  _or?: Maybe<Array<TeachersBoolExp>>;
  classes?: Maybe<ClassesBoolExp>;
  classroom?: Maybe<ClassroomsBoolExp>;
  classroom_id?: Maybe<UuidComparisonExp>;
  course_teachers?: Maybe<CourseTeacherBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  teacher_subjects?: Maybe<TeacherSubjectBoolExp>;
  type?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** order by max() on columns of table "teachers" */
export interface TeachersMaxOrderBy {
  classroom_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** order by min() on columns of table "teachers" */
export interface TeachersMinOrderBy {
  classroom_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "teachers". */
export interface TeachersOrderBy {
  classes_aggregate?: Maybe<ClassesAggregateOrderBy>;
  classroom?: Maybe<ClassroomsOrderBy>;
  classroom_id?: Maybe<OrderBy>;
  course_teachers_aggregate?: Maybe<CourseTeacherAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherSubjectAggregateOrderBy>;
  type?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "teachers" */
export const enum TeachersSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface TeachingStructureLeafsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

export interface TeachingStructureParentsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

/** columns and relationships of "teaching_structure_students" */
export interface TeachingStructureStudents {
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<Students>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<Subjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure: EntireFieldWrapper<TeachingStructures>;
  teaching_structure_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  teaching_structure_students_subject: EntireFieldWrapper<Array<Subjects>>;
}


/** columns and relationships of "teaching_structure_students" */
export interface TeachingStructureStudentsTeachingStructureStudentsSubjectArgs {
  distinct_on?: Maybe<Array<SubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<SubjectsOrderBy>>;
  where?: Maybe<SubjectsBoolExp>;
}

/** order by aggregate values of table "teaching_structure_students" */
export interface TeachingStructureStudentsAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<TeachingStructureStudentsMaxOrderBy>;
  min?: Maybe<TeachingStructureStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structure_students". All fields are combined with a logical 'AND'. */
export interface TeachingStructureStudentsBoolExp {
  _and?: Maybe<Array<TeachingStructureStudentsBoolExp>>;
  _not?: Maybe<TeachingStructureStudentsBoolExp>;
  _or?: Maybe<Array<TeachingStructureStudentsBoolExp>>;
  id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  teaching_structure?: Maybe<TeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<UuidComparisonExp>;
  teaching_structure_students_subject?: Maybe<SubjectsBoolExp>;
}

/** order by max() on columns of table "teaching_structure_students" */
export interface TeachingStructureStudentsMaxOrderBy {
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "teaching_structure_students" */
export interface TeachingStructureStudentsMinOrderBy {
  id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "teaching_structure_students". */
export interface TeachingStructureStudentsOrderBy {
  id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  teaching_structure?: Maybe<TeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<OrderBy>;
  teaching_structure_students_subject_aggregate?: Maybe<SubjectsAggregateOrderBy>;
}

/** select columns of table "teaching_structure_students" */
export const enum TeachingStructureStudentsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id'
};

/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructures {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<Assignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<AssignmentsAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  depth: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  ltr: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  parent?: EntireFieldWrapper<Maybe<TeachingStructures>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<Semesters>>;
  /** A computed field, executes function "subject_icon" */
  subject_icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  teacher_subjects: EntireFieldWrapper<Array<TeacherSubject>>;
  /** An array relationship */
  teaching_structure_students: EntireFieldWrapper<Array<TeachingStructureStudents>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<TeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<TeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresAssignmentsArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<AssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<AssignmentsOrderBy>>;
  where?: Maybe<AssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresTeacherSubjectsArgs {
  distinct_on?: Maybe<Array<TeacherSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeacherSubjectOrderBy>>;
  where?: Maybe<TeacherSubjectBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresTeachingStructureStudentsArgs {
  distinct_on?: Maybe<Array<TeachingStructureStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructureStudentsOrderBy>>;
  where?: Maybe<TeachingStructureStudentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresTeachingStructuresArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface TeachingStructuresTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<TeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<TeachingStructuresOrderBy>>;
  where?: Maybe<TeachingStructuresBoolExp>;
}

/** aggregated selection of "teaching_structures" */
export interface TeachingStructuresAggregate {
  aggregate?: EntireFieldWrapper<Maybe<TeachingStructuresAggregateFields>>;
  nodes: EntireFieldWrapper<Array<TeachingStructures>>;
}

/** aggregate fields of "teaching_structures" */
export interface TeachingStructuresAggregateFields {
  avg?: EntireFieldWrapper<Maybe<TeachingStructuresAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<TeachingStructuresMaxFields>>;
  min?: EntireFieldWrapper<Maybe<TeachingStructuresMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<TeachingStructuresStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<TeachingStructuresStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<TeachingStructuresStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<TeachingStructuresSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<TeachingStructuresVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<TeachingStructuresVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<TeachingStructuresVarianceFields>>;
}


/** aggregate fields of "teaching_structures" */
export interface TeachingStructuresAggregateFieldsCountArgs {
  columns?: Maybe<Array<TeachingStructuresSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "teaching_structures" */
export interface TeachingStructuresAggregateOrderBy {
  avg?: Maybe<TeachingStructuresAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<TeachingStructuresMaxOrderBy>;
  min?: Maybe<TeachingStructuresMinOrderBy>;
  stddev?: Maybe<TeachingStructuresStddevOrderBy>;
  stddev_pop?: Maybe<TeachingStructuresStddevPopOrderBy>;
  stddev_samp?: Maybe<TeachingStructuresStddevSampOrderBy>;
  sum?: Maybe<TeachingStructuresSumOrderBy>;
  var_pop?: Maybe<TeachingStructuresVarPopOrderBy>;
  var_samp?: Maybe<TeachingStructuresVarSampOrderBy>;
  variance?: Maybe<TeachingStructuresVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface TeachingStructuresAvgFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "teaching_structures" */
export interface TeachingStructuresAvgOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structures". All fields are combined with a logical 'AND'. */
export interface TeachingStructuresBoolExp {
  _and?: Maybe<Array<TeachingStructuresBoolExp>>;
  _not?: Maybe<TeachingStructuresBoolExp>;
  _or?: Maybe<Array<TeachingStructuresBoolExp>>;
  assignments?: Maybe<AssignmentsBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  depth?: Maybe<IntComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  ltr?: Maybe<IntComparisonExp>;
  parent?: Maybe<TeachingStructuresBoolExp>;
  parent_id?: Maybe<UuidComparisonExp>;
  rtl?: Maybe<IntComparisonExp>;
  semester?: Maybe<SemestersBoolExp>;
  subject_icon?: Maybe<StringComparisonExp>;
  teacher_subjects?: Maybe<TeacherSubjectBoolExp>;
  teaching_structure_students?: Maybe<TeachingStructureStudentsBoolExp>;
  teaching_structures?: Maybe<TeachingStructuresBoolExp>;
  title?: Maybe<StringComparisonExp>;
  type_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface TeachingStructuresMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "teaching_structures" */
export interface TeachingStructuresMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  parent_id?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface TeachingStructuresMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "teaching_structures" */
export interface TeachingStructuresMinOrderBy {
  created_at?: Maybe<OrderBy>;
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  parent_id?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
  title?: Maybe<OrderBy>;
  type_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "teaching_structures". */
export interface TeachingStructuresOrderBy {
  assignments_aggregate?: Maybe<AssignmentsAggregateOrderBy>;
  created_at?: Maybe<OrderBy>;
  depth?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  parent?: Maybe<TeachingStructuresOrderBy>;
  parent_id?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
  semester?: Maybe<SemestersOrderBy>;
  subject_icon?: Maybe<OrderBy>;
  teacher_subjects_aggregate?: Maybe<TeacherSubjectAggregateOrderBy>;
  teaching_structure_students_aggregate?: Maybe<TeachingStructureStudentsAggregateOrderBy>;
  teaching_structures_aggregate?: Maybe<TeachingStructuresAggregateOrderBy>;
  title?: Maybe<OrderBy>;
  type_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "teaching_structures" */
export const enum TeachingStructuresSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface TeachingStructuresStddevFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "teaching_structures" */
export interface TeachingStructuresStddevOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate stddev_pop on columns */
export interface TeachingStructuresStddevPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "teaching_structures" */
export interface TeachingStructuresStddevPopOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate stddev_samp on columns */
export interface TeachingStructuresStddevSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "teaching_structures" */
export interface TeachingStructuresStddevSampOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate sum on columns */
export interface TeachingStructuresSumFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "teaching_structures" */
export interface TeachingStructuresSumOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate var_pop on columns */
export interface TeachingStructuresVarPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "teaching_structures" */
export interface TeachingStructuresVarPopOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate var_samp on columns */
export interface TeachingStructuresVarSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "teaching_structures" */
export interface TeachingStructuresVarSampOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}

/** aggregate variance on columns */
export interface TeachingStructuresVarianceFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "teaching_structures" */
export interface TeachingStructuresVarianceOrderBy {
  depth?: Maybe<OrderBy>;
  ltr?: Maybe<OrderBy>;
  rtl?: Maybe<OrderBy>;
}


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface TimestampComparisonExp {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
}


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface TimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export interface TimetzComparisonExp {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
}

/** columns and relationships of "users" */
export interface Users {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<AuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<PrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<PrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<PrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<PrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<Relationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<Relationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<RelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface UsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<RelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<RelationshipsOrderBy>>;
  where?: Maybe<RelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface UsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<UsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Users>>;
}

/** aggregate fields of "users" */
export interface UsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<UsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<UsersMinFields>>;
}


/** aggregate fields of "users" */
export interface UsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<UsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface UsersBoolExp {
  _and?: Maybe<Array<UsersBoolExp>>;
  _not?: Maybe<UsersBoolExp>;
  _or?: Maybe<Array<UsersBoolExp>>;
  account?: Maybe<AuthAccountsBoolExp>;
  address?: Maybe<PrivateAdressesBoolExp>;
  avatar_url?: Maybe<StringComparisonExp>;
  birthday?: Maybe<PrivateBirthdaysBoolExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  first_name?: Maybe<StringComparisonExp>;
  full_name?: Maybe<StringComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  insurance_number?: Maybe<PrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<StringComparisonExp>;
  phone_number?: Maybe<PrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<RelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<RelationshipsBoolExp>;
  title?: Maybe<StringComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum UsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface UsersInsertInput {
  account?: Maybe<AuthAccountsObjRelInsertInput>;
  address?: Maybe<PrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<PrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<PrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<PrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<RelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<RelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface UsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface UsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface UsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<Users>>;
}

/** input type for inserting object relation for remote table "users" */
export interface UsersObjRelInsertInput {
  data: UsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<UsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface UsersOnConflict {
  constraint: UsersConstraint;
  update_columns?: Array<UsersUpdateColumn>;
  where?: Maybe<UsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface UsersOrderBy {
  account?: Maybe<AuthAccountsOrderBy>;
  address?: Maybe<PrivateAdressesOrderBy>;
  avatar_url?: Maybe<OrderBy>;
  birthday?: Maybe<PrivateBirthdaysOrderBy>;
  created_at?: Maybe<OrderBy>;
  first_name?: Maybe<OrderBy>;
  full_name?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  insurance_number?: Maybe<PrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<OrderBy>;
  phone_number?: Maybe<PrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<RelationshipsAggregateOrderBy>;
  title?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** primary key columns input for table: users */
export interface UsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum UsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface UsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum UsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface UuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** columns and relationships of "view.assignment_class" */
export interface ViewAssignmentClass {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<Assignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<Classes>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.assignment_class" */
export interface ViewAssignmentClassAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ViewAssignmentClassMaxOrderBy>;
  min?: Maybe<ViewAssignmentClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.assignment_class". All fields are combined with a logical 'AND'. */
export interface ViewAssignmentClassBoolExp {
  _and?: Maybe<Array<ViewAssignmentClassBoolExp>>;
  _not?: Maybe<ViewAssignmentClassBoolExp>;
  _or?: Maybe<Array<ViewAssignmentClassBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  class?: Maybe<ClassesBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "view.assignment_class" */
export interface ViewAssignmentClassMaxOrderBy {
  assignment_id?: Maybe<OrderBy>;
  class_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "view.assignment_class" */
export interface ViewAssignmentClassMinOrderBy {
  assignment_id?: Maybe<OrderBy>;
  class_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "view.assignment_class". */
export interface ViewAssignmentClassOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  class?: Maybe<ClassesOrderBy>;
  class_id?: Maybe<OrderBy>;
}

/** select columns of table "view.assignment_class" */
export const enum ViewAssignmentClassSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id'
};

/** columns and relationships of "view.assignment_student_grade" */
export interface ViewAssignmentStudentGrade {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<Assignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  grade?: EntireFieldWrapper<Maybe<Grades>>;
  grade_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<Students>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.assignment_student_grade". All fields are combined with a logical 'AND'. */
export interface ViewAssignmentStudentGradeBoolExp {
  _and?: Maybe<Array<ViewAssignmentStudentGradeBoolExp>>;
  _not?: Maybe<ViewAssignmentStudentGradeBoolExp>;
  _or?: Maybe<Array<ViewAssignmentStudentGradeBoolExp>>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  grade?: Maybe<GradesBoolExp>;
  grade_id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "view.assignment_student_grade". */
export interface ViewAssignmentStudentGradeOrderBy {
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  grade?: Maybe<GradesOrderBy>;
  grade_id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
}

/** select columns of table "view.assignment_student_grade" */
export const enum ViewAssignmentStudentGradeSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  GRADE_ID = 'grade_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.class_student" */
export interface ViewClassStudent {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<Classes>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<Students>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.class_student". All fields are combined with a logical 'AND'. */
export interface ViewClassStudentBoolExp {
  _and?: Maybe<Array<ViewClassStudentBoolExp>>;
  _not?: Maybe<ViewClassStudentBoolExp>;
  _or?: Maybe<Array<ViewClassStudentBoolExp>>;
  class?: Maybe<ClassesBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
  student?: Maybe<StudentsBoolExp>;
  student_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "view.class_student". */
export interface ViewClassStudentOrderBy {
  class?: Maybe<ClassesOrderBy>;
  class_id?: Maybe<OrderBy>;
  student?: Maybe<StudentsOrderBy>;
  student_id?: Maybe<OrderBy>;
}

/** select columns of table "view.class_student" */
export const enum ViewClassStudentSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.grade_type_subject" */
export interface ViewGradeTypeSubject {
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<GradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<GradeTypes>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "view.grade_type_subject" */
export interface ViewGradeTypeSubjectGradeTypesArgs {
  distinct_on?: Maybe<Array<GradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<GradeTypesOrderBy>>;
  where?: Maybe<GradeTypesBoolExp>;
}

/** order by aggregate values of table "view.grade_type_subject" */
export interface ViewGradeTypeSubjectAggregateOrderBy {
  count?: Maybe<OrderBy>;
  max?: Maybe<ViewGradeTypeSubjectMaxOrderBy>;
  min?: Maybe<ViewGradeTypeSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grade_type_subject". All fields are combined with a logical 'AND'. */
export interface ViewGradeTypeSubjectBoolExp {
  _and?: Maybe<Array<ViewGradeTypeSubjectBoolExp>>;
  _not?: Maybe<ViewGradeTypeSubjectBoolExp>;
  _or?: Maybe<Array<ViewGradeTypeSubjectBoolExp>>;
  grade_type?: Maybe<GradeTypesBoolExp>;
  grade_type_id?: Maybe<UuidComparisonExp>;
  grade_types?: Maybe<GradeTypesBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "view.grade_type_subject" */
export interface ViewGradeTypeSubjectMaxOrderBy {
  grade_type_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "view.grade_type_subject" */
export interface ViewGradeTypeSubjectMinOrderBy {
  grade_type_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "view.grade_type_subject". */
export interface ViewGradeTypeSubjectOrderBy {
  grade_type?: Maybe<GradeTypesOrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  grade_types_aggregate?: Maybe<GradeTypesAggregateOrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** select columns of table "view.grade_type_subject" */
export const enum ViewGradeTypeSubjectSelectColumn {
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.grades" */
export interface ViewGrades {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<Semesters>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregated selection of "view.grades" */
export interface ViewGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<ViewGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<ViewGrades>>;
}

/** aggregate fields of "view.grades" */
export interface ViewGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<ViewGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<ViewGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<ViewGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<ViewGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<ViewGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<ViewGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<ViewGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<ViewGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<ViewGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<ViewGradesVarianceFields>>;
}


/** aggregate fields of "view.grades" */
export interface ViewGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<ViewGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "view.grades" */
export interface ViewGradesAggregateOrderBy {
  avg?: Maybe<ViewGradesAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ViewGradesMaxOrderBy>;
  min?: Maybe<ViewGradesMinOrderBy>;
  stddev?: Maybe<ViewGradesStddevOrderBy>;
  stddev_pop?: Maybe<ViewGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<ViewGradesStddevSampOrderBy>;
  sum?: Maybe<ViewGradesSumOrderBy>;
  var_pop?: Maybe<ViewGradesVarPopOrderBy>;
  var_samp?: Maybe<ViewGradesVarSampOrderBy>;
  variance?: Maybe<ViewGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface ViewGradesAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "view.grades" */
export interface ViewGradesAvgOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "view.grades". All fields are combined with a logical 'AND'. */
export interface ViewGradesBoolExp {
  _and?: Maybe<Array<ViewGradesBoolExp>>;
  _not?: Maybe<ViewGradesBoolExp>;
  _or?: Maybe<Array<ViewGradesBoolExp>>;
  created_at?: Maybe<TimetzComparisonExp>;
  created_date?: Maybe<DateComparisonExp>;
  grade_type?: Maybe<StringComparisonExp>;
  grade_type_id?: Maybe<UuidComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  semester?: Maybe<SemestersBoolExp>;
  semester_id?: Maybe<UuidComparisonExp>;
  student_id?: Maybe<UuidComparisonExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  value?: Maybe<IntComparisonExp>;
  weight?: Maybe<IntComparisonExp>;
}

/** columns and relationships of "view.grades_for_students" */
export interface ViewGradesForStudents {
  assigment_date?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<Assignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<Marks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<Subjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.grades_for_students". All fields are combined with a logical 'AND'. */
export interface ViewGradesForStudentsBoolExp {
  _and?: Maybe<Array<ViewGradesForStudentsBoolExp>>;
  _not?: Maybe<ViewGradesForStudentsBoolExp>;
  _or?: Maybe<Array<ViewGradesForStudentsBoolExp>>;
  assigment_date?: Maybe<TimestamptzComparisonExp>;
  assignment?: Maybe<AssignmentsBoolExp>;
  assignment_id?: Maybe<UuidComparisonExp>;
  comment?: Maybe<StringComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  mark?: Maybe<MarksBoolExp>;
  mark_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "view.grades_for_students". */
export interface ViewGradesForStudentsOrderBy {
  assigment_date?: Maybe<OrderBy>;
  assignment?: Maybe<AssignmentsOrderBy>;
  assignment_id?: Maybe<OrderBy>;
  comment?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  mark?: Maybe<MarksOrderBy>;
  mark_id?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "view.grades_for_students" */
export const enum ViewGradesForStudentsSelectColumn {
  /** column name */
  ASSIGMENT_DATE = 'assigment_date',
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate max on columns */
export interface ViewGradesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "view.grades" */
export interface ViewGradesMaxOrderBy {
  created_at?: Maybe<OrderBy>;
  created_date?: Maybe<OrderBy>;
  grade_type?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate min on columns */
export interface ViewGradesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "view.grades" */
export interface ViewGradesMinOrderBy {
  created_at?: Maybe<OrderBy>;
  created_date?: Maybe<OrderBy>;
  grade_type?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "view.grades". */
export interface ViewGradesOrderBy {
  created_at?: Maybe<OrderBy>;
  created_date?: Maybe<OrderBy>;
  grade_type?: Maybe<OrderBy>;
  grade_type_id?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  semester?: Maybe<SemestersOrderBy>;
  semester_id?: Maybe<OrderBy>;
  student_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** select columns of table "view.grades" */
export const enum ViewGradesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_DATE = 'created_date',
  /** column name */
  GRADE_TYPE = 'grade_type',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  VALUE = 'value',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface ViewGradesStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "view.grades" */
export interface ViewGradesStddevOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate stddev_pop on columns */
export interface ViewGradesStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "view.grades" */
export interface ViewGradesStddevPopOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate stddev_samp on columns */
export interface ViewGradesStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "view.grades" */
export interface ViewGradesStddevSampOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate sum on columns */
export interface ViewGradesSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "view.grades" */
export interface ViewGradesSumOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate var_pop on columns */
export interface ViewGradesVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "view.grades" */
export interface ViewGradesVarPopOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate var_samp on columns */
export interface ViewGradesVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "view.grades" */
export interface ViewGradesVarSampOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** aggregate variance on columns */
export interface ViewGradesVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "view.grades" */
export interface ViewGradesVarianceOrderBy {
  value?: Maybe<OrderBy>;
  weight?: Maybe<OrderBy>;
}

/** columns and relationships of "view.latest_chat_messages" */
export interface ViewLatestChatMessages {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<Chats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user?: EntireFieldWrapper<Maybe<Users>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "view.latest_chat_messages" */
export interface ViewLatestChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<ViewLatestChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<ViewLatestChatMessages>>;
}

/** aggregate fields of "view.latest_chat_messages" */
export interface ViewLatestChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<ViewLatestChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<ViewLatestChatMessagesMinFields>>;
}


/** aggregate fields of "view.latest_chat_messages" */
export interface ViewLatestChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<ViewLatestChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "view.latest_chat_messages". All fields are combined with a logical 'AND'. */
export interface ViewLatestChatMessagesBoolExp {
  _and?: Maybe<Array<ViewLatestChatMessagesBoolExp>>;
  _not?: Maybe<ViewLatestChatMessagesBoolExp>;
  _or?: Maybe<Array<ViewLatestChatMessagesBoolExp>>;
  body?: Maybe<StringComparisonExp>;
  chat?: Maybe<ChatsBoolExp>;
  chat_id?: Maybe<UuidComparisonExp>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  user_id?: Maybe<UuidComparisonExp>;
}

/** aggregate max on columns */
export interface ViewLatestChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface ViewLatestChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "view.latest_chat_messages". */
export interface ViewLatestChatMessagesOrderBy {
  body?: Maybe<OrderBy>;
  chat?: Maybe<ChatsOrderBy>;
  chat_id?: Maybe<OrderBy>;
  created_at?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  user_id?: Maybe<OrderBy>;
}

/** select columns of table "view.latest_chat_messages" */
export const enum ViewLatestChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMark {
  avg?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
  count?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  max?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  min?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkAggregateOrderBy {
  avg?: Maybe<ViewStatisticsSemesterSubjectMarkAvgOrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<ViewStatisticsSemesterSubjectMarkMaxOrderBy>;
  min?: Maybe<ViewStatisticsSemesterSubjectMarkMinOrderBy>;
  stddev?: Maybe<ViewStatisticsSemesterSubjectMarkStddevOrderBy>;
  stddev_pop?: Maybe<ViewStatisticsSemesterSubjectMarkStddevPopOrderBy>;
  stddev_samp?: Maybe<ViewStatisticsSemesterSubjectMarkStddevSampOrderBy>;
  sum?: Maybe<ViewStatisticsSemesterSubjectMarkSumOrderBy>;
  var_pop?: Maybe<ViewStatisticsSemesterSubjectMarkVarPopOrderBy>;
  var_samp?: Maybe<ViewStatisticsSemesterSubjectMarkVarSampOrderBy>;
  variance?: Maybe<ViewStatisticsSemesterSubjectMarkVarianceOrderBy>;
}

/** order by avg() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkAvgOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** Boolean expression to filter rows from the table "view.statistics_semester_subject_mark". All fields are combined with a logical 'AND'. */
export interface ViewStatisticsSemesterSubjectMarkBoolExp {
  _and?: Maybe<Array<ViewStatisticsSemesterSubjectMarkBoolExp>>;
  _not?: Maybe<ViewStatisticsSemesterSubjectMarkBoolExp>;
  _or?: Maybe<Array<ViewStatisticsSemesterSubjectMarkBoolExp>>;
  avg?: Maybe<NumericComparisonExp>;
  count?: Maybe<BigintComparisonExp>;
  max?: Maybe<IntComparisonExp>;
  min?: Maybe<IntComparisonExp>;
  semester_id?: Maybe<UuidComparisonExp>;
  subject_id?: Maybe<UuidComparisonExp>;
}

/** order by max() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkMaxOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** order by min() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkMinOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** Ordering options when selecting data from "view.statistics_semester_subject_mark". */
export interface ViewStatisticsSemesterSubjectMarkOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
  semester_id?: Maybe<OrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** select columns of table "view.statistics_semester_subject_mark" */
export const enum ViewStatisticsSemesterSubjectMarkSelectColumn {
  /** column name */
  AVG = 'avg',
  /** column name */
  COUNT = 'count',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** order by stddev() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkStddevOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by stddev_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkStddevPopOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by stddev_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkStddevSampOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by sum() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkSumOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by var_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkVarPopOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by var_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkVarSampOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** order by variance() on columns of table "view.statistics_semester_subject_mark" */
export interface ViewStatisticsSemesterSubjectMarkVarianceOrderBy {
  avg?: Maybe<OrderBy>;
  count?: Maybe<OrderBy>;
  max?: Maybe<OrderBy>;
  min?: Maybe<OrderBy>;
}

/** columns and relationships of "view.subject_semester" */
export interface ViewSubjectSemester {
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<Subjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.subject_semester". All fields are combined with a logical 'AND'. */
export interface ViewSubjectSemesterBoolExp {
  _and?: Maybe<Array<ViewSubjectSemesterBoolExp>>;
  _not?: Maybe<ViewSubjectSemesterBoolExp>;
  _or?: Maybe<Array<ViewSubjectSemesterBoolExp>>;
  semester_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "view.subject_semester". */
export interface ViewSubjectSemesterOrderBy {
  semester_id?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
}

/** select columns of table "view.subject_semester" */
export const enum ViewSubjectSemesterSelectColumn {
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.teacher_class_subject" */
export interface ViewTeacherClassSubject {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<Classes>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<Subjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.teacher_class_subject". All fields are combined with a logical 'AND'. */
export interface ViewTeacherClassSubjectBoolExp {
  _and?: Maybe<Array<ViewTeacherClassSubjectBoolExp>>;
  _not?: Maybe<ViewTeacherClassSubjectBoolExp>;
  _or?: Maybe<Array<ViewTeacherClassSubjectBoolExp>>;
  class?: Maybe<ClassesBoolExp>;
  class_id?: Maybe<UuidComparisonExp>;
  subject?: Maybe<SubjectsBoolExp>;
  subject_id?: Maybe<UuidComparisonExp>;
  teacher_id?: Maybe<UuidComparisonExp>;
}

/** Ordering options when selecting data from "view.teacher_class_subject". */
export interface ViewTeacherClassSubjectOrderBy {
  class?: Maybe<ClassesOrderBy>;
  class_id?: Maybe<OrderBy>;
  subject?: Maybe<SubjectsOrderBy>;
  subject_id?: Maybe<OrderBy>;
  teacher_id?: Maybe<OrderBy>;
}

/** select columns of table "view.teacher_class_subject" */
export const enum ViewTeacherClassSubjectSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "years" */
export interface Years {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "year_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<Promotions>>;
  start_date: EntireFieldWrapper<Scalars['date']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "years" */
export interface YearsPromotionsArgs {
  distinct_on?: Maybe<Array<PromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<PromotionsOrderBy>>;
  where?: Maybe<PromotionsBoolExp>;
}

/** aggregated selection of "years" */
export interface YearsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<YearsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<Years>>;
}

/** aggregate fields of "years" */
export interface YearsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<YearsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<YearsMinFields>>;
}


/** aggregate fields of "years" */
export interface YearsAggregateFieldsCountArgs {
  columns?: Maybe<Array<YearsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "years". All fields are combined with a logical 'AND'. */
export interface YearsBoolExp {
  _and?: Maybe<Array<YearsBoolExp>>;
  _not?: Maybe<YearsBoolExp>;
  _or?: Maybe<Array<YearsBoolExp>>;
  created_at?: Maybe<TimestamptzComparisonExp>;
  end_date?: Maybe<DateComparisonExp>;
  id?: Maybe<UuidComparisonExp>;
  name?: Maybe<StringComparisonExp>;
  promotions?: Maybe<PromotionsBoolExp>;
  start_date?: Maybe<DateComparisonExp>;
  updated_at?: Maybe<TimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface YearsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface YearsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** Ordering options when selecting data from "years". */
export interface YearsOrderBy {
  created_at?: Maybe<OrderBy>;
  end_date?: Maybe<OrderBy>;
  id?: Maybe<OrderBy>;
  name?: Maybe<OrderBy>;
  promotions_aggregate?: Maybe<PromotionsAggregateOrderBy>;
  start_date?: Maybe<OrderBy>;
  updated_at?: Maybe<OrderBy>;
}

/** select columns of table "years" */
export const enum YearsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_DATE = 'end_date',
  /** column name */
  ID = 'id',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export type AssignmentGradeWeightsQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignmentGradeWeightsQuery = { assignment_grade_weights: Array<{ id: string, value: any }> };

export type AssignmentsQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  show_completed?: Maybe<BooleanComparisonExp>;
  due_at?: Maybe<TimestamptzComparisonExp>;
}>;


export type AssignmentsQuery = { totalCount: { aggregate?: Maybe<{ count: number }> }, assignments: Array<{ id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }> };

export type DeleteAssignmentNoteMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type DeleteAssignmentNoteMutation = { delete_assignment_notes_by_pk?: Maybe<{ id: string }> };

export type GetMyNotesByAssignmentIdQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
  _eq1?: Maybe<Scalars['uuid']>;
}>;


export type GetMyNotesByAssignmentIdQuery = { assignment_notes: Array<{ content: string, id: string, created_at?: Maybe<string> }> };

export type InsertNoteMutationVariables = Exact<{
  user_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  assignment_id?: Maybe<Scalars['uuid']>;
}>;


export type InsertNoteMutation = { insert_assignment_notes?: Maybe<{ affected_rows: number }> };

export type UpdateAssignmentMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
}>;


export type UpdateAssignmentMutation = { update_assignment_notes_by_pk?: Maybe<{ content: string }> };

export type ChangePasswordMutationVariables = Exact<{
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}>;


export type ChangePasswordMutation = { change_password?: Maybe<{ message?: Maybe<string> }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { me?: Maybe<{ id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> }> };

export type ResetPasswordMutationVariables = Exact<{
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}>;


export type ResetPasswordMutation = { reset_password?: Maybe<{ message?: Maybe<string> }> };

export type RevokeTokenMutationVariables = Exact<{
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}>;


export type RevokeTokenMutation = { revoke_token?: Maybe<{ message?: Maybe<string> }> };

export type BookBySubjectQueryVariables = Exact<{
  subject_id: Scalars['uuid'];
  with_notes?: Maybe<Scalars['Boolean']>;
  with_body?: Maybe<Scalars['Boolean']>;
}>;


export type BookBySubjectQuery = { books: Array<{ id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> }> };

export type ChapterSectionQueryVariables = Exact<{
  id: Scalars['uuid'];
  with_notes?: Maybe<Scalars['Boolean']>;
  with_body?: Maybe<Scalars['Boolean']>;
}>;


export type ChapterSectionQuery = { chapter_sections_by_pk?: Maybe<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type ChatByTypeGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatByTypeGroupQuery = { chats: Array<{ id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> }> };

export type ChatByTypePrivateQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatByTypePrivateQuery = { chats: Array<{ id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> }> };

export type ChatParticipantsPrivateQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type ChatParticipantsPrivateQuery = { chat_user: Array<{ chat: { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> } }> };

export type DeleteLikeMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteLikeMutation = { delete_chat_message_likes_by_pk?: Maybe<{ id: string }> };

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeleteMessageMutation = { delete_chat_messages_by_pk?: Maybe<{ id: string }> };

export type ChatInsertByTypeGroupMutationVariables = Exact<{
  title: Scalars['String'];
  avatar_url: Scalars['String'];
}>;


export type ChatInsertByTypeGroupMutation = { insert_chats_one?: Maybe<{ id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> }> };

export type ChatInsertUserMutationVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type ChatInsertUserMutation = { insert_chat_user_one?: Maybe<{ chat: { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> } }> };

export type LatestChatsQueryVariables = Exact<{
  user_id: Scalars['uuid'];
}>;


export type LatestChatsQuery = { chat_messages: Array<{ id?: Maybe<string>, body?: Maybe<string>, chat_id?: Maybe<string>, created_at?: Maybe<string>, user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }>, chat?: Maybe<{ id: string, title?: Maybe<string>, type: ChatTypeEnum }> }> };

export type LikeMessageMutationVariables = Exact<{
  chat_message_id: Scalars['uuid'];
}>;


export type LikeMessageMutation = { insert_chat_message_likes_one?: Maybe<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }> };

export type ChatMessageReadMutationVariables = Exact<{
  conversation_id: Scalars['uuid'];
}>;


export type ChatMessageReadMutation = { update_chat_message_reads?: Maybe<{ affected_rows: number }> };

export type ChatMessagesQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  chat_id: Scalars['uuid'];
}>;


export type ChatMessagesQuery = { chat_messages: Array<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, chat_messages_aggregate: { aggregate?: Maybe<{ count: number }> } };

export type UpdateMessageMutationVariables = Exact<{
  id: Scalars['uuid'];
  body: Scalars['String'];
}>;


export type UpdateMessageMutation = { update_chat_messages_by_pk?: Maybe<{ id: string }> };

export type CheckForSubscibtionQueryVariables = Exact<{
  user_id?: Maybe<Scalars['uuid']>;
  assignment_id?: Maybe<Scalars['uuid']>;
}>;


export type CheckForSubscibtionQuery = { assignment_discussion_subscription: Array<{ is_notification_enabled: boolean, assignment_discussion_id: string, id: string }> };

export type CreateDiscussionMutationVariables = Exact<{
  title?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
  assignment_id?: Maybe<Scalars['uuid']>;
}>;


export type CreateDiscussionMutation = { insert_assignment_discussion_one?: Maybe<{ id: string }> };

export type GetDiscussionsQueryVariables = Exact<{
  _eq?: Maybe<Scalars['uuid']>;
}>;


export type GetDiscussionsQuery = { assignment_discussion: Array<{ title?: Maybe<string>, id: string, user_id: string, assignment_discussion_contents: Array<{ content: string, created_at: string, id: string, user_id: string, replay_to?: Maybe<{ id: string, content: string }>, student?: Maybe<{ user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, teacher?: Maybe<{ user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> }> }> };

export type InsertDiscussionContentMutationVariables = Exact<{
  parent_id?: Maybe<Scalars['uuid']>;
  content?: Maybe<Scalars['String']>;
  assignment_discussion_id?: Maybe<Scalars['uuid']>;
  user_id?: Maybe<Scalars['uuid']>;
}>;


export type InsertDiscussionContentMutation = { insert_assignment_discussion_content_one?: Maybe<{ id: string }> };

export type UpdateMySubscriptionMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
  is_notification_enabled?: Maybe<Scalars['Boolean']>;
}>;


export type UpdateMySubscriptionMutation = { update_assignment_discussion_subscription_by_pk?: Maybe<{ id: string }> };

export type GetMyProfilePictureByIdQueryVariables = Exact<{
  userId?: Maybe<Scalars['uuid']>;
}>;


export type GetMyProfilePictureByIdQuery = { files: Array<{ id: string }> };

export type DeleteFileByIdMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type DeleteFileByIdMutation = { delete_files_by_pk?: Maybe<{ id: string }> };

export type GetLatestActivitiesQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetLatestActivitiesQuery = { latest_activities: Array<{ created_at?: Maybe<string>, id: string, message: string, path?: Maybe<string> }> };

export type LessonsQueryVariables = Exact<{
  date?: Maybe<Scalars['date']>;
}>;


export type LessonsQuery = { lessons: Array<{ id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } }> };

export type GetLiveClassDetailsByIdQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type GetLiveClassDetailsByIdQuery = { live_classes_by_pk?: Maybe<{ id: string, name: string, duration: number, description?: Maybe<string>, starting_at?: Maybe<string>, status?: Maybe<string> }> };

export type MarksQueryVariables = Exact<{ [key: string]: never; }>;


export type MarksQuery = { marks: Array<{ name: string, value: number }> };

export type GetNotificationsQueryVariables = Exact<{
  user_id?: Maybe<Scalars['uuid']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type GetNotificationsQuery = { notifications: Array<{ content: string, created_at: string, id: string, is_read: boolean, user_id: string, path?: Maybe<string> }>, notifications_aggregate: { aggregate?: Maybe<{ count: number }> } };

export type UpdateNotificationsMutationVariables = Exact<{
  object: Array<NotificationsInsertInput> | NotificationsInsertInput;
}>;


export type UpdateNotificationsMutation = { insert_notifications?: Maybe<{ affected_rows: number }> };

export type GetSemestersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSemestersQuery = { semesters: Array<{ id: string, start_at: any, end_at: any, teaching_structure?: Maybe<{ id: string, title: string, parent?: Maybe<{ title: string, id: string }> }> }> };

export type StudentsByClassQueryVariables = Exact<{
  class_id?: Maybe<Scalars['uuid']>;
}>;


export type StudentsByClassQuery = { students: Array<{ id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> }> };

export type StudentsMyClassQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentsMyClassQuery = { view_class_student: Array<{ student?: Maybe<{ id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> }> }> };

export type PossibleParticipantsQueryVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type PossibleParticipantsQuery = { view_class_student: Array<{ student?: Maybe<{ id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> }> }> };

export type SubjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type SubjectsQuery = { subjects: Array<{ id: string, name: string, icon?: Maybe<string> }> };

export type DeleteTaskMutationVariables = Exact<{
  id?: Maybe<Scalars['uuid']>;
}>;


export type DeleteTaskMutation = { delete_tasks_by_pk?: Maybe<{ id: string }> };

export type TasksQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  show_completed?: Maybe<BooleanComparisonExp>;
}>;


export type TasksQuery = { tasks: Array<{ id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean }>, tasks_aggregate: { aggregate?: Maybe<{ count: number }> } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: Maybe<{ id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> }> };

export type PrivateQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivateQuery = { private_adresses: Array<{ street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string }>, private_birthdays: Array<{ date: any }>, private_insurance_numbers: Array<{ name: string }>, private_phone_numbers: Array<{ country_code: string, number: string, created_at: string, updated_at: string }> };

export type UpdateAvatarUrlMutationVariables = Exact<{
  avatar_url: Scalars['String'];
}>;


export type UpdateAvatarUrlMutation = { update_users?: Maybe<{ affected_rows: number }> };

export type UpsertPrivateMutationVariables = Exact<{
  user: UsersSetInput;
  adress: PrivateAdressesInsertInput;
  phone_number: PrivatePhoneNumbersInsertInput;
}>;


export type UpsertPrivateMutation = { update_users?: Maybe<{ returning: Array<{ first_name?: Maybe<string>, last_name?: Maybe<string> }> }>, insert_private_adresses_one?: Maybe<{ id: string }>, insert_private_phone_numbers_one?: Maybe<{ id: string }> };

export type YearsQueryVariables = Exact<{ [key: string]: never; }>;


export type YearsQuery = { years: Array<{ id: string, name?: Maybe<string>, start_date: any, end_date: any }> };

export type AdressFragment = { street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string };

export type AssignmentFragment = { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> };

export type AggregateAssignmentFragment = { aggregate?: Maybe<{ count: number }> };

export type AssignmentClassFragment = { class?: Maybe<{ name?: Maybe<string>, id: string }> };

export type AssignmentGradeFragment = { id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> };

export type AssignmentStudentFragment = { user?: Maybe<{ id: string, full_name?: Maybe<string> }>, assignment: { id: string } };

export type AssignmentStudentGradeFragment = { student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> };

export type AssignmentTotalCountFragment = { aggregate?: Maybe<{ count: number }> };

export type AssignmentTypeFragment = { name: string, icon?: Maybe<string> };

export type BookFragment = { id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> };

export type ChapterFragment = { id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type ChatFragment = { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type ChatMessageFragment = { id: string, body: string, user_id: string, chat_id: string, created_at: string };

export type KClassFragment = { name?: Maybe<string>, id: string };

export type ClassStudentFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type ChatTypeFragment = { name: string, description: string };

export type FileFragment = { id: string, file_name: string, foreign_id: string, path: string };

export type GradeFragment = { id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } };

export type LessonFragment = { id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } };

export type MarkFragment = { name: string, value: number };

export type MessageFragment = { id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type MessageAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type NoteFragment = { id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type PhoneNumberFragment = { country_code: string, number: string, created_at: string, updated_at: string };

export type PrivateChatFragment = { id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type SectionFragment = { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> };

export type SectionTypeFragment = { name: string, icon?: Maybe<string> };

export type SemesterFragment = { id: string, start_at: any, end_at: any };

export type StudentFragment = { id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> };

export type SubjectFragment = { id: string, name: string, icon?: Maybe<string> };

export type TaskFragment = { id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean };

export type TasksAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type TeacherFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type UserFragment = { id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> };

export type YearFragment = { id: string, name?: Maybe<string>, start_date: any, end_date: any };

export const AdressFragmentDoc = gql`
    fragment Adress on private_adresses {
  street
  area
  city
  postal_code
  country
  created_at
  updated_at
}
    `;
export const AssignmentTypeFragmentDoc = gql`
    fragment AssignmentType on assignment_type {
  name
  icon
}
    `;
export const FileFragmentDoc = gql`
    fragment File on files {
  id
  file_name
  foreign_id
  path
}
    `;
export const AssignmentFragmentDoc = gql`
    fragment Assignment on assignments {
  id
  title
  description
  duration
  due_at
  due_at_filter
  created_at
  assignment_users {
    user_id
    id
  }
  chat {
    title
    id
  }
  teaching_structure {
    subject_icon
    subject_icon
    id
    ltr
    rtl
  }
  assignment_type {
    ...AssignmentType
  }
  lesson {
    course {
      subject {
        name
      }
    }
  }
  is_gradeable
  is_completed
  lesson {
    course {
      subject {
        name
      }
    }
  }
  user {
    full_name
  }
  grade_weight: assignment_grade_weight {
    id
    value
    comment
  }
  files {
    ...File
  }
}
    ${AssignmentTypeFragmentDoc}
${FileFragmentDoc}`;
export const AggregateAssignmentFragmentDoc = gql`
    fragment AggregateAssignment on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const KClassFragmentDoc = gql`
    fragment KClass on classes {
  name
  id
}
    `;
export const AssignmentClassFragmentDoc = gql`
    fragment AssignmentClass on view_assignment_class {
  class {
    ...KClass
  }
}
    ${KClassFragmentDoc}`;
export const AssignmentGradeFragmentDoc = gql`
    fragment AssignmentGrade on grades {
  id
  student {
    id
    user {
      full_name
    }
  }
  mark {
    id
    value
  }
}
    `;
export const AssignmentStudentFragmentDoc = gql`
    fragment AssignmentStudent on assignment_user {
  user {
    id
    full_name
  }
  assignment {
    id
  }
}
    `;
export const AssignmentStudentGradeFragmentDoc = gql`
    fragment AssignmentStudentGrade on view_assignment_student_grade {
  student {
    id
    user {
      full_name
    }
  }
  grade {
    id
    mark {
      id
      value
    }
  }
}
    `;
export const AssignmentTotalCountFragmentDoc = gql`
    fragment AssignmentTotalCount on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const SectionTypeFragmentDoc = gql`
    fragment SectionType on chapter_section_type {
  name
  icon
}
    `;
export const NoteFragmentDoc = gql`
    fragment Note on chapter_section_notes {
  id
  body
  created_at
  user {
    full_name
    avatar_url
  }
}
    `;
export const SectionFragmentDoc = gql`
    fragment Section on chapter_sections {
  id
  title
  body @include(if: $with_body)
  duration_left
  duration_total: duration
  is_completed
  type: chapter_section_type {
    ...SectionType
  }
  notes: chapter_section_notes @include(if: $with_notes) {
    ...Note
  }
}
    ${SectionTypeFragmentDoc}
${NoteFragmentDoc}`;
export const ChapterFragmentDoc = gql`
    fragment Chapter on book_chapters {
  id
  title
  duration_left
  due_at
  type: book_chapter_type {
    name
    description
  }
  sections: chapter_sections(order_by: {sort: asc}) {
    ...Section
  }
}
    ${SectionFragmentDoc}`;
export const BookFragmentDoc = gql`
    fragment Book on books {
  id
  title
  book_chapters {
    ...Chapter
  }
}
    ${ChapterFragmentDoc}`;
export const ChatFragmentDoc = gql`
    fragment Chat on chats {
  id
  title
  avatar_url
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_messages {
  id
  body
  user_id
  chat_id
  created_at
}
    `;
export const ClassStudentFragmentDoc = gql`
    fragment ClassStudent on students {
  id
  user {
    full_name
  }
}
    `;
export const ChatTypeFragmentDoc = gql`
    fragment ChatType on chat_type {
  name
  description
}
    `;
export const GradeFragmentDoc = gql`
    fragment Grade on grades {
  id
  weight
  comment
  mark {
    id
    name
    value
  }
  assignment {
    title
    type: assignment_type {
      name
      icon
    }
    lesson {
      course {
        subject {
          id
          name
        }
      }
    }
  }
}
    `;
export const TeacherFragmentDoc = gql`
    fragment Teacher on teachers {
  id
  user {
    full_name
  }
}
    `;
export const LessonFragmentDoc = gql`
    fragment Lesson on lessons {
  id
  start_at
  start_date
  course {
    id
    subject {
      id
      name
    }
    course_teachers {
      teacher {
        ...Teacher
      }
    }
  }
  description
}
    ${TeacherFragmentDoc}`;
export const MarkFragmentDoc = gql`
    fragment Mark on marks {
  name
  value
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on chat_messages {
  id
  body
  user_id
  chat_id
  is_pinned
  created_at
  replys {
    id
    body
    user_id
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  likes: chat_message_likes {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
  responding: chat_message {
    id
    body
    user_id
    chat_id
    is_pinned
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  user {
    first_name
    last_name
    avatar_url
  }
}
    `;
export const MessageAggregateFragmentDoc = gql`
    fragment MessageAggregate on chat_messages_aggregate {
  aggregate {
    count
  }
}
    `;
export const PhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on private_phone_numbers {
  country_code
  number
  created_at
  updated_at
}
    `;
export const PrivateChatFragmentDoc = gql`
    fragment PrivateChat on chats {
  id
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const SemesterFragmentDoc = gql`
    fragment Semester on semesters {
  id
  start_at
  end_at
}
    `;
export const StudentFragmentDoc = gql`
    fragment Student on students {
  id
  user {
    avatar_url
    full_name
  }
}
    `;
export const SubjectFragmentDoc = gql`
    fragment Subject on subjects {
  id
  name
  icon
}
    `;
export const TaskFragmentDoc = gql`
    fragment Task on tasks {
  id
  body
  title
  is_completed
}
    `;
export const TasksAggregateFragmentDoc = gql`
    fragment TasksAggregate on tasks_aggregate {
  aggregate {
    count
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserData {
  id
  last_name
  first_name
  email
  birthday_at
  avatar_url
  mobile
  street_address
  title
  role
  is_verified
  assignments
  live_class
  grading
  chat
}
    `;
export const YearFragmentDoc = gql`
    fragment Year on years {
  id
  name
  start_date
  end_date
}
    `;
export const AssignmentGradeWeightsDocument = gql`
    query AssignmentGradeWeights {
  assignment_grade_weights {
    id
    value
  }
}
    `;

/**
 * __useAssignmentGradeWeightsQuery__
 *
 * To run a query within a React component, call `useAssignmentGradeWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentGradeWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentGradeWeightsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignmentGradeWeightsQuery(baseOptions?: Apollo.QueryHookOptions<AssignmentGradeWeightsQuery, AssignmentGradeWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentGradeWeightsQuery, AssignmentGradeWeightsQueryVariables>(AssignmentGradeWeightsDocument, options);
      }
export function useAssignmentGradeWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentGradeWeightsQuery, AssignmentGradeWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentGradeWeightsQuery, AssignmentGradeWeightsQueryVariables>(AssignmentGradeWeightsDocument, options);
        }
export type AssignmentGradeWeightsQueryHookResult = ReturnType<typeof useAssignmentGradeWeightsQuery>;
export type AssignmentGradeWeightsLazyQueryHookResult = ReturnType<typeof useAssignmentGradeWeightsLazyQuery>;
export type AssignmentGradeWeightsQueryResult = Apollo.QueryResult<AssignmentGradeWeightsQuery, AssignmentGradeWeightsQueryVariables>;
export const AssignmentsDocument = gql`
    query Assignments($limit: Int = 9, $offset: Int = 0, $show_completed: Boolean_comparison_exp = {}, $due_at: timestamptz_comparison_exp = {}) {
  totalCount: assignments_aggregate(
    where: {type: {_eq: TASK}, is_completed: $show_completed}
  ) {
    ...AggregateAssignment
  }
  assignments: assignments(
    limit: $limit
    offset: $offset
    order_by: {due_at: asc}
    where: {is_completed: $show_completed, type: {_eq: TASK}, due_at: $due_at}
  ) {
    ...Assignment
  }
}
    ${AggregateAssignmentFragmentDoc}
${AssignmentFragmentDoc}`;

/**
 * __useAssignmentsQuery__
 *
 * To run a query within a React component, call `useAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      show_completed: // value for 'show_completed'
 *      due_at: // value for 'due_at'
 *   },
 * });
 */
export function useAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentsQuery, AssignmentsQueryVariables>(AssignmentsDocument, options);
      }
export function useAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentsQuery, AssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentsQuery, AssignmentsQueryVariables>(AssignmentsDocument, options);
        }
export type AssignmentsQueryHookResult = ReturnType<typeof useAssignmentsQuery>;
export type AssignmentsLazyQueryHookResult = ReturnType<typeof useAssignmentsLazyQuery>;
export type AssignmentsQueryResult = Apollo.QueryResult<AssignmentsQuery, AssignmentsQueryVariables>;
export const DeleteAssignmentNoteDocument = gql`
    mutation deleteAssignmentNote($id: uuid = "") {
  delete_assignment_notes_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteAssignmentNoteMutationFn = Apollo.MutationFunction<DeleteAssignmentNoteMutation, DeleteAssignmentNoteMutationVariables>;

/**
 * __useDeleteAssignmentNoteMutation__
 *
 * To run a mutation, you first call `useDeleteAssignmentNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAssignmentNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAssignmentNoteMutation, { data, loading, error }] = useDeleteAssignmentNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAssignmentNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAssignmentNoteMutation, DeleteAssignmentNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAssignmentNoteMutation, DeleteAssignmentNoteMutationVariables>(DeleteAssignmentNoteDocument, options);
      }
export type DeleteAssignmentNoteMutationHookResult = ReturnType<typeof useDeleteAssignmentNoteMutation>;
export type DeleteAssignmentNoteMutationResult = Apollo.MutationResult<DeleteAssignmentNoteMutation>;
export type DeleteAssignmentNoteMutationOptions = Apollo.BaseMutationOptions<DeleteAssignmentNoteMutation, DeleteAssignmentNoteMutationVariables>;
export const GetMyNotesByAssignmentIdDocument = gql`
    query getMyNotesByAssignmentId($_eq: uuid = "", $_eq1: uuid = "") {
  assignment_notes(
    where: {assignment_id: {_eq: $_eq}, user_id: {_eq: $_eq1}}
    order_by: {created_at: asc}
  ) {
    content
    id
    created_at
  }
}
    `;

/**
 * __useGetMyNotesByAssignmentIdQuery__
 *
 * To run a query within a React component, call `useGetMyNotesByAssignmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotesByAssignmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotesByAssignmentIdQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *      _eq1: // value for '_eq1'
 *   },
 * });
 */
export function useGetMyNotesByAssignmentIdQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>(GetMyNotesByAssignmentIdDocument, options);
      }
export function useGetMyNotesByAssignmentIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>(GetMyNotesByAssignmentIdDocument, options);
        }
export type GetMyNotesByAssignmentIdQueryHookResult = ReturnType<typeof useGetMyNotesByAssignmentIdQuery>;
export type GetMyNotesByAssignmentIdLazyQueryHookResult = ReturnType<typeof useGetMyNotesByAssignmentIdLazyQuery>;
export type GetMyNotesByAssignmentIdQueryResult = Apollo.QueryResult<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>;
export const InsertNoteDocument = gql`
    mutation insertNote($user_id: uuid = "", $content: String = "", $assignment_id: uuid = "") {
  insert_assignment_notes(
    objects: {user_id: $user_id, content: $content, assignment_id: $assignment_id}
  ) {
    affected_rows
  }
}
    `;
export type InsertNoteMutationFn = Apollo.MutationFunction<InsertNoteMutation, InsertNoteMutationVariables>;

/**
 * __useInsertNoteMutation__
 *
 * To run a mutation, you first call `useInsertNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNoteMutation, { data, loading, error }] = useInsertNoteMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      content: // value for 'content'
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useInsertNoteMutation(baseOptions?: Apollo.MutationHookOptions<InsertNoteMutation, InsertNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNoteMutation, InsertNoteMutationVariables>(InsertNoteDocument, options);
      }
export type InsertNoteMutationHookResult = ReturnType<typeof useInsertNoteMutation>;
export type InsertNoteMutationResult = Apollo.MutationResult<InsertNoteMutation>;
export type InsertNoteMutationOptions = Apollo.BaseMutationOptions<InsertNoteMutation, InsertNoteMutationVariables>;
export const UpdateAssignmentDocument = gql`
    mutation updateAssignment($id: uuid = "", $content: String = "") {
  update_assignment_notes_by_pk(pk_columns: {id: $id}, _set: {content: $content}) {
    content
  }
}
    `;
export type UpdateAssignmentMutationFn = Apollo.MutationFunction<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;

/**
 * __useUpdateAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdateAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignmentMutation, { data, loading, error }] = useUpdateAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>(UpdateAssignmentDocument, options);
      }
export type UpdateAssignmentMutationHookResult = ReturnType<typeof useUpdateAssignmentMutation>;
export type UpdateAssignmentMutationResult = Apollo.MutationResult<UpdateAssignmentMutation>;
export type UpdateAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($new_password: String!, $old_password: String!) {
  change_password(new_password: $new_password, old_password: $old_password) {
    message
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      new_password: // value for 'new_password'
 *      old_password: // value for 'old_password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($new_password: String!, $old_password: String!) {
  reset_password(new_password: $new_password, old_password: $old_password) {
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      new_password: // value for 'new_password'
 *      old_password: // value for 'old_password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const RevokeTokenDocument = gql`
    mutation RevokeToken($all: Boolean = false, $refresh_token: String!) {
  revoke_token(refresh_token: $refresh_token, all: $all) {
    message
  }
}
    `;
export type RevokeTokenMutationFn = Apollo.MutationFunction<RevokeTokenMutation, RevokeTokenMutationVariables>;

/**
 * __useRevokeTokenMutation__
 *
 * To run a mutation, you first call `useRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeTokenMutation, { data, loading, error }] = useRevokeTokenMutation({
 *   variables: {
 *      all: // value for 'all'
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useRevokeTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeTokenMutation, RevokeTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeTokenMutation, RevokeTokenMutationVariables>(RevokeTokenDocument, options);
      }
export type RevokeTokenMutationHookResult = ReturnType<typeof useRevokeTokenMutation>;
export type RevokeTokenMutationResult = Apollo.MutationResult<RevokeTokenMutation>;
export type RevokeTokenMutationOptions = Apollo.BaseMutationOptions<RevokeTokenMutation, RevokeTokenMutationVariables>;
export const BookBySubjectDocument = gql`
    query BookBySubject($subject_id: uuid!, $with_notes: Boolean = false, $with_body: Boolean = true) {
  books(order_by: {sort: asc}, where: {subject_id: {_eq: $subject_id}}) {
    ...Book
  }
}
    ${BookFragmentDoc}`;

/**
 * __useBookBySubjectQuery__
 *
 * To run a query within a React component, call `useBookBySubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookBySubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookBySubjectQuery({
 *   variables: {
 *      subject_id: // value for 'subject_id'
 *      with_notes: // value for 'with_notes'
 *      with_body: // value for 'with_body'
 *   },
 * });
 */
export function useBookBySubjectQuery(baseOptions: Apollo.QueryHookOptions<BookBySubjectQuery, BookBySubjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookBySubjectQuery, BookBySubjectQueryVariables>(BookBySubjectDocument, options);
      }
export function useBookBySubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookBySubjectQuery, BookBySubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookBySubjectQuery, BookBySubjectQueryVariables>(BookBySubjectDocument, options);
        }
export type BookBySubjectQueryHookResult = ReturnType<typeof useBookBySubjectQuery>;
export type BookBySubjectLazyQueryHookResult = ReturnType<typeof useBookBySubjectLazyQuery>;
export type BookBySubjectQueryResult = Apollo.QueryResult<BookBySubjectQuery, BookBySubjectQueryVariables>;
export const ChapterSectionDocument = gql`
    query ChapterSection($id: uuid!, $with_notes: Boolean = false, $with_body: Boolean = false) {
  chapter_sections_by_pk(id: $id) {
    ...Section
  }
}
    ${SectionFragmentDoc}`;

/**
 * __useChapterSectionQuery__
 *
 * To run a query within a React component, call `useChapterSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChapterSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChapterSectionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      with_notes: // value for 'with_notes'
 *      with_body: // value for 'with_body'
 *   },
 * });
 */
export function useChapterSectionQuery(baseOptions: Apollo.QueryHookOptions<ChapterSectionQuery, ChapterSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChapterSectionQuery, ChapterSectionQueryVariables>(ChapterSectionDocument, options);
      }
export function useChapterSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChapterSectionQuery, ChapterSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChapterSectionQuery, ChapterSectionQueryVariables>(ChapterSectionDocument, options);
        }
export type ChapterSectionQueryHookResult = ReturnType<typeof useChapterSectionQuery>;
export type ChapterSectionLazyQueryHookResult = ReturnType<typeof useChapterSectionLazyQuery>;
export type ChapterSectionQueryResult = Apollo.QueryResult<ChapterSectionQuery, ChapterSectionQueryVariables>;
export const ChatByTypeGroupDocument = gql`
    query ChatByTypeGroup {
  chats(where: {type: {_eq: GROUP}}) {
    ...Chat
  }
}
    ${ChatFragmentDoc}`;

/**
 * __useChatByTypeGroupQuery__
 *
 * To run a query within a React component, call `useChatByTypeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatByTypeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatByTypeGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatByTypeGroupQuery(baseOptions?: Apollo.QueryHookOptions<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>(ChatByTypeGroupDocument, options);
      }
export function useChatByTypeGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>(ChatByTypeGroupDocument, options);
        }
export type ChatByTypeGroupQueryHookResult = ReturnType<typeof useChatByTypeGroupQuery>;
export type ChatByTypeGroupLazyQueryHookResult = ReturnType<typeof useChatByTypeGroupLazyQuery>;
export type ChatByTypeGroupQueryResult = Apollo.QueryResult<ChatByTypeGroupQuery, ChatByTypeGroupQueryVariables>;
export const ChatByTypePrivateDocument = gql`
    query ChatByTypePrivate {
  chats(where: {type: {_eq: PRIVATE}}) {
    ...PrivateChat
  }
}
    ${PrivateChatFragmentDoc}`;

/**
 * __useChatByTypePrivateQuery__
 *
 * To run a query within a React component, call `useChatByTypePrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatByTypePrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatByTypePrivateQuery({
 *   variables: {
 *   },
 * });
 */
export function useChatByTypePrivateQuery(baseOptions?: Apollo.QueryHookOptions<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>(ChatByTypePrivateDocument, options);
      }
export function useChatByTypePrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>(ChatByTypePrivateDocument, options);
        }
export type ChatByTypePrivateQueryHookResult = ReturnType<typeof useChatByTypePrivateQuery>;
export type ChatByTypePrivateLazyQueryHookResult = ReturnType<typeof useChatByTypePrivateLazyQuery>;
export type ChatByTypePrivateQueryResult = Apollo.QueryResult<ChatByTypePrivateQuery, ChatByTypePrivateQueryVariables>;
export const ChatParticipantsPrivateDocument = gql`
    query ChatParticipantsPrivate($user_id: uuid!) {
  chat_user(where: {user_id: {_eq: $user_id}, chat: {type: {_eq: PRIVATE}}}) {
    chat {
      ...Chat
    }
  }
}
    ${ChatFragmentDoc}`;

/**
 * __useChatParticipantsPrivateQuery__
 *
 * To run a query within a React component, call `useChatParticipantsPrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatParticipantsPrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatParticipantsPrivateQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useChatParticipantsPrivateQuery(baseOptions: Apollo.QueryHookOptions<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>(ChatParticipantsPrivateDocument, options);
      }
export function useChatParticipantsPrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>(ChatParticipantsPrivateDocument, options);
        }
export type ChatParticipantsPrivateQueryHookResult = ReturnType<typeof useChatParticipantsPrivateQuery>;
export type ChatParticipantsPrivateLazyQueryHookResult = ReturnType<typeof useChatParticipantsPrivateLazyQuery>;
export type ChatParticipantsPrivateQueryResult = Apollo.QueryResult<ChatParticipantsPrivateQuery, ChatParticipantsPrivateQueryVariables>;
export const DeleteLikeDocument = gql`
    mutation DeleteLike($id: uuid!) {
  delete_chat_message_likes_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteLikeMutationFn = Apollo.MutationFunction<DeleteLikeMutation, DeleteLikeMutationVariables>;

/**
 * __useDeleteLikeMutation__
 *
 * To run a mutation, you first call `useDeleteLikeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLikeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLikeMutation, { data, loading, error }] = useDeleteLikeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLikeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLikeMutation, DeleteLikeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLikeMutation, DeleteLikeMutationVariables>(DeleteLikeDocument, options);
      }
export type DeleteLikeMutationHookResult = ReturnType<typeof useDeleteLikeMutation>;
export type DeleteLikeMutationResult = Apollo.MutationResult<DeleteLikeMutation>;
export type DeleteLikeMutationOptions = Apollo.BaseMutationOptions<DeleteLikeMutation, DeleteLikeMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($id: uuid!) {
  delete_chat_messages_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const ChatInsertByTypeGroupDocument = gql`
    mutation ChatInsertByTypeGroup($title: String!, $avatar_url: String!) {
  insert_chats_one(object: {title: $title, avatar_url: $avatar_url, type: GROUP}) {
    ...Chat
  }
}
    ${ChatFragmentDoc}`;
export type ChatInsertByTypeGroupMutationFn = Apollo.MutationFunction<ChatInsertByTypeGroupMutation, ChatInsertByTypeGroupMutationVariables>;

/**
 * __useChatInsertByTypeGroupMutation__
 *
 * To run a mutation, you first call `useChatInsertByTypeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatInsertByTypeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatInsertByTypeGroupMutation, { data, loading, error }] = useChatInsertByTypeGroupMutation({
 *   variables: {
 *      title: // value for 'title'
 *      avatar_url: // value for 'avatar_url'
 *   },
 * });
 */
export function useChatInsertByTypeGroupMutation(baseOptions?: Apollo.MutationHookOptions<ChatInsertByTypeGroupMutation, ChatInsertByTypeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatInsertByTypeGroupMutation, ChatInsertByTypeGroupMutationVariables>(ChatInsertByTypeGroupDocument, options);
      }
export type ChatInsertByTypeGroupMutationHookResult = ReturnType<typeof useChatInsertByTypeGroupMutation>;
export type ChatInsertByTypeGroupMutationResult = Apollo.MutationResult<ChatInsertByTypeGroupMutation>;
export type ChatInsertByTypeGroupMutationOptions = Apollo.BaseMutationOptions<ChatInsertByTypeGroupMutation, ChatInsertByTypeGroupMutationVariables>;
export const ChatInsertUserDocument = gql`
    mutation ChatInsertUser($user_id: uuid!) {
  insert_chat_user_one(object: {user_id: $user_id, chat: {data: {}}}) {
    chat {
      ...Chat
    }
  }
}
    ${ChatFragmentDoc}`;
export type ChatInsertUserMutationFn = Apollo.MutationFunction<ChatInsertUserMutation, ChatInsertUserMutationVariables>;

/**
 * __useChatInsertUserMutation__
 *
 * To run a mutation, you first call `useChatInsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatInsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatInsertUserMutation, { data, loading, error }] = useChatInsertUserMutation({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useChatInsertUserMutation(baseOptions?: Apollo.MutationHookOptions<ChatInsertUserMutation, ChatInsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatInsertUserMutation, ChatInsertUserMutationVariables>(ChatInsertUserDocument, options);
      }
export type ChatInsertUserMutationHookResult = ReturnType<typeof useChatInsertUserMutation>;
export type ChatInsertUserMutationResult = Apollo.MutationResult<ChatInsertUserMutation>;
export type ChatInsertUserMutationOptions = Apollo.BaseMutationOptions<ChatInsertUserMutation, ChatInsertUserMutationVariables>;
export const LatestChatsDocument = gql`
    query LatestChats($user_id: uuid!) {
  chat_messages: view_latest_chat_messages(
    limit: 4
    where: {user_id: {_neq: $user_id}}
  ) {
    id
    body
    chat_id
    created_at
    user {
      id
      full_name
      avatar_url
    }
    chat {
      id
      title
      type
    }
  }
}
    `;

/**
 * __useLatestChatsQuery__
 *
 * To run a query within a React component, call `useLatestChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestChatsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useLatestChatsQuery(baseOptions: Apollo.QueryHookOptions<LatestChatsQuery, LatestChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestChatsQuery, LatestChatsQueryVariables>(LatestChatsDocument, options);
      }
export function useLatestChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestChatsQuery, LatestChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestChatsQuery, LatestChatsQueryVariables>(LatestChatsDocument, options);
        }
export type LatestChatsQueryHookResult = ReturnType<typeof useLatestChatsQuery>;
export type LatestChatsLazyQueryHookResult = ReturnType<typeof useLatestChatsLazyQuery>;
export type LatestChatsQueryResult = Apollo.QueryResult<LatestChatsQuery, LatestChatsQueryVariables>;
export const LikeMessageDocument = gql`
    mutation LikeMessage($chat_message_id: uuid!) {
  insert_chat_message_likes_one(object: {chat_message_id: $chat_message_id}) {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
}
    `;
export type LikeMessageMutationFn = Apollo.MutationFunction<LikeMessageMutation, LikeMessageMutationVariables>;

/**
 * __useLikeMessageMutation__
 *
 * To run a mutation, you first call `useLikeMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeMessageMutation, { data, loading, error }] = useLikeMessageMutation({
 *   variables: {
 *      chat_message_id: // value for 'chat_message_id'
 *   },
 * });
 */
export function useLikeMessageMutation(baseOptions?: Apollo.MutationHookOptions<LikeMessageMutation, LikeMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeMessageMutation, LikeMessageMutationVariables>(LikeMessageDocument, options);
      }
export type LikeMessageMutationHookResult = ReturnType<typeof useLikeMessageMutation>;
export type LikeMessageMutationResult = Apollo.MutationResult<LikeMessageMutation>;
export type LikeMessageMutationOptions = Apollo.BaseMutationOptions<LikeMessageMutation, LikeMessageMutationVariables>;
export const ChatMessageReadDocument = gql`
    mutation ChatMessageRead($conversation_id: uuid!) {
  update_chat_message_reads(
    _set: {is_read: true}
    where: {chat_message: {chat_id: {_eq: $conversation_id}}}
  ) {
    affected_rows
  }
}
    `;
export type ChatMessageReadMutationFn = Apollo.MutationFunction<ChatMessageReadMutation, ChatMessageReadMutationVariables>;

/**
 * __useChatMessageReadMutation__
 *
 * To run a mutation, you first call `useChatMessageReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatMessageReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatMessageReadMutation, { data, loading, error }] = useChatMessageReadMutation({
 *   variables: {
 *      conversation_id: // value for 'conversation_id'
 *   },
 * });
 */
export function useChatMessageReadMutation(baseOptions?: Apollo.MutationHookOptions<ChatMessageReadMutation, ChatMessageReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatMessageReadMutation, ChatMessageReadMutationVariables>(ChatMessageReadDocument, options);
      }
export type ChatMessageReadMutationHookResult = ReturnType<typeof useChatMessageReadMutation>;
export type ChatMessageReadMutationResult = Apollo.MutationResult<ChatMessageReadMutation>;
export type ChatMessageReadMutationOptions = Apollo.BaseMutationOptions<ChatMessageReadMutation, ChatMessageReadMutationVariables>;
export const ChatMessagesDocument = gql`
    query ChatMessages($limit: Int = 9, $offset: Int = 0, $chat_id: uuid!) {
  chat_messages(
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
    where: {chat_id: {_eq: $chat_id}}
  ) {
    ...Message
  }
  chat_messages_aggregate(where: {chat_id: {_eq: $chat_id}}) {
    ...MessageAggregate
  }
}
    ${MessageFragmentDoc}
${MessageAggregateFragmentDoc}`;

/**
 * __useChatMessagesQuery__
 *
 * To run a query within a React component, call `useChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatMessagesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      chat_id: // value for 'chat_id'
 *   },
 * });
 */
export function useChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
      }
export function useChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatMessagesQuery, ChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatMessagesQuery, ChatMessagesQueryVariables>(ChatMessagesDocument, options);
        }
export type ChatMessagesQueryHookResult = ReturnType<typeof useChatMessagesQuery>;
export type ChatMessagesLazyQueryHookResult = ReturnType<typeof useChatMessagesLazyQuery>;
export type ChatMessagesQueryResult = Apollo.QueryResult<ChatMessagesQuery, ChatMessagesQueryVariables>;
export const UpdateMessageDocument = gql`
    mutation UpdateMessage($id: uuid!, $body: String!) {
  update_chat_messages_by_pk(_set: {body: $body}, pk_columns: {id: $id}) {
    id
  }
}
    `;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const CheckForSubscibtionDocument = gql`
    query checkForSubscibtion($user_id: uuid = "", $assignment_id: uuid = "") {
  assignment_discussion_subscription(
    where: {user_id: {_eq: $user_id}, assignment_discussion: {assignment_id: {_eq: $assignment_id}}}
  ) {
    is_notification_enabled
    assignment_discussion_id
    id
  }
}
    `;

/**
 * __useCheckForSubscibtionQuery__
 *
 * To run a query within a React component, call `useCheckForSubscibtionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckForSubscibtionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckForSubscibtionQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useCheckForSubscibtionQuery(baseOptions?: Apollo.QueryHookOptions<CheckForSubscibtionQuery, CheckForSubscibtionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckForSubscibtionQuery, CheckForSubscibtionQueryVariables>(CheckForSubscibtionDocument, options);
      }
export function useCheckForSubscibtionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckForSubscibtionQuery, CheckForSubscibtionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckForSubscibtionQuery, CheckForSubscibtionQueryVariables>(CheckForSubscibtionDocument, options);
        }
export type CheckForSubscibtionQueryHookResult = ReturnType<typeof useCheckForSubscibtionQuery>;
export type CheckForSubscibtionLazyQueryHookResult = ReturnType<typeof useCheckForSubscibtionLazyQuery>;
export type CheckForSubscibtionQueryResult = Apollo.QueryResult<CheckForSubscibtionQuery, CheckForSubscibtionQueryVariables>;
export const CreateDiscussionDocument = gql`
    mutation createDiscussion($title: String = "", $user_id: uuid = "", $assignment_id: uuid = "") {
  insert_assignment_discussion_one(
    object: {title: $title, user_id: $user_id, assignment_id: $assignment_id}
  ) {
    id
  }
}
    `;
export type CreateDiscussionMutationFn = Apollo.MutationFunction<CreateDiscussionMutation, CreateDiscussionMutationVariables>;

/**
 * __useCreateDiscussionMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionMutation, { data, loading, error }] = useCreateDiscussionMutation({
 *   variables: {
 *      title: // value for 'title'
 *      user_id: // value for 'user_id'
 *      assignment_id: // value for 'assignment_id'
 *   },
 * });
 */
export function useCreateDiscussionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscussionMutation, CreateDiscussionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscussionMutation, CreateDiscussionMutationVariables>(CreateDiscussionDocument, options);
      }
export type CreateDiscussionMutationHookResult = ReturnType<typeof useCreateDiscussionMutation>;
export type CreateDiscussionMutationResult = Apollo.MutationResult<CreateDiscussionMutation>;
export type CreateDiscussionMutationOptions = Apollo.BaseMutationOptions<CreateDiscussionMutation, CreateDiscussionMutationVariables>;
export const GetDiscussionsDocument = gql`
    query GetDiscussions($_eq: uuid = "") {
  assignment_discussion(where: {assignment_id: {_eq: $_eq}}) {
    title
    id
    user_id
    assignment_discussion_contents(order_by: {created_at: asc}) {
      content
      created_at
      id
      user_id
      replay_to {
        id
        content
      }
      student {
        user {
          full_name
          avatar_url
        }
      }
      teacher {
        user {
          full_name
          avatar_url
        }
      }
    }
  }
}
    `;

/**
 * __useGetDiscussionsQuery__
 *
 * To run a query within a React component, call `useGetDiscussionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscussionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscussionsQuery({
 *   variables: {
 *      _eq: // value for '_eq'
 *   },
 * });
 */
export function useGetDiscussionsQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscussionsQuery, GetDiscussionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscussionsQuery, GetDiscussionsQueryVariables>(GetDiscussionsDocument, options);
      }
export function useGetDiscussionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscussionsQuery, GetDiscussionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscussionsQuery, GetDiscussionsQueryVariables>(GetDiscussionsDocument, options);
        }
export type GetDiscussionsQueryHookResult = ReturnType<typeof useGetDiscussionsQuery>;
export type GetDiscussionsLazyQueryHookResult = ReturnType<typeof useGetDiscussionsLazyQuery>;
export type GetDiscussionsQueryResult = Apollo.QueryResult<GetDiscussionsQuery, GetDiscussionsQueryVariables>;
export const InsertDiscussionContentDocument = gql`
    mutation insertDiscussionContent($parent_id: uuid = "", $content: String = "", $assignment_discussion_id: uuid = "", $user_id: uuid = "") {
  insert_assignment_discussion_content_one(
    object: {parent_id: $parent_id, content: $content, assignment_discussion_id: $assignment_discussion_id, user_id: $user_id}
  ) {
    id
  }
}
    `;
export type InsertDiscussionContentMutationFn = Apollo.MutationFunction<InsertDiscussionContentMutation, InsertDiscussionContentMutationVariables>;

/**
 * __useInsertDiscussionContentMutation__
 *
 * To run a mutation, you first call `useInsertDiscussionContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertDiscussionContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertDiscussionContentMutation, { data, loading, error }] = useInsertDiscussionContentMutation({
 *   variables: {
 *      parent_id: // value for 'parent_id'
 *      content: // value for 'content'
 *      assignment_discussion_id: // value for 'assignment_discussion_id'
 *      user_id: // value for 'user_id'
 *   },
 * });
 */
export function useInsertDiscussionContentMutation(baseOptions?: Apollo.MutationHookOptions<InsertDiscussionContentMutation, InsertDiscussionContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertDiscussionContentMutation, InsertDiscussionContentMutationVariables>(InsertDiscussionContentDocument, options);
      }
export type InsertDiscussionContentMutationHookResult = ReturnType<typeof useInsertDiscussionContentMutation>;
export type InsertDiscussionContentMutationResult = Apollo.MutationResult<InsertDiscussionContentMutation>;
export type InsertDiscussionContentMutationOptions = Apollo.BaseMutationOptions<InsertDiscussionContentMutation, InsertDiscussionContentMutationVariables>;
export const UpdateMySubscriptionDocument = gql`
    mutation updateMySubscription($id: uuid = "", $is_notification_enabled: Boolean = false) {
  update_assignment_discussion_subscription_by_pk(
    pk_columns: {id: $id}
    _set: {is_notification_enabled: $is_notification_enabled}
  ) {
    id
  }
}
    `;
export type UpdateMySubscriptionMutationFn = Apollo.MutationFunction<UpdateMySubscriptionMutation, UpdateMySubscriptionMutationVariables>;

/**
 * __useUpdateMySubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateMySubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMySubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMySubscriptionMutation, { data, loading, error }] = useUpdateMySubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_notification_enabled: // value for 'is_notification_enabled'
 *   },
 * });
 */
export function useUpdateMySubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMySubscriptionMutation, UpdateMySubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMySubscriptionMutation, UpdateMySubscriptionMutationVariables>(UpdateMySubscriptionDocument, options);
      }
export type UpdateMySubscriptionMutationHookResult = ReturnType<typeof useUpdateMySubscriptionMutation>;
export type UpdateMySubscriptionMutationResult = Apollo.MutationResult<UpdateMySubscriptionMutation>;
export type UpdateMySubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateMySubscriptionMutation, UpdateMySubscriptionMutationVariables>;
export const GetMyProfilePictureByIdDocument = gql`
    query GetMyProfilePictureById($userId: uuid = "") {
  files(
    where: {foreign_id: {_eq: $userId}}
    order_by: {created_at: desc}
    limit: 1
  ) {
    id
  }
}
    `;

/**
 * __useGetMyProfilePictureByIdQuery__
 *
 * To run a query within a React component, call `useGetMyProfilePictureByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfilePictureByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfilePictureByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyProfilePictureByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfilePictureByIdQuery, GetMyProfilePictureByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProfilePictureByIdQuery, GetMyProfilePictureByIdQueryVariables>(GetMyProfilePictureByIdDocument, options);
      }
export function useGetMyProfilePictureByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfilePictureByIdQuery, GetMyProfilePictureByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProfilePictureByIdQuery, GetMyProfilePictureByIdQueryVariables>(GetMyProfilePictureByIdDocument, options);
        }
export type GetMyProfilePictureByIdQueryHookResult = ReturnType<typeof useGetMyProfilePictureByIdQuery>;
export type GetMyProfilePictureByIdLazyQueryHookResult = ReturnType<typeof useGetMyProfilePictureByIdLazyQuery>;
export type GetMyProfilePictureByIdQueryResult = Apollo.QueryResult<GetMyProfilePictureByIdQuery, GetMyProfilePictureByIdQueryVariables>;
export const DeleteFileByIdDocument = gql`
    mutation DeleteFileById($id: uuid = "") {
  delete_files_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteFileByIdMutationFn = Apollo.MutationFunction<DeleteFileByIdMutation, DeleteFileByIdMutationVariables>;

/**
 * __useDeleteFileByIdMutation__
 *
 * To run a mutation, you first call `useDeleteFileByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileByIdMutation, { data, loading, error }] = useDeleteFileByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileByIdMutation, DeleteFileByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileByIdMutation, DeleteFileByIdMutationVariables>(DeleteFileByIdDocument, options);
      }
export type DeleteFileByIdMutationHookResult = ReturnType<typeof useDeleteFileByIdMutation>;
export type DeleteFileByIdMutationResult = Apollo.MutationResult<DeleteFileByIdMutation>;
export type DeleteFileByIdMutationOptions = Apollo.BaseMutationOptions<DeleteFileByIdMutation, DeleteFileByIdMutationVariables>;
export const GetLatestActivitiesDocument = gql`
    query GetLatestActivities($limit: Int = 10, $offset: Int = 0) {
  latest_activities(limit: $limit, offset: $offset) {
    created_at
    id
    message
    path
  }
}
    `;

/**
 * __useGetLatestActivitiesQuery__
 *
 * To run a query within a React component, call `useGetLatestActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetLatestActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>(GetLatestActivitiesDocument, options);
      }
export function useGetLatestActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>(GetLatestActivitiesDocument, options);
        }
export type GetLatestActivitiesQueryHookResult = ReturnType<typeof useGetLatestActivitiesQuery>;
export type GetLatestActivitiesLazyQueryHookResult = ReturnType<typeof useGetLatestActivitiesLazyQuery>;
export type GetLatestActivitiesQueryResult = Apollo.QueryResult<GetLatestActivitiesQuery, GetLatestActivitiesQueryVariables>;
export const LessonsDocument = gql`
    query Lessons($date: date) {
  lessons: lessons(where: {start_date: {_eq: $date}}, order_by: {start_at: asc}) {
    ...Lesson
  }
}
    ${LessonFragmentDoc}`;

/**
 * __useLessonsQuery__
 *
 * To run a query within a React component, call `useLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonsQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useLessonsQuery(baseOptions?: Apollo.QueryHookOptions<LessonsQuery, LessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonsQuery, LessonsQueryVariables>(LessonsDocument, options);
      }
export function useLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonsQuery, LessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonsQuery, LessonsQueryVariables>(LessonsDocument, options);
        }
export type LessonsQueryHookResult = ReturnType<typeof useLessonsQuery>;
export type LessonsLazyQueryHookResult = ReturnType<typeof useLessonsLazyQuery>;
export type LessonsQueryResult = Apollo.QueryResult<LessonsQuery, LessonsQueryVariables>;
export const GetLiveClassDetailsByIdDocument = gql`
    query GetLiveClassDetailsByID($id: uuid = "") {
  live_classes_by_pk(id: $id) {
    id
    name
    duration
    description
    starting_at
    status
  }
}
    `;

/**
 * __useGetLiveClassDetailsByIdQuery__
 *
 * To run a query within a React component, call `useGetLiveClassDetailsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiveClassDetailsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiveClassDetailsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLiveClassDetailsByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>(GetLiveClassDetailsByIdDocument, options);
      }
export function useGetLiveClassDetailsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>(GetLiveClassDetailsByIdDocument, options);
        }
export type GetLiveClassDetailsByIdQueryHookResult = ReturnType<typeof useGetLiveClassDetailsByIdQuery>;
export type GetLiveClassDetailsByIdLazyQueryHookResult = ReturnType<typeof useGetLiveClassDetailsByIdLazyQuery>;
export type GetLiveClassDetailsByIdQueryResult = Apollo.QueryResult<GetLiveClassDetailsByIdQuery, GetLiveClassDetailsByIdQueryVariables>;
export const MarksDocument = gql`
    query Marks {
  marks {
    ...Mark
  }
}
    ${MarkFragmentDoc}`;

/**
 * __useMarksQuery__
 *
 * To run a query within a React component, call `useMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMarksQuery(baseOptions?: Apollo.QueryHookOptions<MarksQuery, MarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarksQuery, MarksQueryVariables>(MarksDocument, options);
      }
export function useMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarksQuery, MarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarksQuery, MarksQueryVariables>(MarksDocument, options);
        }
export type MarksQueryHookResult = ReturnType<typeof useMarksQuery>;
export type MarksLazyQueryHookResult = ReturnType<typeof useMarksLazyQuery>;
export type MarksQueryResult = Apollo.QueryResult<MarksQuery, MarksQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($user_id: uuid = "", $offset: Int = 0) {
  notifications(
    where: {user_id: {_eq: $user_id}}
    order_by: {created_at: desc}
    offset: $offset
  ) {
    content
    created_at
    id
    is_read
    user_id
    path
  }
  notifications_aggregate(
    where: {is_read: {_eq: false}, user_id: {_eq: $user_id}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const UpdateNotificationsDocument = gql`
    mutation UpdateNotifications($object: [notifications_insert_input!]!) {
  insert_notifications(
    objects: $object
    on_conflict: {update_columns: is_read, constraint: notifications_pkey}
  ) {
    affected_rows
  }
}
    `;
export type UpdateNotificationsMutationFn = Apollo.MutationFunction<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;

/**
 * __useUpdateNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsMutation, { data, loading, error }] = useUpdateNotificationsMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpdateNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>(UpdateNotificationsDocument, options);
      }
export type UpdateNotificationsMutationHookResult = ReturnType<typeof useUpdateNotificationsMutation>;
export type UpdateNotificationsMutationResult = Apollo.MutationResult<UpdateNotificationsMutation>;
export type UpdateNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;
export const GetSemestersDocument = gql`
    query getSemesters {
  semesters {
    id
    start_at
    end_at
    teaching_structure {
      id
      title
      parent {
        title
        id
      }
    }
  }
}
    `;

/**
 * __useGetSemestersQuery__
 *
 * To run a query within a React component, call `useGetSemestersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSemestersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSemestersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSemestersQuery(baseOptions?: Apollo.QueryHookOptions<GetSemestersQuery, GetSemestersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSemestersQuery, GetSemestersQueryVariables>(GetSemestersDocument, options);
      }
export function useGetSemestersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSemestersQuery, GetSemestersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSemestersQuery, GetSemestersQueryVariables>(GetSemestersDocument, options);
        }
export type GetSemestersQueryHookResult = ReturnType<typeof useGetSemestersQuery>;
export type GetSemestersLazyQueryHookResult = ReturnType<typeof useGetSemestersLazyQuery>;
export type GetSemestersQueryResult = Apollo.QueryResult<GetSemestersQuery, GetSemestersQueryVariables>;
export const StudentsByClassDocument = gql`
    query StudentsByClass($class_id: uuid) {
  students(where: {class_id: {_eq: $class_id}}) {
    ...Student
  }
}
    ${StudentFragmentDoc}`;

/**
 * __useStudentsByClassQuery__
 *
 * To run a query within a React component, call `useStudentsByClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsByClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsByClassQuery({
 *   variables: {
 *      class_id: // value for 'class_id'
 *   },
 * });
 */
export function useStudentsByClassQuery(baseOptions?: Apollo.QueryHookOptions<StudentsByClassQuery, StudentsByClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsByClassQuery, StudentsByClassQueryVariables>(StudentsByClassDocument, options);
      }
export function useStudentsByClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsByClassQuery, StudentsByClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsByClassQuery, StudentsByClassQueryVariables>(StudentsByClassDocument, options);
        }
export type StudentsByClassQueryHookResult = ReturnType<typeof useStudentsByClassQuery>;
export type StudentsByClassLazyQueryHookResult = ReturnType<typeof useStudentsByClassLazyQuery>;
export type StudentsByClassQueryResult = Apollo.QueryResult<StudentsByClassQuery, StudentsByClassQueryVariables>;
export const StudentsMyClassDocument = gql`
    query StudentsMyClass {
  view_class_student {
    student {
      ...Student
    }
  }
}
    ${StudentFragmentDoc}`;

/**
 * __useStudentsMyClassQuery__
 *
 * To run a query within a React component, call `useStudentsMyClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsMyClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsMyClassQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentsMyClassQuery(baseOptions?: Apollo.QueryHookOptions<StudentsMyClassQuery, StudentsMyClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsMyClassQuery, StudentsMyClassQueryVariables>(StudentsMyClassDocument, options);
      }
export function useStudentsMyClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsMyClassQuery, StudentsMyClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsMyClassQuery, StudentsMyClassQueryVariables>(StudentsMyClassDocument, options);
        }
export type StudentsMyClassQueryHookResult = ReturnType<typeof useStudentsMyClassQuery>;
export type StudentsMyClassLazyQueryHookResult = ReturnType<typeof useStudentsMyClassLazyQuery>;
export type StudentsMyClassQueryResult = Apollo.QueryResult<StudentsMyClassQuery, StudentsMyClassQueryVariables>;
export const PossibleParticipantsDocument = gql`
    query PossibleParticipants($id: uuid = "") {
  view_class_student(where: {_not: {student_id: {_eq: $id}}}) {
    student {
      ...Student
    }
  }
}
    ${StudentFragmentDoc}`;

/**
 * __usePossibleParticipantsQuery__
 *
 * To run a query within a React component, call `usePossibleParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePossibleParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePossibleParticipantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePossibleParticipantsQuery(baseOptions?: Apollo.QueryHookOptions<PossibleParticipantsQuery, PossibleParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PossibleParticipantsQuery, PossibleParticipantsQueryVariables>(PossibleParticipantsDocument, options);
      }
export function usePossibleParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PossibleParticipantsQuery, PossibleParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PossibleParticipantsQuery, PossibleParticipantsQueryVariables>(PossibleParticipantsDocument, options);
        }
export type PossibleParticipantsQueryHookResult = ReturnType<typeof usePossibleParticipantsQuery>;
export type PossibleParticipantsLazyQueryHookResult = ReturnType<typeof usePossibleParticipantsLazyQuery>;
export type PossibleParticipantsQueryResult = Apollo.QueryResult<PossibleParticipantsQuery, PossibleParticipantsQueryVariables>;
export const SubjectsDocument = gql`
    query Subjects {
  subjects {
    ...Subject
  }
}
    ${SubjectFragmentDoc}`;

/**
 * __useSubjectsQuery__
 *
 * To run a query within a React component, call `useSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<SubjectsQuery, SubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubjectsQuery, SubjectsQueryVariables>(SubjectsDocument, options);
      }
export function useSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubjectsQuery, SubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubjectsQuery, SubjectsQueryVariables>(SubjectsDocument, options);
        }
export type SubjectsQueryHookResult = ReturnType<typeof useSubjectsQuery>;
export type SubjectsLazyQueryHookResult = ReturnType<typeof useSubjectsLazyQuery>;
export type SubjectsQueryResult = Apollo.QueryResult<SubjectsQuery, SubjectsQueryVariables>;
export const DeleteTaskDocument = gql`
    mutation DeleteTask($id: uuid = "") {
  delete_tasks_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteTaskMutationFn = Apollo.MutationFunction<DeleteTaskMutation, DeleteTaskMutationVariables>;

/**
 * __useDeleteTaskMutation__
 *
 * To run a mutation, you first call `useDeleteTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskMutation, { data, loading, error }] = useDeleteTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskMutation, DeleteTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskMutation, DeleteTaskMutationVariables>(DeleteTaskDocument, options);
      }
export type DeleteTaskMutationHookResult = ReturnType<typeof useDeleteTaskMutation>;
export type DeleteTaskMutationResult = Apollo.MutationResult<DeleteTaskMutation>;
export type DeleteTaskMutationOptions = Apollo.BaseMutationOptions<DeleteTaskMutation, DeleteTaskMutationVariables>;
export const TasksDocument = gql`
    query Tasks($limit: Int = 6, $offset: Int = 0, $show_completed: Boolean_comparison_exp = {}) {
  tasks(
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
    where: {is_completed: $show_completed}
  ) {
    ...Task
  }
  tasks_aggregate(where: {is_completed: $show_completed}) {
    ...TasksAggregate
  }
}
    ${TaskFragmentDoc}
${TasksAggregateFragmentDoc}`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      show_completed: // value for 'show_completed'
 *   },
 * });
 */
export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const PrivateDocument = gql`
    query Private {
  private_adresses {
    ...Adress
  }
  private_birthdays {
    date
  }
  private_insurance_numbers {
    name
  }
  private_phone_numbers {
    ...PhoneNumber
  }
}
    ${AdressFragmentDoc}
${PhoneNumberFragmentDoc}`;

/**
 * __usePrivateQuery__
 *
 * To run a query within a React component, call `usePrivateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivateQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivateQuery(baseOptions?: Apollo.QueryHookOptions<PrivateQuery, PrivateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivateQuery, PrivateQueryVariables>(PrivateDocument, options);
      }
export function usePrivateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivateQuery, PrivateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivateQuery, PrivateQueryVariables>(PrivateDocument, options);
        }
export type PrivateQueryHookResult = ReturnType<typeof usePrivateQuery>;
export type PrivateLazyQueryHookResult = ReturnType<typeof usePrivateLazyQuery>;
export type PrivateQueryResult = Apollo.QueryResult<PrivateQuery, PrivateQueryVariables>;
export const UpdateAvatarUrlDocument = gql`
    mutation UpdateAvatarURL($avatar_url: String!) {
  update_users(_set: {avatar_url: $avatar_url}, where: {}) {
    affected_rows
  }
}
    `;
export type UpdateAvatarUrlMutationFn = Apollo.MutationFunction<UpdateAvatarUrlMutation, UpdateAvatarUrlMutationVariables>;

/**
 * __useUpdateAvatarUrlMutation__
 *
 * To run a mutation, you first call `useUpdateAvatarUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAvatarUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAvatarUrlMutation, { data, loading, error }] = useUpdateAvatarUrlMutation({
 *   variables: {
 *      avatar_url: // value for 'avatar_url'
 *   },
 * });
 */
export function useUpdateAvatarUrlMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAvatarUrlMutation, UpdateAvatarUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAvatarUrlMutation, UpdateAvatarUrlMutationVariables>(UpdateAvatarUrlDocument, options);
      }
export type UpdateAvatarUrlMutationHookResult = ReturnType<typeof useUpdateAvatarUrlMutation>;
export type UpdateAvatarUrlMutationResult = Apollo.MutationResult<UpdateAvatarUrlMutation>;
export type UpdateAvatarUrlMutationOptions = Apollo.BaseMutationOptions<UpdateAvatarUrlMutation, UpdateAvatarUrlMutationVariables>;
export const UpsertPrivateDocument = gql`
    mutation UpsertPrivate($user: users_set_input!, $adress: private_adresses_insert_input!, $phone_number: private_phone_numbers_insert_input!) {
  update_users(_set: $user, where: {}) {
    returning {
      first_name
      last_name
    }
  }
  insert_private_adresses_one(
    object: $adress
    on_conflict: {constraint: adresses_pkey, update_columns: [city, country, postal_code, street, area]}
  ) {
    id
  }
  insert_private_phone_numbers_one(
    object: $phone_number
    on_conflict: {constraint: phone_numbers_pkey, update_columns: [number, country_code]}
  ) {
    id
  }
}
    `;
export type UpsertPrivateMutationFn = Apollo.MutationFunction<UpsertPrivateMutation, UpsertPrivateMutationVariables>;

/**
 * __useUpsertPrivateMutation__
 *
 * To run a mutation, you first call `useUpsertPrivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPrivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPrivateMutation, { data, loading, error }] = useUpsertPrivateMutation({
 *   variables: {
 *      user: // value for 'user'
 *      adress: // value for 'adress'
 *      phone_number: // value for 'phone_number'
 *   },
 * });
 */
export function useUpsertPrivateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPrivateMutation, UpsertPrivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPrivateMutation, UpsertPrivateMutationVariables>(UpsertPrivateDocument, options);
      }
export type UpsertPrivateMutationHookResult = ReturnType<typeof useUpsertPrivateMutation>;
export type UpsertPrivateMutationResult = Apollo.MutationResult<UpsertPrivateMutation>;
export type UpsertPrivateMutationOptions = Apollo.BaseMutationOptions<UpsertPrivateMutation, UpsertPrivateMutationVariables>;
export const YearsDocument = gql`
    query Years {
  years {
    ...Year
  }
}
    ${YearFragmentDoc}`;

/**
 * __useYearsQuery__
 *
 * To run a query within a React component, call `useYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useYearsQuery(baseOptions?: Apollo.QueryHookOptions<YearsQuery, YearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YearsQuery, YearsQueryVariables>(YearsDocument, options);
      }
export function useYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YearsQuery, YearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YearsQuery, YearsQueryVariables>(YearsDocument, options);
        }
export type YearsQueryHookResult = ReturnType<typeof useYearsQuery>;
export type YearsLazyQueryHookResult = ReturnType<typeof useYearsLazyQuery>;
export type YearsQueryResult = Apollo.QueryResult<YearsQuery, YearsQueryVariables>;